export const ListProject = [
  {
    "key": "1",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "アーバンネット札幌ビル",
    "内閣府No": "1",
    "内閣府プロジェクト名": "アーバンネット札幌ビル",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "-",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ＮＴＴ都市開発",
    "事業期間（年度）": "H15-16",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "2",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大通交流拠点-札幌大通西４ビル",
    "内閣府No": "2",
    "内閣府プロジェクト名": "大通交流拠点-札幌大通西４ビル",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "②",
    "特定地域整備計画名": "大通交流拠点（札幌大通西４ビル）",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "石屋製菓、秋田銀行、秋田共立",
    "事業期間（年度）": "H23-24",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "3",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大通交流拠点-明治安田生命札幌大通ビル",
    "内閣府No": "3",
    "内閣府プロジェクト名": "大通交流拠点-明治安田生命札幌大通ビル",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "-",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "明治安田生命保険",
    "事業期間（年度）": "H25-26",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "4",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "北５西５街区整備事業",
    "内閣府No": "4",
    "内閣府プロジェクト名": "北５西５街区整備事業",
    "内閣府プロジェクト名２": "sapporo55",
    "特定地域整備計画No": "-",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "竹中工務店",
    "事業期間（年度）": "H16",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "5",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "北３東１１周辺地区第一種市街地再開発事業",
    "内閣府No": "5",
    "内閣府プロジェクト名": "北３東１１周辺地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "プレミストタワーズ札幌苗穂AQUAGATE、苗穂ヒラクスWEST、真照寺、北3東10ビル",
    "特定地域整備計画No": "-",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H30-R4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "6",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "北２西３北地区優良建築物等整備事業",
    "内閣府No": "6",
    "内閣府プロジェクト名": "北２西３北地区優良建築物等整備事業",
    "内閣府プロジェクト名２": "札幌フコク生命越山ビル、sitatte sapporo",
    "特定地域整備計画No": "-",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "富国生命保険、越山ビルディングズ",
    "事業期間（年度）": "H27-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "7",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "北２西４地区",
    "内閣府No": "7",
    "内閣府プロジェクト名": "北２西４地区",
    "内閣府プロジェクト名２": "札幌三井ＪＰビルディング",
    "特定地域整備計画No": "①",
    "特定地域整備計画名": "北２西４地区",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "三井不動産、郵便局",
    "事業期間（年度）": "H24-26",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "8",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "北８西１地区第一種市街地再開発事業",
    "内閣府No": "8",
    "内閣府プロジェクト名": "北８西１地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "ONE札幌ステーションタワー",
    "特定地域整備計画No": "-",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "R2-5",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "9",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "北８西３西地区第一種市街地再開発事業",
    "内閣府No": "9",
    "内閣府プロジェクト名": "北８西３西地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "札幌エルプラザ",
    "特定地域整備計画No": "-",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "個人施行者",
    "事業期間（年度）": "H13-14",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "10",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "北８西３東地区第一種市街地再開発事業",
    "内閣府No": "10",
    "内閣府プロジェクト名": "北８西３東地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "D’ｸﾞﾗﾌｫｰﾄ札幌ｽﾃｰｼｮﾝﾀﾜｰ、北ビル",
    "特定地域整備計画No": "-",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H16-18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "11",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "北４東６周辺地区第一種市街地再開発事業",
    "内閣府No": "11",
    "内閣府プロジェクト名": "北４東６周辺地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "ザ・タワーズフロンティア札幌、札幌市中央体育館（北ガスアリーナ札幌46）、VitPark札幌47",
    "特定地域整備計画No": "-",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H28-R3",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "12",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "札幌創世1.1.1区北１西１地区第一種市街地再開発事業",
    "内閣府No": "12",
    "内閣府プロジェクト名": "札幌創世1.1.1区北１西１地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "札幌創世スクエア",
    "特定地域整備計画No": "③",
    "特定地域整備計画名": "札幌創世1.1.1 区 北１西１地区第一種市街地再開発事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H26-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "13",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "日本生命札幌ビル",
    "内閣府No": "13",
    "内閣府プロジェクト名": "日本生命札幌ビル",
    "内閣府プロジェクト名２": "NOASIS3.4",
    "特定地域整備計画No": "-",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "日本生命保険",
    "事業期間（年度）": "H16-21",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "14",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "北洋大通センター",
    "内閣府No": "14",
    "内閣府プロジェクト名": "北洋大通センター",
    "内閣府プロジェクト名２": "大通ビッセ",
    "特定地域整備計画No": "-",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "北洋銀行、交洋不動産",
    "事業期間（年度）": "H19-21",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "15",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "南２西３南西地区第一種市街地再開発事業",
    "内閣府No": "15",
    "内閣府プロジェクト名": "南２西３南西地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "moyuk SAPPORO",
    "特定地域整備計画No": "-",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "R1-5",
    "状況": "事業中",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "16",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "北３西３南地区優良建築物等整備事業",
    "内閣府No": "16",
    "内閣府プロジェクト名": "北３西３南地区優良建築物等整備事業",
    "内閣府プロジェクト名２": "大同生命札幌ビル、miredo",
    "特定地域整備計画No": "-",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "大同生命保険",
    "事業期間（年度）": "H30-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "17",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "苗穂駅北口西地区優良建築物等整備事業",
    "内閣府No": "17",
    "内閣府プロジェクト名": "苗穂駅北口西地区優良建築物等整備事業",
    "内閣府プロジェクト名２": "ザ・グランアルト札幌苗穂ステーションタワー、苗穂駅前北口ビル",
    "特定地域整備計画No": "-",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "大京、住友不動産、北海道旅客鉄道",
    "事業期間（年度）": "H30-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "18",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "北４西３地区第一種市街地再開発事業",
    "内閣府No": "19",
    "内閣府プロジェクト名": "北４西３地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "④",
    "特定地域整備計画名": "北4 西 3 地区第一種市街地再開発事業",
    "補助金・交付金等": "道都札幌にふさわしい活気に満ちあふれた魅力ある都心の実現（北４西３地区）",
    "その他": "",
    "実施主体": "再開発組合（予定）",
    "事業期間（年度）": "R5-10",
    "状況": "事業中",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "●",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "19",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "北5 西 1 ・西 2 地区第一種市街地再開発事業",
    "内閣府No": "",
    "内閣府プロジェクト名": "",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "⑤",
    "特定地域整備計画名": "北5 西 1 ・西 2 地区第一種市街地再開発事業",
    "補助金・交付金等": "道都札幌にふさわしい活気に満ちあふれた魅力ある都心の実現（北5 西 1 ・西 2 地区）",
    "その他": "",
    "実施主体": "再開発組合（予定）",
    "事業期間（年度）": "R5-10",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "●",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "20",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大通西４南地区第一種市街地再開発事業",
    "内閣府No": "",
    "内閣府プロジェクト名": "",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "⑥",
    "特定地域整備計画名": "大通西４南地区第一種市街地再開発事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合（予定）",
    "事業期間（年度）": "R5-10",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "21",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "アクセス道路",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "アクセス道路",
    "内閣府プロジェクト名２": "苗穂駅北通",
    "特定地域整備計画No": "○ク",
    "特定地域整備計画名": "苗穂駅周辺地区整備事業（道路）",
    "補助金・交付金等": "７・４・４１ 苗穂駅北通",
    "その他": "",
    "実施主体": "札幌市",
    "事業期間（年度）": "H29-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "22",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "エネルギーネットワーク",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "エネルギーネットワーク",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "-",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H28-29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "23",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "エネルギーネットワーク収容施設",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "エネルギーネットワーク収容施設",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "-",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H17-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "24",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "大通交流拠点地下広場",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "大通交流拠点地下広場",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○ウ",
    "特定地域整備計画名": "大通交流拠点地下広場整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "札幌市",
    "事業期間（年度）": "H25-27",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "25",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "北３条広場",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "北３条広場",
    "内閣府プロジェクト名２": "アカプラ",
    "特定地域整備計画No": "○ア",
    "特定地域整備計画名": "北３条広場整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "三井不動産、日本郵便",
    "事業期間（年度）": "H25-26",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "26",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "46エネルギーセンター",
    "内閣府No": "カ",
    "内閣府プロジェクト名": "46エネルギーセンター",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "-",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H29-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "27",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "札幌駅前通公共地下歩道及び地下鉄さっぽろ駅東豊線連絡通路改修事業",
    "内閣府No": "キ",
    "内閣府プロジェクト名": "札幌駅前通公共地下歩道及び地下鉄さっぽろ駅東豊線連絡通路改修事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○サ",
    "特定地域整備計画名": "札幌駅前通公共地下歩道及び地下鉄さっぽろ駅東豊線連絡通路改修事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "札幌市",
    "事業期間（年度）": "H28-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "28",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "札幌駅前通地下歩行空間",
    "内閣府No": "ク",
    "内閣府プロジェクト名": "札幌駅前通地下歩行空間",
    "内閣府プロジェクト名２": "チカホ",
    "特定地域整備計画No": "-",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H17-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "29",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "市民交流プラザ",
    "内閣府No": "ケ",
    "内閣府プロジェクト名": "市民交流プラザ",
    "内閣府プロジェクト名２": "札幌市民交流プラザ",
    "特定地域整備計画No": "○エ",
    "特定地域整備計画名": "市民交流複合施設整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "札幌市",
    "事業期間（年度）": "H26-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "30",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "創世エネルギーセンター",
    "内閣府No": "コ",
    "内閣府プロジェクト名": "創世エネルギーセンター",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "-",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H27-29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "31",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "創成川通アンダーパス連続化",
    "内閣府No": "サ",
    "内閣府プロジェクト名": "創成川通アンダーパス連続化",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "-",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H17-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "32",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "創成川通親水空間",
    "内閣府No": "シ",
    "内閣府プロジェクト名": "創成川通親水空間",
    "内閣府プロジェクト名２": "創成川公園",
    "特定地域整備計画No": "-",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H17-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "33",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "札幌市中央体育館",
    "内閣府No": "ス",
    "内閣府プロジェクト名": "札幌市中央体育館",
    "内閣府プロジェクト名２": "北ガスアリーナ札幌46",
    "特定地域整備計画No": "○キ",
    "特定地域整備計画名": "中央体育館整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "札幌市",
    "事業期間（年度）": "H28-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "34",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "苗穂駅移転・橋上化",
    "内閣府No": "セ",
    "内閣府プロジェクト名": "苗穂駅移転・橋上化",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○ケ",
    "特定地域整備計画名": "苗穂駅周辺地区まちづくり事業（鉄道施設）",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "札幌市",
    "事業期間（年度）": "H25-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "35",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "苗穂駅南北自由通路",
    "内閣府No": "ソ",
    "内閣府プロジェクト名": "苗穂駅南北自由通路",
    "内閣府プロジェクト名２": "苗穂駅前広場連絡歩道",
    "特定地域整備計画No": "○ク",
    "特定地域整備計画名": "苗穂駅周辺地区整備事業（道路）",
    "補助金・交付金等": "８・７・３８ 苗穂駅前広場連絡歩道",
    "その他": "",
    "実施主体": "札幌市",
    "事業期間（年度）": "H28-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "36",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "苗穂駅南口・北口駅前広場",
    "内閣府No": "タ",
    "内閣府プロジェクト名": "苗穂駅南口・北口駅前広場",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○ク",
    "特定地域整備計画名": "苗穂駅周辺地区整備事業（道路）",
    "補助金・交付金等": "８・７・３８ 苗穂駅前広場連絡歩道",
    "その他": "",
    "実施主体": "札幌市",
    "事業期間（年度）": "H28-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "37",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "西２丁目地下歩道",
    "内閣府No": "チ",
    "内閣府プロジェクト名": "西２丁目地下歩道",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○オ",
    "特定地域整備計画名": "西２丁目線地下歩道整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "札幌市",
    "事業期間（年度）": "H27-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "38",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "ネットワーク道路",
    "内閣府No": "ツ",
    "内閣府プロジェクト名": "ネットワーク道路",
    "内閣府プロジェクト名２": "苗穂駅連絡通",
    "特定地域整備計画No": "○ク",
    "特定地域整備計画名": "苗穂駅周辺地区整備事業（道路）",
    "補助金・交付金等": "７・４・４０苗穂駅連絡通、３・３・３ 北３条通、３・４・２８ 東８丁目・篠路通",
    "その他": "",
    "実施主体": "札幌市",
    "事業期間（年度）": "H29-R4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "39",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "路面電車のループ化",
    "内閣府No": "テ",
    "内閣府プロジェクト名": "路面電車のループ化",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○カ",
    "特定地域整備計画名": "路面電車ループ化整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "札幌市",
    "事業期間（年度）": "H24-27",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "40",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "地下通路（都市高速鉄道（東豊線））",
    "内閣府No": "ナ",
    "内閣府プロジェクト名": "地下通路（都市高速鉄道（東豊線））",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "-",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R3-4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "41",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "北２西４周辺地区地域冷暖房施設整備事業",
    "内閣府No": "",
    "内閣府プロジェクト名": "",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○イ",
    "特定地域整備計画名": "北２西４周辺地区地域冷暖房施設整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "北海道熱供給公社",
    "事業期間（年度）": "H24-26",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "42",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "札幌市北１西１周辺街区自立・分散型エネルギー供給施設整備事業",
    "内閣府No": "",
    "内閣府プロジェクト名": "",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○コ",
    "特定地域整備計画名": "札幌市北１西１周辺街区自立・分散型エネルギー供給施設整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "北海道熱供給公社",
    "事業期間（年度）": "H27-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "43",
    "地域No": "01",
    "地域名": "【特定】札幌都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "札幌駅バスターミナル整備事業",
    "内閣府No": "",
    "内閣府プロジェクト名": "",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○シ",
    "特定地域整備計画名": "札幌駅バスターミナル整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "北海道旅客鉄道（予定）",
    "事業期間（年度）": "R5-10",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "44",
    "地域No": "02",
    "地域名": "【特定】仙台都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "中央一丁目第二地区第一種市街地再開発事業",
    "内閣府No": "1",
    "内閣府プロジェクト名": "中央一丁目第二地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "仙台マークワン",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H18-20",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "45",
    "地域No": "02",
    "地域名": "【特定】仙台都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "花京院一丁目第一地区第一種市街地再開発事業",
    "内閣府No": "2",
    "内閣府プロジェクト名": "花京院一丁目第一地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "ソララプラザ・ソララガーデン",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H19-21",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "46",
    "地域No": "02",
    "地域名": "【特定】仙台都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "中央南地区市街地再開発事業",
    "内閣府No": "3",
    "内閣府プロジェクト名": "中央南地区市街地再開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合（予定）",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "47",
    "地域No": "02",
    "地域名": "【特定】仙台都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "一番町二丁目四番地区第一種市街地再開発事業",
    "内閣府No": "4",
    "内閣府プロジェクト名": "一番町二丁目四番地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "THE SENDAI TOWER",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H23-26",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "48",
    "地域No": "02",
    "地域名": "【特定】仙台都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "一番町三丁目南地区",
    "内閣府No": "5",
    "内閣府プロジェクト名": "一番町三丁目南地区",
    "内閣府プロジェクト名２": "仙台ファーストタワー",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "特定目的会社",
    "事業期間（年度）": "H17-21",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "49",
    "地域No": "02",
    "地域名": "【特定】仙台都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "中央一丁目広瀬通地区",
    "内閣府No": "6",
    "内閣府プロジェクト名": "中央一丁目広瀬通地区",
    "内閣府プロジェクト名２": "東京建物仙台ビル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "特定目的会社",
    "事業期間（年度）": "H20-21",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "50",
    "地域No": "02",
    "地域名": "【特定】仙台都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "中央四丁目東二番丁通地区",
    "内閣府No": "7",
    "内閣府プロジェクト名": "中央四丁目東二番丁通地区",
    "内閣府プロジェクト名２": "アーバンネット仙台中央ビル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "NTT東日本、NTT都市開発",
    "事業期間（年度）": "R3-5",
    "状況": "事業中",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "51",
    "地域No": "02",
    "地域名": "【特定】仙台都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）一番町三丁目第一地区",
    "内閣府No": "8",
    "内閣府プロジェクト名": "（仮称）一番町三丁目第一地区",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "52",
    "地域No": "02",
    "地域名": "【特定】仙台都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）ヨドバシ一体開発（第一ビル・第二ビル）計画",
    "内閣府No": "9",
    "内閣府プロジェクト名": "（仮称）ヨドバシ一体開発（第一ビル・第二ビル）計画",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ヨドバシホールディングス",
    "事業期間（年度）": "R3-5",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "●",
    "税制支援（都市再生）": "●",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "53",
    "地域No": "02",
    "地域名": "【特定】仙台都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）中央一丁目10番地区",
    "内閣府No": "10",
    "内閣府プロジェクト名": "（仮称）中央一丁目10番地区",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "●",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "54",
    "地域No": "02",
    "地域名": "【特定】仙台都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）NTT青葉通ビル建替計画",
    "内閣府No": "11",
    "内閣府プロジェクト名": "（仮称）NTT青葉通ビル建替計画",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "NTT東日本、NTT都市開発",
    "事業期間（年度）": "R7-9",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "55",
    "地域No": "02",
    "地域名": "【特定】仙台都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）東邦銀行仙台支店建替え計画",
    "内閣府No": "12",
    "内閣府プロジェクト名": "（仮称）東邦銀行仙台支店建替え計画",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東邦銀行",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "56",
    "地域No": "02",
    "地域名": "【特定】仙台都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "愛宕上杉通植栽整備",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "愛宕上杉通植栽整備",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "仙台市",
    "事業期間（年度）": "H18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "57",
    "地域No": "02",
    "地域名": "【特定】仙台都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "都市計画道路元寺小路福室線",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "都市計画道路元寺小路福室線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H19-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "58",
    "地域No": "02",
    "地域名": "【特定】仙台都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "仙台駅北部東西自由通路整備",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "仙台駅北部東西自由通路整備",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H19-20",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "59",
    "地域No": "02",
    "地域名": "【特定】仙台都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "地下鉄東西線整備",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "地下鉄東西線整備",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H15-27",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "60",
    "地域No": "02",
    "地域名": "【特定】仙台都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "仙台駅東西自由通路整備",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "仙台駅東西自由通路整備",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H19-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "61",
    "地域No": "02",
    "地域名": "【特定】仙台都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "青葉通再整備",
    "内閣府No": "カ",
    "内閣府プロジェクト名": "青葉通再整備",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H18-未定",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "●",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "●",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "62",
    "地域No": "02",
    "地域名": "【特定】仙台都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "仙台駅西口駅前広場再整備",
    "内閣府No": "キ",
    "内閣府プロジェクト名": "仙台駅西口駅前広場再整備",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H26-未定",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "●",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "63",
    "地域No": "02",
    "地域名": "【特定】仙台都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "仙台市役所本庁舎建替え",
    "内閣府No": "ク",
    "内閣府プロジェクト名": "仙台市役所本庁舎建替え",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R6-9",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "●（社会実験）",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "64",
    "地域No": "02",
    "地域名": "【特定】仙台都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "勾当台公園再整備事業",
    "内閣府No": "ケ",
    "内閣府プロジェクト名": "勾当台公園再整備事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R7-12",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "65",
    "地域No": "02",
    "地域名": "【特定】仙台都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "定禅寺通再整備",
    "内閣府No": "コ",
    "内閣府プロジェクト名": "定禅寺通再整備",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "●",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "66",
    "地域No": "02",
    "地域名": "【特定】仙台都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "無電柱化事業（東八番丁小田原（その１）線外２線）",
    "内閣府No": "サ",
    "内閣府プロジェクト名": "無電柱化事業（東八番丁小田原（その１）線外２線）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "●",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "67",
    "地域No": "02",
    "地域名": "【特定】仙台都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "無電柱化事業（青葉山線）",
    "内閣府No": "シ",
    "内閣府プロジェクト名": "無電柱化事業（青葉山線）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "●",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "68",
    "地域No": "02",
    "地域名": "【特定】仙台都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "仙台駅西口地区下水道浸水被害軽減総合事業",
    "内閣府No": "ス",
    "内閣府プロジェクト名": "仙台駅西口地区下水道浸水被害軽減総合事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R1-7",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "69",
    "地域No": "03",
    "地域名": "大宮駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大宮駅東口大門町２丁目中地区第一種市街地再開発事業",
    "内閣府No": "1",
    "内閣府プロジェクト名": "大宮駅東口大門町２丁目中地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "大宮門街",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H29-R3",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "70",
    "地域No": "03",
    "地域名": "大宮駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大宮駅西口第四土地区画整理事業",
    "内閣府No": "2",
    "内閣府プロジェクト名": "大宮駅西口第四土地区画整理事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "さいたま市",
    "事業期間（年度）": "H7-R6",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "●",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "71",
    "地域No": "03",
    "地域名": "大宮駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大宮駅西口第３－Ｂ地区第一種市街地再開発事業",
    "内閣府No": "3",
    "内閣府プロジェクト名": "大宮駅西口第３－Ｂ地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "大宮サクラスクエア",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "R2-6",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "●",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "●（L街）",
    "都市・地域交通戦略推進事業": "",
    "その他支援": "防災・省エネまちづくり緊急促進事業"
  },
  {
    "key": "72",
    "地域No": "03",
    "地域名": "大宮駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大宮鐘塚C地区第一種市街地再開発事業",
    "内閣府No": "4",
    "内閣府プロジェクト名": "大宮鐘塚C地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "武蔵野銀行本店ビル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "武蔵野銀行",
    "事業期間（年度）": "R1-3",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "73",
    "地域No": "03",
    "地域名": "大宮駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "氷川緑道西通線整備",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "氷川緑道西通線整備",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H26-R8",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "●（街路事業整備済み、無電柱実施中）",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "74",
    "地域No": "03",
    "地域名": "大宮駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "大宮区役所新庁舎整備",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "大宮区役所新庁舎整備",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H29-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "75",
    "地域No": "03",
    "地域名": "大宮駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "桜木１号線・桜木２号線",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "桜木１号線・桜木２号線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R7-8",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "●（L街、S街）",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "76",
    "地域No": "03",
    "地域名": "大宮駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "上落合桜木線",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "上落合桜木線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R4-6",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "●",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "77",
    "地域No": "04",
    "地域名": "さいたま新都心駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ＪＲホテル整備事業",
    "内閣府No": "1",
    "内閣府プロジェクト名": "ＪＲホテル整備事業",
    "内閣府プロジェクト名２": "JRさいたま新都心ビル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東日本旅客鉄道",
    "事業期間（年度）": "H27-29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "78",
    "地域No": "04",
    "地域名": "さいたま新都心駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "１街区整備事業",
    "内閣府No": "2",
    "内閣府プロジェクト名": "１街区整備事業",
    "内閣府プロジェクト名２": "クラリオン株式会社本社・技術センター",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "クラリオン",
    "事業期間（年度）": "H18-19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "79",
    "地域No": "04",
    "地域名": "さいたま新都心駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "片倉街区整備事業",
    "内閣府No": "3",
    "内閣府プロジェクト名": "片倉街区整備事業",
    "内閣府プロジェクト名２": "コクーン新都心（現 コクーン１）",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "片倉工業",
    "事業期間（年度）": "H15-16",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "80",
    "地域No": "04",
    "地域名": "さいたま新都心駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "南側中核施設群整備事業",
    "内閣府No": "4",
    "内閣府プロジェクト名": "南側中核施設群整備事業",
    "内閣府プロジェクト名２": "さいたま赤十字病院・埼玉県立小児医療センター",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "日本赤十字社、埼玉県",
    "事業期間（年度）": "H25-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "81",
    "地域No": "04",
    "地域名": "さいたま新都心駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "自由通路",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "自由通路",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H6-27",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "82",
    "地域No": "04",
    "地域名": "さいたま新都心駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "地域冷暖房施設",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "地域冷暖房施設",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H9-12",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "83",
    "地域No": "05",
    "地域名": "川口駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "川口１丁目１番第一種市街地再開発事業",
    "内閣府No": "1",
    "内閣府プロジェクト名": "川口１丁目１番第一種市街地再開発事業",
    "内閣府プロジェクト名２": "キュポ・ラ、オーベルタワー川口コラージュ、シティー",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H15-17",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "84",
    "地域No": "05",
    "地域名": "川口駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "川口１丁目２番地区住宅市街地総合整備事業",
    "内閣府No": "2",
    "内閣府プロジェクト名": "川口１丁目２番地区住宅市街地総合整備事業",
    "内閣府プロジェクト名２": "リビオタワー川口ミ・ド・リ・ノ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "共同ビル建設組合",
    "事業期間（年度）": "H15-17",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "85",
    "地域No": "05",
    "地域名": "川口駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "飯塚２丁目第２地区住宅市街地総合整備事業",
    "内閣府No": "3",
    "内閣府プロジェクト名": "飯塚２丁目第２地区住宅市街地総合整備事業",
    "内閣府プロジェクト名２": "ドリームタワーキュアレジデンス",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発ビル建設組合",
    "事業期間（年度）": "H16-18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "86",
    "地域No": "05",
    "地域名": "川口駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "飯塚２丁目第３地区住宅市街地総合整備事業",
    "内閣府No": "4",
    "内閣府プロジェクト名": "飯塚２丁目第３地区住宅市街地総合整備事業",
    "内閣府プロジェクト名２": "ソルクレスト川口ザ・タワー",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "共同施行者協議会",
    "事業期間（年度）": "H16-18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "87",
    "地域No": "05",
    "地域名": "川口駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "サッポロビール埼玉工場跡地開発事業",
    "内閣府No": "5",
    "内閣府プロジェクト名": "サッポロビール埼玉工場跡地開発事業",
    "内閣府プロジェクト名２": "リボンシティ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "イトーヨーカ堂、サッポロスポーツプラザ、東武鉄道、リクルートコスモス、川口コミュニティー開発、市、UR",
    "事業期間（年度）": "H16-18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "88",
    "地域No": "05",
    "地域名": "川口駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "川口栄町３丁目銀座地区第一種市街地再開発事業",
    "内閣府No": "6",
    "内閣府プロジェクト名": "川口栄町３丁目銀座地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "プラウドタワー川口クロス",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "R1-4",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "89",
    "地域No": "05",
    "地域名": "川口駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "川口飯塚１丁目３番地区優良建築物等整備事業",
    "内閣府No": "7",
    "内閣府プロジェクト名": "川口飯塚１丁目３番地区優良建築物等整備事業",
    "内閣府プロジェクト名２": "プラウドタワー川口",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "野村不動産株式会社",
    "事業期間（年度）": "H29-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "90",
    "地域No": "05",
    "地域名": "川口駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "川口本町４丁目８番地区優良建築物等整備事業",
    "内閣府No": "8",
    "内閣府プロジェクト名": "川口本町４丁目８番地区優良建築物等整備事業",
    "内閣府プロジェクト名２": "ザ・パークハウス川口本町",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "共同ビル建設組合",
    "事業期間（年度）": "H30-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "91",
    "地域No": "05",
    "地域名": "川口駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "栄町３丁目１番地区",
    "内閣府No": "9",
    "内閣府プロジェクト名": "栄町３丁目１番地区",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "92",
    "地域No": "05",
    "地域名": "川口駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "川口都市計画公園事業3･3･22号並木元町公園（サッポビール埼玉工場跡地開発事業）",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "川口都市計画公園事業3･3･22号並木元町公園（サッポビール埼玉工場跡地開発事業）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "93",
    "地域No": "05",
    "地域名": "川口駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "環状八間通り線",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "環状八間通り線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H14-R8",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "94",
    "地域No": "05",
    "地域名": "川口駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "環状本町飯塚線",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "環状本町飯塚線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H8-R9",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "95",
    "地域No": "05",
    "地域名": "川口駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "駅前六間通り線",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "駅前六間通り線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H7-R6",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "●",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "96",
    "地域No": "05",
    "地域名": "川口駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "駅前大通り線",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "駅前大通り線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "97",
    "地域No": "05",
    "地域名": "川口駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "善光寺荒川線",
    "内閣府No": "カ",
    "内閣府プロジェクト名": "善光寺荒川線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "98",
    "地域No": "05",
    "地域名": "川口駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "ペデストリアンデッキ整備",
    "内閣府No": "キ",
    "内閣府プロジェクト名": "ペデストリアンデッキ整備",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "99",
    "地域No": "05",
    "地域名": "川口駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "川口駅東口公共広場",
    "内閣府No": "ク",
    "内閣府プロジェクト名": "川口駅東口公共広場",
    "内閣府プロジェクト名２": "キュポ・ラ広場",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "100",
    "地域No": "05",
    "地域名": "川口駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "駐車・駐輪場整備",
    "内閣府No": "ケ",
    "内閣府プロジェクト名": "駐車・駐輪場整備",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "101",
    "地域No": "05",
    "地域名": "川口駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "図書館",
    "内閣府No": "コ",
    "内閣府プロジェクト名": "図書館",
    "内閣府プロジェクト名２": "中央図書館・メディアセブン",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "102",
    "地域No": "06",
    "地域名": "千葉駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "千葉中央第六地区第一種市街地再開発事業",
    "内閣府No": "1",
    "内閣府プロジェクト名": "千葉中央第六地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "きぼーる",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H17-19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "103",
    "地域No": "06",
    "地域名": "千葉駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "千葉駅西口地区第二種市街地再開発事業",
    "内閣府No": "2",
    "内閣府プロジェクト名": "千葉駅西口地区第二種市街地再開発事業",
    "内閣府プロジェクト名２": "Ⅰ街区：ウェストリオ、Ⅱ街区：ウェストゲート千葉",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "千葉市",
    "事業期間（年度）": "H2-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "104",
    "地域No": "06",
    "地域名": "千葉駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "千葉駅東口地区第一種市街地再開発事業",
    "内閣府No": "3",
    "内閣府プロジェクト名": "千葉駅東口地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H28-R4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "105",
    "地域No": "06",
    "地域名": "千葉駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "千葉中央第三地区",
    "内閣府No": "4",
    "内閣府プロジェクト名": "千葉中央第三地区",
    "内閣府プロジェクト名２": "千葉セントラルタワー",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "オリックス・リアルエステート、ニチモ",
    "事業期間（年度）": "H18-20",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "106",
    "地域No": "06",
    "地域名": "千葉駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "千葉中央第五地区市街地再開発事業",
    "内閣府No": "5",
    "内閣府プロジェクト名": "千葉中央第五地区市街地再開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "107",
    "地域No": "06",
    "地域名": "千葉駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "新千葉一丁目地区市街地再開発事業",
    "内閣府No": "6",
    "内閣府プロジェクト名": "新千葉一丁目地区市街地再開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "108",
    "地域No": "06",
    "地域名": "千葉駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "新千葉二丁目地区市街地再開発事業",
    "内閣府No": "7",
    "内閣府プロジェクト名": "新千葉二丁目地区市街地再開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "109",
    "地域No": "06",
    "地域名": "千葉駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "新千葉２・３地区市街地再開発事業",
    "内閣府No": "8",
    "内閣府プロジェクト名": "新千葉２・３地区市街地再開発事業",
    "内閣府プロジェクト名２": "グラディス千葉駅前",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "R2-4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "110",
    "地域No": "06",
    "地域名": "千葉駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "富士見ハイネスビル",
    "内閣府No": "9",
    "内閣府プロジェクト名": "富士見ハイネスビル",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東電不動産",
    "事業期間（年度）": "H13-14",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "111",
    "地域No": "06",
    "地域名": "千葉駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "都市計画道路千葉港黒砂台線",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "都市計画道路千葉港黒砂台線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H1-25",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "112",
    "地域No": "06",
    "地域名": "千葉駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "千葉都市計画都市計画道路3.6.88千葉港黒砂台線",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "千葉都市計画都市計画道路3.6.88千葉港黒砂台線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H2-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "113",
    "地域No": "06",
    "地域名": "千葉駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "市道新千葉24.30.31.37.38.40号線",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "市道新千葉24.30.31.37.38.40号線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H2-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "114",
    "地域No": "06",
    "地域名": "千葉駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "新千葉公園",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "新千葉公園",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H2-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "115",
    "地域No": "06",
    "地域名": "千葉駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "千葉駅西口地区第二種市街地再開発事業内立体的歩道",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "千葉駅西口地区第二種市街地再開発事業内立体的歩道",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H2-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "116",
    "地域No": "07",
    "地域名": "松戸駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "【仮称】松戸市相模台地区土地区画整理事業",
    "内閣府No": "1",
    "内閣府プロジェクト名": "【仮称】松戸市相模台地区土地区画整理事業",
    "内閣府プロジェクト名２": "新拠点ゾーン",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "松戸市",
    "事業期間（年度）": "R4-9",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "117",
    "地域No": "07",
    "地域名": "松戸駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "松戸駅改良・駅ビル新設他",
    "内閣府No": "2",
    "内閣府プロジェクト名": "松戸駅改良・駅ビル新設他",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "JR東日本、新京成電鉄",
    "事業期間（年度）": "R1-9",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "118",
    "地域No": "07",
    "地域名": "松戸駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "【仮称】市役所機能再編整備計画",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "【仮称】市役所機能再編整備計画",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R7-9",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "119",
    "地域No": "07",
    "地域名": "松戸駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "松戸中央公園",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "松戸中央公園",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R7-10",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "120",
    "地域No": "07",
    "地域名": "松戸駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "相模台公園",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "相模台公園",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R7-10",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "121",
    "地域No": "07",
    "地域名": "松戸駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "ウォーカブルシティの推進",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "ウォーカブルシティの推進",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H13-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "122",
    "地域No": "08",
    "地域名": "柏駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "柏駅東口Ａ街区第二地区第一種市街地再開発事業",
    "内閣府No": "1",
    "内閣府プロジェクト名": "柏駅東口Ａ街区第二地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "ザ・カシワ・タワー",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H19-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "123",
    "地域No": "08",
    "地域名": "柏駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "柏駅東口Ｄ街区第一地区第一種市街地再開発事業",
    "内閣府No": "2",
    "内閣府プロジェクト名": "柏駅東口Ｄ街区第一地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "DayOneタワー，DayOneスクエア",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H25-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "124",
    "地域No": "08",
    "地域名": "柏駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "柏駅西口北地区市街地再開発事業",
    "内閣府No": "3",
    "内閣府プロジェクト名": "柏駅西口北地区市街地再開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "125",
    "地域No": "08",
    "地域名": "柏駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "都市計画道路７・５・３号元町通り線",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "都市計画道路７・５・３号元町通り線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H13-未定",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "126",
    "地域No": "08",
    "地域名": "柏駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "都市計画道路７・６・４号中通り線",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "都市計画道路７・６・４号中通り線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H13-未定",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "127",
    "地域No": "08",
    "地域名": "柏駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "都市計画道路７・６・２号南通り線",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "都市計画道路７・６・２号南通り線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H9-未定",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "128",
    "地域No": "08",
    "地域名": "柏駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "都市計画道路８・７・１号小柳町通り線",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "都市計画道路８・７・１号小柳町通り線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H9-未定",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "129",
    "地域No": "08",
    "地域名": "柏駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "都市計画道路３・３・２８号末広あけぼの線",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "都市計画道路３・３・２８号末広あけぼの線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H14-未定",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "130",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "丸の内一丁目1-12地区プロジェクト",
    "内閣府No": "1",
    "内閣府プロジェクト名": "丸の内一丁目1-12地区プロジェクト",
    "内閣府プロジェクト名２": "鉃鋼ビルディング",
    "特定地域整備計画No": "03-①",
    "特定地域整備計画名": "鉄鋼ビルディング",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "鉃鋼ビルディング",
    "事業期間（年度）": "H25-27",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "131",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "日本橋二丁目地区プロジェクト",
    "内閣府No": "2",
    "内閣府プロジェクト名": "日本橋二丁目地区プロジェクト",
    "内閣府プロジェクト名２": "Ａ街区：太陽生命日本橋ビル、B街区：日本橋髙島屋S.C.本館、Ｃ街区：日本橋髙島屋三井ビルディング、E街区：東京日本橋タワー",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合、住友不動産",
    "事業期間（年度）": "H24-R3",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "132",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "銀座六丁目１０地区第一種市街地再開発事業",
    "内閣府No": "3",
    "内閣府プロジェクト名": "銀座六丁目１０地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "GINZA　SIX",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H26-29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "133",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "六本木一丁目西地区（Ｂ－１地区）",
    "内閣府No": "4",
    "内閣府プロジェクト名": "六本木一丁目西地区（Ｂ－１地区）",
    "内閣府プロジェクト名２": "アークヒルズサウスタワー",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "森ビル",
    "事業期間（年度）": "H23-25",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "134",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "六本木五丁目西地区第一種市街地再開発事業",
    "内閣府No": "5",
    "内閣府プロジェクト名": "六本木五丁目西地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "未定",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合（予定）",
    "事業期間（年度）": "R7-12",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "135",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）豊洲二・三丁目地区２街区",
    "内閣府No": "6",
    "内閣府プロジェクト名": "（仮称）豊洲二・三丁目地区２街区",
    "内閣府プロジェクト名２": "豊洲ベイサイドクロス",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "江東区、三井不動産",
    "事業期間（年度）": "H24-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "136",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）豊洲３－２街区",
    "内閣府No": "7",
    "内閣府プロジェクト名": "（仮称）豊洲３－２街区",
    "内閣府プロジェクト名２": "芝浦工業大学中学校高等学校、テプコ豊洲ビル、パークアクシス豊洲キャナル、東京ワンダフルプロジェクトBAYZ TOWER＆GARDEN、東京ワンダフルプロジェクトSKYZ TOWER＆GARDEN",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東京電力、三井不動産レジデンシャル（住宅街区）ほか",
    "事業期間（年度）": "H22-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "137",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）有明北３－１街区",
    "内閣府No": "8",
    "内閣府プロジェクト名": "（仮称）有明北３－１街区",
    "内閣府プロジェクト名２": "シティタワーズ東京ベイ、有明ガーデン",
    "特定地域整備計画No": "05-①",
    "特定地域整備計画名": "\"臨海副都心有明北地区地区計画（3-1-A",
    "補助金・交付金等": "3-1-B",
    "その他": "3-1-C街区）\"",
    "実施主体": "",
    "事業期間（年度）": "",
    "状況": "住友不動産",
    "都市再生特別地区": "H28-R8",
    "民間都市再生事業計画認定": "事業中",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "138",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "丸の内三丁目10地区",
    "内閣府No": "9",
    "内閣府プロジェクト名": "丸の内三丁目10地区",
    "内閣府プロジェクト名２": "丸の内二重橋ビル",
    "特定地域整備計画No": "03-⑤",
    "特定地域整備計画名": "丸の内二重橋ビル",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "三菱地所、東京商工会議所、東京會舘",
    "事業期間（年度）": "H27-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "139",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "虎ノ門四丁目地区",
    "内閣府No": "10",
    "内閣府プロジェクト名": "虎ノ門四丁目地区",
    "内閣府プロジェクト名２": "東京ワールドゲート",
    "特定地域整備計画No": "01-⑥",
    "特定地域整備計画名": "（仮称）虎ノ門四丁目計画建設事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "森トラスト",
    "事業期間（年度）": "H28-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "140",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "都市再生ステップアッププロジェクト竹芝地区",
    "内閣府No": "11",
    "内閣府プロジェクト名": "都市再生ステップアッププロジェクト竹芝地区",
    "内閣府プロジェクト名２": "東京ポートシティ竹芝",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "アルベログランデ",
    "事業期間（年度）": "H28-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "141",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大手町連鎖型都市再生プロジェクト第３次事業",
    "内閣府No": "12",
    "内閣府プロジェクト名": "大手町連鎖型都市再生プロジェクト第３次事業",
    "内閣府プロジェクト名２": "大手町フィナンシャルシティ グランキューブ及び宿泊施設棟",
    "特定地域整備計画No": "03-③",
    "特定地域整備計画名": "大手町一丁目第3地区第一種市街地再開発事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "三菱地所",
    "事業期間（年度）": "H26-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "142",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大手町地区（B-3街区）",
    "内閣府No": "13",
    "内閣府プロジェクト名": "大手町地区（B-3街区）",
    "内閣府プロジェクト名２": "大手町プレイス",
    "特定地域整備計画No": "03-④",
    "特定地域整備計画名": "大手町二丁目地区第一種市街地再開発事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR、NTT都市開発",
    "事業期間（年度）": "H27-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "143",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大手町一丁目１地区",
    "内閣府No": "14",
    "内閣府プロジェクト名": "大手町一丁目１地区",
    "内閣府プロジェクト名２": "大手町ホトリアＡ棟：大手門タワー・ＪＸビル、Ｂ棟：大手町パークビルディング",
    "特定地域整備計画No": "03-②",
    "特定地域整備計画名": "大手町ホトリア",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "三菱地所、JXホールディングス、大手町デベロップメント",
    "事業期間（年度）": "H25-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "144",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大手町一丁目６地区",
    "内閣府No": "15",
    "内閣府プロジェクト名": "大手町一丁目６地区",
    "内閣府プロジェクト名２": "大手町タワー",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "みずほ信託銀行",
    "事業期間（年度）": "H21-26",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "145",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "日本橋室町東地区開発",
    "内閣府No": "16",
    "内閣府プロジェクト名": "日本橋室町東地区開発",
    "内閣府プロジェクト名２": "コレド室町、ユイト",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "三井不動産、野村不動産ほか",
    "事業期間（年度）": "H19-26",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "146",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "日本橋室町三丁目地区第一種市街地再開発事業",
    "内閣府No": "17",
    "内閣府プロジェクト名": "日本橋室町三丁目地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "日本橋室町三井タワー",
    "特定地域整備計画No": "04-①",
    "特定地域整備計画名": "日本橋室町三丁目地区第一種市街地再開発事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H27-31",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "147",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "京橋二丁目西地区第一種市街地再開発事業",
    "内閣府No": "18",
    "内閣府プロジェクト名": "京橋二丁目西地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "京橋エドグラン",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H25-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "148",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）新日比谷プロジェクト",
    "内閣府No": "19",
    "内閣府プロジェクト名": "（仮称）新日比谷プロジェクト",
    "内閣府プロジェクト名２": "東京ミッドタウン日比谷",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "三井不動産",
    "事業期間（年度）": "H27-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "149",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "環状第二号線新橋・虎ノ門地区第二種市街地再開発事業",
    "内閣府No": "20",
    "内閣府プロジェクト名": "環状第二号線新橋・虎ノ門地区第二種市街地再開発事業",
    "内閣府プロジェクト名２": "虎ノ門ヒルズ、新橋プラザビル、グランスイート虎ノ門",
    "特定地域整備計画No": "01-①",
    "特定地域整備計画名": "環状第二号線新橋・虎ノ門地区第二種市街地再開発事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東京都",
    "事業期間（年度）": "H17-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "150",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "虎ノ門一丁目地区",
    "内閣府No": "21",
    "内閣府プロジェクト名": "虎ノ門一丁目地区",
    "内閣府プロジェクト名２": "虎ノ門ヒルズ　ビジネスタワー",
    "特定地域整備計画No": "01-⑨",
    "特定地域整備計画名": "虎ノ門一丁目地区市街地再開発事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H29-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "151",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "虎ノ門二丁目地区",
    "内閣府No": "22",
    "内閣府プロジェクト名": "虎ノ門二丁目地区",
    "内閣府プロジェクト名２": "未定",
    "特定地域整備計画No": "01-④",
    "特定地域整備計画名": "虎ノ門二丁目地区市街地再開発事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR、国家公務員共済組合連合会",
    "事業期間（年度）": "H27-R10",
    "状況": "事業中",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "152",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "六本木三丁目東地区",
    "内閣府No": "23",
    "内閣府プロジェクト名": "六本木三丁目東地区",
    "内閣府プロジェクト名２": "住友不動産六本木グランドタワー【業務】、六本木グランドタワーレジデンス【住宅】、六本木グランドプラザ【商業】",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H25-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "153",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "月島一丁目３、４、５番地区第一種種市街地再開発",
    "内閣府No": "24",
    "内閣府プロジェクト名": "月島一丁目３、４、５番地区第一種種市街地再開発",
    "内閣府プロジェクト名２": "CAPITAL GATE PLACE",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H23-27",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "154",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "勝どき東地区第一種市街地再開発事業",
    "内閣府No": "25",
    "内閣府プロジェクト名": "勝どき東地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "A1棟：PARK TOWER KACHIDOKI SOUTHA、2棟：PARK TOWER KACHIDOKI MIDA、3棟：臨港消防署月島出張所、B棟：未定",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H30-R10",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "155",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "浜松町二丁目４地区　A街区",
    "内閣府No": "26",
    "内閣府プロジェクト名": "浜松町二丁目４地区　A街区",
    "内閣府プロジェクト名２": "未定",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "世界貿易センタービルディング、鹿島建設、東京モノレール、JR東日本",
    "事業期間（年度）": "H29-R9",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "●",
    "税制支援（都市再生）": "●",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "156",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "浜松町二丁目４地区　B街区",
    "内閣府No": "27",
    "内閣府プロジェクト名": "浜松町二丁目４地区　B街区",
    "内閣府プロジェクト名２": "日本生命浜松町クレアタワー",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "日本生命、大林組",
    "事業期間（年度）": "H27-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "157",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大手町一丁目２地区",
    "内閣府No": "28",
    "内閣府プロジェクト名": "大手町一丁目２地区",
    "内閣府プロジェクト名２": "Otemachi One",
    "特定地域整備計画No": "03-⑦",
    "特定地域整備計画名": "（仮称）OH-1計画",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "三井物産、三井不動産",
    "事業期間（年度）": "H28-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "158",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大手町二丁目常盤橋地区第一種市街地再開発プロジェクト",
    "内閣府No": "29",
    "内閣府プロジェクト名": "大手町二丁目常盤橋地区第一種市街地再開発プロジェクト",
    "内閣府プロジェクト名２": "常盤橋街区再開発プロジェクト",
    "特定地域整備計画No": "03-⑥",
    "特定地域整備計画名": "大手町二丁目常盤橋地区第一種市街地再開発事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "三菱地所",
    "事業期間（年度）": "H29-R9",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "●",
    "税制支援（都市再生）": "●",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "159",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "京橋トラストタワー新築事業",
    "内閣府No": "30",
    "内閣府プロジェクト名": "京橋トラストタワー新築事業",
    "内閣府プロジェクト名２": "京橋トラストタワー",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "森トラスト",
    "事業期間（年度）": "H23-25",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "160",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "京橋一丁目東地区",
    "内閣府No": "31",
    "内閣府プロジェクト名": "京橋一丁目東地区",
    "内閣府プロジェクト名２": "A街区：ミュージアムタワー京橋、Ｂ街区：未定、Ｃ街区：全国信用組合会館",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "永坂産業、戸田建設",
    "事業期間（年度）": "H28-R6",
    "状況": "事業中",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "161",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "八重洲二丁目１地区",
    "内閣府No": "32",
    "内閣府プロジェクト名": "八重洲二丁目１地区",
    "内閣府プロジェクト名２": "街区全体：東京ミッドタウン八重洲、A-1街区、A-2街区、B街区：未定",
    "特定地域整備計画No": "02-③",
    "特定地域整備計画名": "八重洲二丁目北地区第一種市街地再開発事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H30-R4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "162",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "東京駅前八重洲一丁目東地区第一種市街地再開発事業",
    "内閣府No": "33",
    "内閣府プロジェクト名": "東京駅前八重洲一丁目東地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "未定",
    "特定地域整備計画No": "02-①、②",
    "特定地域整備計画名": "（仮称）東京駅前八重洲一丁目東A 地区第一種市街地再開発事業、東京駅前八重洲一丁目東B地区第一種市街地再開発事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "R3-7",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "●",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "163",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "八重洲二丁目中地区第一種市街地再開発事業",
    "内閣府No": "34",
    "内閣府プロジェクト名": "八重洲二丁目中地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "未定",
    "特定地域整備計画No": "02-④",
    "特定地域整備計画名": "（仮称）八重洲二丁目中地区第一種市街地再開発事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "R6-10",
    "状況": "未着手",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "164",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）日本橋室町一丁目地区第一種市街地再開発事業",
    "内閣府No": "35",
    "内閣府プロジェクト名": "（仮称）日本橋室町一丁目地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "未定",
    "特定地域整備計画No": "04-②",
    "特定地域整備計画名": "日本橋室町一丁目地区第一種市街地再開発事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "R6-12",
    "状況": "未着手",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "165",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）虎ノ門２－10計画",
    "内閣府No": "36",
    "内閣府プロジェクト名": "（仮称）虎ノ門２－10計画",
    "内閣府プロジェクト名２": "ホテルオークラプレステージタワー、オークラヘリテージウイング",
    "特定地域整備計画No": "01-⑤",
    "特定地域整備計画名": "（仮称）虎ノ門２－10計画建設事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ホテルオークラ",
    "事業期間（年度）": "H28-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "166",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）芝公園１丁目ビル計画",
    "内閣府No": "37",
    "内閣府プロジェクト名": "（仮称）芝公園１丁目ビル計画",
    "内閣府プロジェクト名２": "住友不動産御成門タワー",
    "特定地域整備計画No": "01-⑫",
    "特定地域整備計画名": "（仮称）芝公園一丁目ビル計画建設事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "住友不動産",
    "事業期間（年度）": "H27-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "167",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "赤坂一丁目地区",
    "内閣府No": "38",
    "内閣府プロジェクト名": "赤坂一丁目地区",
    "内閣府プロジェクト名２": "赤坂インターシティＡＩＲ、赤坂AIRレジデンス",
    "特定地域整備計画No": "01-②",
    "特定地域整備計画名": "赤坂一丁目地区市街地再開発事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H26-29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "168",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "虎ノ門駅前地区",
    "内閣府No": "39",
    "内閣府プロジェクト名": "虎ノ門駅前地区",
    "内閣府プロジェクト名２": "東京虎ノ門グローバルスクエア",
    "特定地域整備計画No": "01-⑧",
    "特定地域整備計画名": "虎ノ門駅前地区市街地再開発事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H30-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "169",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "虎ノ門・麻布台地区",
    "内閣府No": "40",
    "内閣府プロジェクト名": "虎ノ門・麻布台地区",
    "内閣府プロジェクト名２": "未定",
    "特定地域整備計画No": "01-⑪",
    "特定地域整備計画名": "虎ノ門・麻布台地区市街地再開発事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "R1-4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "170",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "気象庁虎ノ門庁舎（仮称）・港区立教育センター整備等事業",
    "内閣府No": "41",
    "内閣府プロジェクト名": "気象庁虎ノ門庁舎（仮称）・港区立教育センター整備等事業",
    "内閣府プロジェクト名２": "気象庁・港区立教育センター",
    "特定地域整備計画No": "01-⑦",
    "特定地域整備計画名": "気象庁虎ノ門庁舎（仮称）・港区立教育センター整備等事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "鞆絵サイエンスパートナーズ",
    "事業期間（年度）": "H29-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "171",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "愛宕山周辺地区（I地区）",
    "内閣府No": "42",
    "内閣府プロジェクト名": "愛宕山周辺地区（I地区）",
    "内閣府プロジェクト名２": "虎ノ門ヒルズ レジデンシャルタワー",
    "特定地域整備計画No": "01-⑩",
    "特定地域整備計画名": "愛宕山周辺地区（I地区）開発事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "森ビル",
    "事業期間（年度）": "H28-R3",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "172",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）豊洲３－２街区ビル計画",
    "内閣府No": "43",
    "内閣府プロジェクト名": "（仮称）豊洲３－２街区ビル計画",
    "内閣府プロジェクト名２": "豊洲フォレシア",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "IHI、豊洲三丁目開発TMC",
    "事業期間（年度）": "H24-26",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "173",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）丸の内1-3計画",
    "内閣府No": "44",
    "内閣府プロジェクト名": "（仮称）丸の内1-3計画",
    "内閣府プロジェクト名２": "みずほ丸の内タワー、銀行会館、丸の内テラス",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "みずほフィナンシャルグループ、全国銀行協会、三菱地所",
    "事業期間（年度）": "H29-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "174",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "月島三丁目北地区第一種市街地再開発事業",
    "内閣府No": "61",
    "内閣府プロジェクト名": "月島三丁目北地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "未定",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "R4-8",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "175",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "勝どき五丁目地区第一種市街地再開発事業",
    "内閣府No": "62",
    "内閣府プロジェクト名": "勝どき五丁目地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "A：勝どきザ・リバーフロント、B-1：勝どきザ・タワー",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H24-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "176",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "芝浦一丁目地区",
    "内閣府No": "65",
    "内閣府プロジェクト名": "芝浦一丁目地区",
    "内閣府プロジェクト名２": "未定",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "野村不動産、JR東日本",
    "事業期間（年度）": "R3-12",
    "状況": "事業中",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "●",
    "税制支援（都市再生）": "●",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "177",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "湊二丁目東地区第一種市街地再開発事業",
    "内閣府No": "70",
    "内閣府プロジェクト名": "湊二丁目東地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "B街区：パークシティ中央湊 ザ タワー",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H26-29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "178",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "日本橋一丁目中地区",
    "内閣府No": "74",
    "内閣府プロジェクト名": "日本橋一丁目中地区",
    "内閣府プロジェクト名２": "未定",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合ほか",
    "事業期間（年度）": "R3-8",
    "状況": "事業中",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": "防災・省エネまちづくり緊急促進事業"
  },
  {
    "key": "179",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "虎ノ門一・二丁目地区（Ａ街区）",
    "内閣府No": "77",
    "内閣府プロジェクト名": "虎ノ門一・二丁目地区（Ａ街区）",
    "内閣府プロジェクト名２": "未定",
    "特定地域整備計画No": "01-⑭",
    "特定地域整備計画名": "虎ノ門一・二丁目地区市街地再開発事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "R1-5",
    "状況": "事業中",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": "防災・省エネまちづくり緊急促進事業"
  },
  {
    "key": "180",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "赤坂二丁目地区",
    "内閣府No": "78",
    "内閣府プロジェクト名": "赤坂二丁目地区",
    "内閣府プロジェクト名２": "未定",
    "特定地域整備計画No": "01-⑯",
    "特定地域整備計画名": "（仮称）赤坂二丁目計画建設事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "森トラスト",
    "事業期間（年度）": "R3-7",
    "状況": "事業中",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "●",
    "税制支援（都市再生）": "●",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "181",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "虎ノ門一・二丁目地区（Ｂ街区）",
    "内閣府No": "79",
    "内閣府プロジェクト名": "虎ノ門一・二丁目地区（Ｂ街区）",
    "内閣府プロジェクト名２": "T-LITE",
    "特定地域整備計画No": "01-⑬",
    "特定地域整備計画名": "（仮称）虎ノ門二丁目計画建設事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東洋海事工業",
    "事業期間（年度）": "R1-3",
    "状況": "事業中",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "182",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "八重洲一丁目北地区第一種市街地再開発事業",
    "内閣府No": "80",
    "内閣府プロジェクト名": "八重洲一丁目北地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "未定",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "R6-14",
    "状況": "未着手",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "183",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "日本橋一丁目東地区",
    "内閣府No": "82",
    "内閣府プロジェクト名": "日本橋一丁目東地区",
    "内閣府プロジェクト名２": "未定",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "R8-19",
    "状況": "未着手",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "184",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "日本橋兜町7地区開発計画",
    "内閣府No": "83",
    "内閣府プロジェクト名": "日本橋兜町7地区開発計画",
    "内閣府プロジェクト名２": "KABUTO　ONE",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "平和不動産、山種不動産、ちばぎん証券",
    "事業期間（年度）": "R1-3",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "185",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "月島三丁目南地区第一種市街地再開発事業",
    "内閣府No": "85",
    "内閣府プロジェクト名": "月島三丁目南地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "未定",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "R4-8",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "186",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "豊海地区第一種市街地再開発事業",
    "内閣府No": "86",
    "内閣府プロジェクト名": "豊海地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "未定",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "R4-8",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "187",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "\"（仮称）豊洲六丁目4-2",
    "内閣府No": "3街区プロジェクト\"",
    "内閣府プロジェクト名": "87",
    "内閣府プロジェクト名２": "\"（仮称）豊洲六丁目4-2",
    "特定地域整備計画No": "3街区プロジェクト\"",
    "特定地域整備計画名": "メブクス豊洲",
    "補助金・交付金等": "05-②",
    "その他": "\"（仮称）豊洲六丁目4-2",
    "実施主体": "3街区プロジェクト\"",
    "事業期間（年度）": "",
    "状況": "",
    "都市再生特別地区": "清水建設",
    "民間都市再生事業計画認定": "H31-R3",
    "税制支援（都市再生）": "完了",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "188",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "虎ノ門一丁目東地区",
    "内閣府No": "88",
    "内閣府プロジェクト名": "虎ノ門一丁目東地区",
    "内閣府プロジェクト名２": "未定",
    "特定地域整備計画No": "01-⑮",
    "特定地域整備計画名": "虎ノ門一丁目東地区市街地再開発事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合（予定）",
    "事業期間（年度）": "R5-8",
    "状況": "事業中",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "189",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）豊洲二・三丁目地区４－２街区開発計画",
    "内閣府No": "92",
    "内閣府プロジェクト名": "（仮称）豊洲二・三丁目地区４－２街区開発計画",
    "内閣府プロジェクト名２": "未定",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "三菱地所",
    "事業期間（年度）": "R4-7",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "●",
    "税制支援（都市再生）": "●",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "190",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "赤坂二・六丁目地区",
    "内閣府No": "99",
    "内閣府プロジェクト名": "赤坂二・六丁目地区",
    "内閣府プロジェクト名２": "未定",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "三菱地所、TBSホールディングス",
    "事業期間（年度）": "R6-10",
    "状況": "未着手",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "191",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "虎ノ門地区拠点整備事業",
    "内閣府No": "",
    "内閣府プロジェクト名": "",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "01-③",
    "特定地域整備計画名": "虎ノ門地区拠点整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "民間事業者、UR等",
    "事業期間（年度）": "H26-R9",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "192",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）愛宕地区市街地再開発事業",
    "内閣府No": "",
    "内閣府プロジェクト名": "",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "01-⑰",
    "特定地域整備計画名": "（仮称）愛宕地区市街地再開発事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR",
    "事業期間（年度）": "R4-13",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "●（L街）",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "193",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "東京駅丸の内側交通広場",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "東京駅丸の内側交通広場",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "03-○ア",
    "特定地域整備計画名": "東京都市計画道路事業補助線街路第９７号線及び東京都市計画道路事業補助線街路第９８号線",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H17-29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "194",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "地下東西自由通路等",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "地下東西自由通路等",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H17-29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "195",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "東京駅八重洲側交通広場",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "東京駅八重洲側交通広場",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H21-26",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "196",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "都市計画道路環状２号線",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "都市計画道路環状２号線",
    "内閣府プロジェクト名２": "新虎通り（新橋～虎ノ門）",
    "特定地域整備計画No": "01-○ア、○イ、○キ",
    "特定地域整備計画名": "環状第２号線（再開発）、環状第２号線（汐留）（街路）、環状第２号線（晴海）（街路）",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "",
    "状況": "",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "●",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "●",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "197",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "豊洲新中央卸売市場",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "豊洲新中央卸売市場",
    "内閣府プロジェクト名２": "東京都中央卸売市場 豊洲市場",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H23-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "198",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "八重洲バスターミナル",
    "内閣府No": "カ",
    "内閣府プロジェクト名": "八重洲バスターミナル",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "02-○ア、○イ、○ウ",
    "特定地域整備計画名": "（仮称）八重洲バスターミナル（Ａ）、（仮称）八重洲バスターミナル（Ｂ）、（仮称）八重洲バスターミナル（Ｃ）",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H30-R10",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "●",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "199",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "日本橋自立・分散型エネルギー供給施設整備事業",
    "内閣府No": "キ",
    "内閣府プロジェクト名": "日本橋自立・分散型エネルギー供給施設整備事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "04-ア",
    "特定地域整備計画名": "日本橋自立・分散型エネルギー供給施設整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "三井不動産TG スマートエナジー",
    "事業期間（年度）": "H28-31",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "200",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "日本橋地区都市再生事業（地下歩道整備）",
    "内閣府No": "ク",
    "内閣府プロジェクト名": "日本橋地区都市再生事業（地下歩道整備）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "04-イ",
    "特定地域整備計画名": "日本橋地区都市再生事業（地下歩道整備）",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "国土交通省（東京国道事務所）",
    "事業期間（年度）": "H28-R8",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "201",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "地下鉄日比谷線新駅整備事業",
    "内閣府No": "ケ",
    "内閣府プロジェクト名": "地下鉄日比谷線新駅整備事業",
    "内閣府プロジェクト名２": "未定",
    "特定地域整備計画No": "01-○ウ",
    "特定地域整備計画名": "地下鉄日比谷線新駅整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR",
    "事業期間（年度）": "H27-R5",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "●",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "202",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "虎ノ門周辺地区交通結節機能強化施設整備事業",
    "内閣府No": "",
    "内閣府プロジェクト名": "",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "01-○エ",
    "特定地域整備計画名": "虎ノ門周辺地区交通結節機能強化施設整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "民間事業者等",
    "事業期間（年度）": "H28-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "203",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "地下鉄虎ノ門駅・神谷町駅改良事業",
    "内閣府No": "",
    "内閣府プロジェクト名": "",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "01-○オ",
    "特定地域整備計画名": "地下鉄虎ノ門駅・神谷町駅改良事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東京地下鉄等",
    "事業期間（年度）": "H26-R4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "204",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "歩行者ネットワーク整備事業",
    "内閣府No": "",
    "内閣府プロジェクト名": "",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "01-○カ",
    "特定地域整備計画名": "歩行者ネットワーク整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "民間事業者等",
    "事業期間（年度）": "H24-R6",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "205",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "大手町土地区画整理事業",
    "内閣府No": "",
    "内閣府プロジェクト名": "",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "03-○イ",
    "特定地域整備計画名": "大手町土地区画整理事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR",
    "事業期間（年度）": "H18-R11",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "206",
    "地域No": "09",
    "地域名": "【特定】東京都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "臨海副都心有明北地区歩行者デッキ整備（3-1街区）",
    "内閣府No": "",
    "内閣府プロジェクト名": "",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "05-○ア",
    "特定地域整備計画名": "臨海副都心有明北地区歩行者デッキ整備（3-1街区）",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "住友不動産",
    "事業期間（年度）": "H28-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "207",
    "地域No": "10",
    "地域名": "秋葉原・神田地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "秋葉原地区開発計画（土地区画整理事業）",
    "内閣府No": "1",
    "内閣府プロジェクト名": "秋葉原地区開発計画（土地区画整理事業）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東京都",
    "事業期間（年度）": "H9-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "208",
    "地域No": "10",
    "地域名": "秋葉原・神田地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "秋葉原クロスフィールド（ＵＤＸビル）",
    "内閣府No": "1-1",
    "内閣府プロジェクト名": "秋葉原クロスフィールド（ＵＤＸビル）",
    "内閣府プロジェクト名２": "秋葉原UDXビル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "SPC",
    "事業期間（年度）": "H15-17",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "209",
    "地域No": "10",
    "地域名": "秋葉原・神田地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "秋葉原クロスフィールド（ダイビル）",
    "内閣府No": "1-2",
    "内閣府プロジェクト名": "秋葉原クロスフィールド（ダイビル）",
    "内閣府プロジェクト名２": "秋葉原ダイビル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ダイビル",
    "事業期間（年度）": "H15-16",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "210",
    "地域No": "10",
    "地域名": "秋葉原・神田地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "神田淡路町二丁目西部地区",
    "内閣府No": "2",
    "内閣府プロジェクト名": "神田淡路町二丁目西部地区",
    "内閣府プロジェクト名２": "WATERRAS",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H21-24",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "211",
    "地域No": "10",
    "地域名": "秋葉原・神田地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "神田駿河台三丁目９地区",
    "内閣府No": "3",
    "内閣府プロジェクト名": "神田駿河台三丁目９地区",
    "内閣府プロジェクト名２": "三井住友海上火災株式会社",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "三井住友海上火災保険",
    "事業期間（年度）": "H20-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "212",
    "地域No": "10",
    "地域名": "秋葉原・神田地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "神田駿河台四丁目６地区",
    "内閣府No": "4",
    "内閣府プロジェクト名": "神田駿河台四丁目６地区",
    "内閣府プロジェクト名２": "御茶ノ水ソラシティ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "SPC",
    "事業期間（年度）": "H22-24",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "213",
    "地域No": "10",
    "地域名": "秋葉原・神田地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "神田練塀町地区",
    "内閣府No": "5",
    "内閣府プロジェクト名": "神田練塀町地区",
    "内閣府プロジェクト名２": "住友不動産秋葉原駅前ビル・グランヴィスタ神田練塀町",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H29-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "214",
    "地域No": "10",
    "地域名": "秋葉原・神田地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "内神田一丁目地区",
    "内閣府No": "6",
    "内閣府プロジェクト名": "内神田一丁目地区",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "三菱地所",
    "事業期間（年度）": "R4-7",
    "状況": "事業中",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "●",
    "税制支援（都市再生）": "●",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "215",
    "地域No": "10",
    "地域名": "秋葉原・神田地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "交通広場",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "交通広場",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H13-17",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "216",
    "地域No": "10",
    "地域名": "秋葉原・神田地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "交通広場",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "交通広場",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H13-17",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "217",
    "地域No": "10",
    "地域名": "秋葉原・神田地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "屋外貫通通路",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "屋外貫通通路",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H15-17",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "218",
    "地域No": "10",
    "地域名": "秋葉原・神田地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "人工地盤上空地（歩行者デッキ）",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "人工地盤上空地（歩行者デッキ）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H15-17",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "219",
    "地域No": "10",
    "地域名": "秋葉原・神田地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "つくばエクスプレス",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "つくばエクスプレス",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H17開業",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "220",
    "地域No": "11",
    "地域名": "【特定】品川駅・田町駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）ＴＧＭＭ芝浦プロジェクト",
    "内閣府No": "1-1",
    "内閣府プロジェクト名": "（仮称）ＴＧＭＭ芝浦プロジェクト",
    "内閣府プロジェクト名２": "msbTamachi 田町ステーションタワーＳ他",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東京ガス不動産、三井不動産、三菱地所",
    "事業期間（年度）": "H27-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "221",
    "地域No": "11",
    "地域名": "【特定】品川駅・田町駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "田町駅前東口地区第一種市街地再開発事業",
    "内閣府No": "1-2",
    "内閣府プロジェクト名": "田町駅前東口地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "なぎさテラス/田町駅東口交番",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H28-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "222",
    "地域No": "11",
    "地域名": "【特定】品川駅・田町駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "三田三・四丁目地区",
    "内閣府No": "2",
    "内閣府プロジェクト名": "三田三・四丁目地区",
    "内閣府プロジェクト名２": "未定",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "R1-6",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "●",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "223",
    "地域No": "11",
    "地域名": "【特定】品川駅・田町駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "芝浦水再生センター地区",
    "内閣府No": "3",
    "内閣府プロジェクト名": "芝浦水再生センター地区",
    "内閣府プロジェクト名２": "品川シーズンテラス",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "NTT都市開発等",
    "事業期間（年度）": "H23-26",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "224",
    "地域No": "11",
    "地域名": "【特定】品川駅・田町駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "品川駅北周辺地区土地区画整理事業",
    "内閣府No": "4",
    "内閣府プロジェクト名": "品川駅北周辺地区土地区画整理事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "①",
    "特定地域整備計画名": "品川駅北周辺地区土地区画整理事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR",
    "事業期間（年度）": "H28-R15",
    "状況": "事業中",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "●",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "225",
    "地域No": "11",
    "地域名": "【特定】品川駅・田町駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "品川駅北周辺地区（1街区～4街区）",
    "内閣府No": "4-1",
    "内閣府プロジェクト名": "品川駅北周辺地区（1街区～4街区）",
    "内閣府プロジェクト名２": "未定",
    "特定地域整備計画No": "④",
    "特定地域整備計画名": "品川駅北周辺地区建設事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "JR東日本",
    "事業期間（年度）": "R2-6",
    "状況": "事業中",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "●",
    "税制支援（都市再生）": "●",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "●",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "226",
    "地域No": "11",
    "地域名": "【特定】品川駅・田町駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "泉岳寺駅地区第二種市街地再開発事業",
    "内閣府No": "5",
    "内閣府プロジェクト名": "泉岳寺駅地区第二種市街地再開発事業",
    "内閣府プロジェクト名２": "未定",
    "特定地域整備計画No": "③",
    "特定地域整備計画名": "泉岳寺駅地区第二種市街地再開発事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東京都",
    "事業期間（年度）": "H30-R9",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "●",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "●（L街）",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "227",
    "地域No": "11",
    "地域名": "【特定】品川駅・田町駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "品川駅街区地区土地区画整理事業",
    "内閣府No": "6",
    "内閣府プロジェクト名": "品川駅街区地区土地区画整理事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "②",
    "特定地域整備計画名": "品川駅街区地区土地区画整理事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR",
    "事業期間（年度）": "H31-R19",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "228",
    "地域No": "11",
    "地域名": "【特定】品川駅・田町駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "環状４号線",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "環状４号線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○カ",
    "特定地域整備計画名": "東京都市計画道路幹線街路環状４号線（港区港南一丁目～同区高輪三丁目）",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東京都",
    "事業期間（年度）": "R1-14",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "●",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "区域外を街路で支援",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "229",
    "地域No": "11",
    "地域名": "【特定】品川駅・田町駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "東西連絡道路",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "東西連絡道路",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○カ",
    "特定地域整備計画名": "東京都市計画道路幹線街路環状４号線（港区港南一丁目～同区高輪三丁目）",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東京都",
    "事業期間（年度）": "R1-14",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "230",
    "地域No": "11",
    "地域名": "【特定】品川駅・田町駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "第二東西連絡道路",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "第二東西連絡道路",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○イ",
    "特定地域整備計画名": "地区幹線道路整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR等",
    "事業期間（年度）": "H28-R15",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "231",
    "地域No": "11",
    "地域名": "【特定】品川駅・田町駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "西口駅前広場",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "西口駅前広場",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○ク",
    "特定地域整備計画名": "国道１５号品川駅西口基盤整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "国土交通省",
    "事業期間（年度）": "R1-9",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "232",
    "地域No": "11",
    "地域名": "【特定】品川駅・田町駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "西口歩行者デッキ",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "西口歩行者デッキ",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○ク",
    "特定地域整備計画名": "国道１５号品川駅西口基盤整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "国土交通省",
    "事業期間（年度）": "R1-9",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "233",
    "地域No": "11",
    "地域名": "【特定】品川駅・田町駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "補助線街路第332号線",
    "内閣府No": "カ",
    "内閣府プロジェクト名": "補助線街路第332号線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○ア",
    "特定地域整備計画名": "東京都市計画道路幹線街路補助線街路第332号線",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR等",
    "事業期間（年度）": "H28-R15",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "234",
    "地域No": "11",
    "地域名": "【特定】品川駅・田町駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "新駅東側連絡通路",
    "内閣府No": "ク",
    "内閣府プロジェクト名": "新駅東側連絡通路",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○オ",
    "特定地域整備計画名": "新駅東側連絡通路",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "JR東日本",
    "事業期間（年度）": "H29-R6",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "235",
    "地域No": "11",
    "地域名": "【特定】品川駅・田町駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "北口広場",
    "内閣府No": "ケ",
    "内閣府プロジェクト名": "北口広場",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○エ",
    "特定地域整備計画名": "東京都市計画道路幹線街路補助線街路第 334 号線",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR",
    "事業期間（年度）": "R2-15",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "236",
    "地域No": "11",
    "地域名": "【特定】品川駅・田町駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "自由通路",
    "内閣府No": "コ",
    "内閣府プロジェクト名": "自由通路",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○ウ",
    "特定地域整備計画名": "品川駅自由通路整備事業（中央自由通路（延伸部）、北側自由通路）",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR等",
    "事業期間（年度）": "R1-9",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "●",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "237",
    "地域No": "11",
    "地域名": "【特定】品川駅・田町駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "京浜急行本線（泉岳寺駅～新馬場駅間）連続立体交差事業",
    "内閣府No": "",
    "内閣府プロジェクト名": "",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○キ",
    "特定地域整備計画名": "京浜急行本線（泉岳寺駅～新馬場駅間）連続立体交差事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東京都",
    "事業期間（年度）": "R2-11",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "●",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "238",
    "地域No": "11",
    "地域名": "【特定】品川駅・田町駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "北品川駅駅前広場整備事業",
    "内閣府No": "",
    "内閣府プロジェクト名": "",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○ケ",
    "特定地域整備計画名": "北品川駅駅前広場整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "品川区",
    "事業期間（年度）": "R2-15",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "●",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "239",
    "地域No": "12",
    "地域名": "【特定】新宿駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "西新宿五丁目中央北地区",
    "内閣府No": "1",
    "内閣府プロジェクト名": "西新宿五丁目中央北地区",
    "内閣府プロジェクト名２": "ザ・パークハウス西新宿タワー６０",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H25-29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "240",
    "地域No": "12",
    "地域名": "【特定】新宿駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "新宿駅西口地区開発計画",
    "内閣府No": "2",
    "内閣府プロジェクト名": "新宿駅西口地区開発計画",
    "内閣府プロジェクト名２": "未定",
    "特定地域整備計画No": "④",
    "特定地域整備計画名": "新宿駅西口地区（（仮称）新宿駅西口地区開発事業）",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "小田急電鉄、東京地下鉄",
    "事業期間（年度）": "R4-11",
    "状況": "事業中",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "241",
    "地域No": "12",
    "地域名": "【特定】新宿駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "西新宿三丁目西地区",
    "内閣府No": "3",
    "内閣府プロジェクト名": "西新宿三丁目西地区",
    "内閣府プロジェクト名２": "未定",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "●",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "242",
    "地域No": "12",
    "地域名": "【特定】新宿駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "西新宿八丁目成子地区",
    "内閣府No": "4",
    "内閣府プロジェクト名": "西新宿八丁目成子地区",
    "内閣府プロジェクト名２": "住友不動産新宿グランドタワー、ラ・トゥール新宿グランド等",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H20-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "243",
    "地域No": "12",
    "地域名": "【特定】新宿駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "西新宿六丁目西第6地区",
    "内閣府No": "5",
    "内閣府プロジェクト名": "西新宿六丁目西第6地区",
    "内閣府プロジェクト名２": "セントラルパークタワー・ラ・トゥール新宿",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H19-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "244",
    "地域No": "12",
    "地域名": "【特定】新宿駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "西新宿六丁目西第7地区",
    "内閣府No": "6",
    "内閣府プロジェクト名": "西新宿六丁目西第7地区",
    "内閣府プロジェクト名２": "N.Y.T アトラスタワー西新宿",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "245",
    "地域No": "12",
    "地域名": "【特定】新宿駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "北新宿地区",
    "内閣府No": "7",
    "内閣府プロジェクト名": "北新宿地区",
    "内閣府プロジェクト名２": "新宿フロントタワー等",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東京都",
    "事業期間（年度）": "H14-26",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "246",
    "地域No": "12",
    "地域名": "【特定】新宿駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "西新宿一丁目7地区",
    "内閣府No": "8",
    "内閣府プロジェクト名": "西新宿一丁目7地区",
    "内閣府プロジェクト名２": "モード学園コクーンタワー",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "モード学園",
    "事業期間（年度）": "H18-20",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "247",
    "地域No": "12",
    "地域名": "【特定】新宿駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "新宿六丁目西北地区（Ｓ街区）",
    "内閣府No": "9",
    "内閣府プロジェクト名": "新宿六丁目西北地区（Ｓ街区）",
    "内閣府プロジェクト名２": "パークハビオ新宿イーストサイドタワー",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "SPC",
    "事業期間（年度）": "H21-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "248",
    "地域No": "12",
    "地域名": "【特定】新宿駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "新宿六丁目西北地区（N街区）",
    "内閣府No": "10",
    "内閣府プロジェクト名": "新宿六丁目西北地区（N街区）",
    "内閣府プロジェクト名２": "新宿イーストサイドスクエア",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "SPC",
    "事業期間（年度）": "H22-24",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "249",
    "地域No": "12",
    "地域名": "【特定】新宿駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "西新宿五丁目北地区",
    "内閣府No": "11",
    "内閣府プロジェクト名": "西新宿五丁目北地区",
    "内閣府プロジェクト名２": "未定",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "防災街区整備事業組合",
    "事業期間（年度）": "R1-4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "250",
    "地域No": "12",
    "地域名": "【特定】新宿駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "西新宿五丁目中央南地区",
    "内閣府No": "12",
    "内閣府プロジェクト名": "西新宿五丁目中央南地区",
    "内閣府プロジェクト名２": "未定",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "R3-6",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "251",
    "地域No": "12",
    "地域名": "【特定】新宿駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "西新宿二丁目（８号地）特定街区",
    "内閣府No": "13",
    "内閣府プロジェクト名": "西新宿二丁目（８号地）特定街区",
    "内閣府プロジェクト名２": "新宿住友ビル三角広場",
    "特定地域整備計画No": "①",
    "特定地域整備計画名": "西新宿二丁目（８号地）特定街区",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "住友不動産",
    "事業期間（年度）": "H29-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "252",
    "地域No": "12",
    "地域名": "【特定】新宿駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）損保ジャパン日本興亜　新美術館計画",
    "内閣府No": "14",
    "内閣府プロジェクト名": "（仮称）損保ジャパン日本興亜　新美術館計画",
    "内閣府プロジェクト名２": "SOMPO美術館",
    "特定地域整備計画No": "②",
    "特定地域整備計画名": "西新宿一丁目（11-2号地）特定街区（損保ジャパン 新美術館計画）",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "損害保険ジャパン日本興亜",
    "事業期間（年度）": "H29-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "253",
    "地域No": "12",
    "地域名": "【特定】新宿駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "歌舞伎町一丁目地区",
    "内閣府No": "15",
    "内閣府プロジェクト名": "歌舞伎町一丁目地区",
    "内閣府プロジェクト名２": "東急歌舞伎町タワー",
    "特定地域整備計画No": "③",
    "特定地域整備計画名": "歌舞伎町一丁目地区",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東急レクリエーション、東急",
    "事業期間（年度）": "R1-4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "254",
    "地域No": "12",
    "地域名": "【特定】新宿駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "都市計画道路放射6号線",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "都市計画道路放射6号線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H7-26",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "255",
    "地域No": "12",
    "地域名": "【特定】新宿駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "都市計画道路環状５の1号線",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "都市計画道路環状５の1号線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H18-R6",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "●",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "256",
    "地域No": "12",
    "地域名": "【特定】新宿駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "国道20号線（新宿駅跨線橋架け替え）",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "国道20号線（新宿駅跨線橋架け替え）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H11-24",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "257",
    "地域No": "12",
    "地域名": "【特定】新宿駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "新宿駅東西自由通路",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "新宿駅東西自由通路",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○ア",
    "特定地域整備計画名": "新宿駅東西自由通路整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "新宿駅周辺地区都市再生協議会",
    "事業期間（年度）": "H24-R5",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "●",
    "その他支援": ""
  },
  {
    "key": "258",
    "地域No": "12",
    "地域名": "【特定】新宿駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "新宿駅直近地区土地区画整理事業",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "新宿駅直近地区土地区画整理事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○イ",
    "特定地域整備計画名": "新宿駅直近地区土地区画整理事業（新宿副都心街路第1号線及び第4号線、新宿区画街路第1号線並びに新宿駅中央通路線等の整備）",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東京都",
    "事業期間（年度）": "R3-28",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "259",
    "地域No": "12",
    "地域名": "【特定】新宿駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "新宿駅北東部地下通路線",
    "内閣府No": "カ",
    "内閣府プロジェクト名": "新宿駅北東部地下通路線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "260",
    "地域No": "13",
    "地域名": "大崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大崎駅西口Ｅ東地区",
    "内閣府No": "1",
    "内閣府プロジェクト名": "大崎駅西口Ｅ東地区",
    "内閣府プロジェクト名２": "Think Park",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "明電舎、世界貿易センタービルディング",
    "事業期間（年度）": "H16-19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "261",
    "地域No": "13",
    "地域名": "大崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大崎駅西口中地区第一種市街地再開発事業",
    "内閣府No": "2",
    "内閣府プロジェクト名": "大崎駅西口中地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "大崎ウエストシティタワーズ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H18-21",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "262",
    "地域No": "13",
    "地域名": "大崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大崎駅東口第３地区第一種市街地再開発事業",
    "内閣府No": "3",
    "内閣府プロジェクト名": "大崎駅東口第３地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "アートヴィレッジ大崎",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H16-18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "263",
    "地域No": "13",
    "地域名": "大崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "東五反田二丁目第２地区第一種市街地再開発事業",
    "内閣府No": "4",
    "内閣府プロジェクト名": "東五反田二丁目第２地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "東京サザンガーデン",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H19-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "264",
    "地域No": "13",
    "地域名": "大崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "北品川五丁目第１地区第一種市街地再開発事業",
    "内閣府No": "5",
    "内閣府プロジェクト名": "北品川五丁目第１地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "パークシティ大崎",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H24-27",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "265",
    "地域No": "13",
    "地域名": "大崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大崎駅西口南地区第一種市街地再開発事業",
    "内閣府No": "6",
    "内閣府プロジェクト名": "大崎駅西口南地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "大崎ウィズシティ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H23-25",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "266",
    "地域No": "13",
    "地域名": "大崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "(仮称)東五反田（B地区）開発計画",
    "内閣府No": "7",
    "内閣府プロジェクト名": "(仮称)東五反田（B地区）開発計画",
    "内閣府プロジェクト名２": "大崎フォレストビルディング",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東洋製罐",
    "事業期間（年度）": "H21-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "267",
    "地域No": "13",
    "地域名": "大崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大崎駅西口C地区",
    "内閣府No": "8",
    "内閣府プロジェクト名": "大崎駅西口C地区",
    "内閣府プロジェクト名２": "ＮＢＦ大崎ビル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ソニー",
    "事業期間（年度）": "H20-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "268",
    "地域No": "13",
    "地域名": "大崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大崎駅東口第４地区",
    "内閣府No": "9",
    "内閣府プロジェクト名": "大崎駅東口第４地区",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "269",
    "地域No": "13",
    "地域名": "大崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "東五反田二丁目第３地区第一種市街地再開発事業",
    "内閣府No": "10",
    "内閣府プロジェクト名": "東五反田二丁目第３地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "R5-9",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "270",
    "地域No": "13",
    "地域名": "大崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大崎駅東口第４西地区",
    "内閣府No": "11",
    "内閣府プロジェクト名": "大崎駅東口第４西地区",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "271",
    "地域No": "13",
    "地域名": "大崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）北品川５丁目計画",
    "内閣府No": "12",
    "内閣府プロジェクト名": "（仮称）北品川５丁目計画",
    "内閣府プロジェクト名２": "住友不動産大崎ツインビル東館",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "住友不動産",
    "事業期間（年度）": "R1-3",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "272",
    "地域No": "13",
    "地域名": "大崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "(仮称)東五反田二丁目地区",
    "内閣府No": "13",
    "内閣府プロジェクト名": "(仮称)東五反田二丁目地区",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "住友不動産",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "273",
    "地域No": "13",
    "地域名": "大崎駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "交通広場",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "交通広場",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H17-27",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "274",
    "地域No": "14",
    "地域名": "【特定】渋谷駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "道玄坂一丁目駅前地区第一種市街地再開発事業",
    "内閣府No": "1",
    "内閣府プロジェクト名": "道玄坂一丁目駅前地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "渋谷フクラス",
    "特定地域整備計画No": "②",
    "特定地域整備計画名": "道玄坂一丁目駅前地区第一種市街地再開発事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H28-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "275",
    "地域No": "14",
    "地域名": "【特定】渋谷駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "渋谷駅桜丘口地区第一種市街地再開発事業",
    "内閣府No": "2",
    "内閣府プロジェクト名": "渋谷駅桜丘口地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "③",
    "特定地域整備計画名": "渋谷駅桜丘口地区第一種市街地再開発事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "R1-5",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "●",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "276",
    "地域No": "14",
    "地域名": "【特定】渋谷駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "渋谷駅街区土地区画整理事業",
    "内閣府No": "3",
    "内閣府プロジェクト名": "渋谷駅街区土地区画整理事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "①",
    "特定地域整備計画名": "渋谷駅街区土地区画整理事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "共同施行者",
    "事業期間（年度）": "H22-R8",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "●",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "277",
    "地域No": "14",
    "地域名": "【特定】渋谷駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "渋谷駅地区駅街区開発事業",
    "内閣府No": "3-1",
    "内閣府プロジェクト名": "渋谷駅地区駅街区開発事業",
    "内閣府プロジェクト名２": "渋谷スクランブルスクエア",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東急、JR東日本、東京地下鉄",
    "事業期間（年度）": "H26-R9",
    "状況": "事業中",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "●",
    "税制支援（都市再生）": "●",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "278",
    "地域No": "14",
    "地域名": "【特定】渋谷駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "渋谷駅南街区土地区画整理事業",
    "内閣府No": "4",
    "内閣府プロジェクト名": "渋谷駅南街区土地区画整理事業",
    "内閣府プロジェクト名２": "渋谷駅南街区土地区画整理事業",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "土地区画整理組合",
    "事業期間（年度）": "H26-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "279",
    "地域No": "14",
    "地域名": "【特定】渋谷駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "渋谷駅南街区プロジェクト",
    "内閣府No": "4-1",
    "内閣府プロジェクト名": "渋谷駅南街区プロジェクト",
    "内閣府プロジェクト名２": "渋谷ストリーム",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東京急行電鉄ほか",
    "事業期間（年度）": "H27-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "280",
    "地域No": "14",
    "地域名": "【特定】渋谷駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "渋谷二丁目２１地区土地区画整理事業",
    "内閣府No": "5",
    "内閣府プロジェクト名": "渋谷二丁目２１地区土地区画整理事業",
    "内閣府プロジェクト名２": "渋谷ヒカリエ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東京急行電鉄",
    "事業期間（年度）": "H20-24",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "281",
    "地域No": "14",
    "地域名": "【特定】渋谷駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "渋谷新文化街区プロジェクト",
    "内閣府No": "5-1",
    "内閣府プロジェクト名": "渋谷新文化街区プロジェクト",
    "内閣府プロジェクト名２": "渋谷ヒカリエ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "推進協議会",
    "事業期間（年度）": "H21-R3",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "282",
    "地域No": "14",
    "地域名": "【特定】渋谷駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "渋谷宮下町計画",
    "内閣府No": "6",
    "内閣府プロジェクト名": "渋谷宮下町計画",
    "内閣府プロジェクト名２": "渋谷キャスト",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "渋谷宮下町リアルティ",
    "事業期間（年度）": "H26-29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "283",
    "地域No": "14",
    "地域名": "【特定】渋谷駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "宇田川町14・15番地区第一種市街地再開発事業",
    "内閣府No": "7",
    "内閣府プロジェクト名": "宇田川町14・15番地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "渋谷パルコ・ヒューリックビル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "パルコ",
    "事業期間（年度）": "H29-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "284",
    "地域No": "14",
    "地域名": "【特定】渋谷駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）南平台プロジェクト",
    "内閣府No": "8",
    "内閣府プロジェクト名": "（仮称）南平台プロジェクト",
    "内閣府プロジェクト名２": "渋谷ソラスタ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "道玄坂121",
    "事業期間（年度）": "H28-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "285",
    "地域No": "14",
    "地域名": "【特定】渋谷駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "渋谷二丁目17街区第一種市街地再開発事業",
    "内閣府No": "9",
    "内閣府プロジェクト名": "渋谷二丁目17街区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "R2-6",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "286",
    "地域No": "14",
    "地域名": "【特定】渋谷駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "道玄坂二丁目南地区",
    "内閣府No": "10",
    "内閣府プロジェクト名": "道玄坂二丁目南地区",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "R5-8",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "287",
    "地域No": "14",
    "地域名": "【特定】渋谷駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "渋谷二丁目西地区プロジェクト",
    "内閣府No": "11",
    "内閣府プロジェクト名": "渋谷二丁目西地区プロジェクト",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合（予定）、東京建物",
    "事業期間（年度）": "R7-11",
    "状況": "未着手",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "288",
    "地域No": "14",
    "地域名": "【特定】渋谷駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "地下鉄副都心線、東急東横線相互直通化・地下化",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "地下鉄副都心線、東急東横線相互直通化・地下化",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H14-24",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "289",
    "地域No": "14",
    "地域名": "【特定】渋谷駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "銀座線ホームの島式化",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "銀座線ホームの島式化",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H23-R8",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "290",
    "地域No": "14",
    "地域名": "【特定】渋谷駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "東西駅前広場整備・自由通路整備",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "東西駅前広場整備・自由通路整備",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H26-R8",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "291",
    "地域No": "14",
    "地域名": "【特定】渋谷駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "（仮称）南口北側自由通路整備事業",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "（仮称）南口北側自由通路整備事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○イ",
    "特定地域整備計画名": "仮称）南口北側 自由通路整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "渋谷区",
    "事業期間（年度）": "H31-R8",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "●",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "292",
    "地域No": "14",
    "地域名": "【特定】渋谷駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "旧大山街道歩行空間拡幅事業",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "旧大山街道歩行空間拡幅事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○ウ",
    "特定地域整備計画名": "旧大山街道歩行空間拡幅事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "渋谷区",
    "事業期間（年度）": "H26-R8",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "●",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "293",
    "地域No": "14",
    "地域名": "【特定】渋谷駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "仮称）渋谷駅街区北側自由通路整備事業",
    "内閣府No": "",
    "内閣府プロジェクト名": "",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○ア",
    "特定地域整備計画名": "仮称）渋谷駅街区北側自由通路整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "渋谷駅街区土地区画整理事業共同施行者",
    "事業期間（年度）": "H23-R8",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "●",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "294",
    "地域No": "15",
    "地域名": "【特定】池袋駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "池袋駅西口再開発プロジェクト（仮称）",
    "内閣府No": "1",
    "内閣府プロジェクト名": "池袋駅西口再開発プロジェクト（仮称）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合（予定）、東武鉄道",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "295",
    "地域No": "15",
    "地域名": "【特定】池袋駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "豊島プロジェクト",
    "内閣府No": "2",
    "内閣府プロジェクト名": "豊島プロジェクト",
    "内閣府プロジェクト名２": "Hareza池袋（Hareza　Tower、東京建物Brillia HALL）",
    "特定地域整備計画No": "①",
    "特定地域整備計画名": "Hareza池袋（Hareza　Tower、東京建物Brillia HALL）",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東京建物、サンケイビルほか",
    "事業期間（年度）": "H28-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "296",
    "地域No": "15",
    "地域名": "【特定】池袋駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "東京国際大学池袋国際キャンパス",
    "内閣府No": "3",
    "内閣府プロジェクト名": "東京国際大学池袋国際キャンパス",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "④",
    "特定地域整備計画名": "東京国際大学　池袋国際キャンパス",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東京国際大学",
    "事業期間（年度）": "R2-5",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "297",
    "地域No": "15",
    "地域名": "【特定】池袋駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "造幣局跡地開発",
    "内閣府No": "4",
    "内閣府プロジェクト名": "造幣局跡地開発",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "",
    "状況": "",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "298",
    "地域No": "15",
    "地域名": "【特定】池袋駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "東池袋五丁目地区第一種市街地再開発事業",
    "内閣府No": "5",
    "内閣府プロジェクト名": "東池袋五丁目地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "プラウドタワー東池袋",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H29-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "299",
    "地域No": "15",
    "地域名": "【特定】池袋駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "東池袋四丁目2番街区地区第一種市街地再開発事業",
    "内閣府No": "6",
    "内閣府プロジェクト名": "東池袋四丁目2番街区地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "プラウドタワー東池袋ステーションアリーナ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H30-R3",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "300",
    "地域No": "15",
    "地域名": "【特定】池袋駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "南池袋二丁目C地区第一種市街地再開発事業",
    "内閣府No": "7",
    "内閣府プロジェクト名": "南池袋二丁目C地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "③",
    "特定地域整備計画名": "南池袋二丁目C地区第一種市街地再開発事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "R4-7",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "301",
    "地域No": "15",
    "地域名": "【特定】池袋駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "南池袋二丁目A地区第一種市街地再開発事業",
    "内閣府No": "8",
    "内閣府プロジェクト名": "南池袋二丁目A地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "としまエコミューゼタウン",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H23-26",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "302",
    "地域No": "15",
    "地域名": "【特定】池袋駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "西武鉄道池袋ビル建替え計画",
    "内閣府No": "9",
    "内閣府プロジェクト名": "西武鉄道池袋ビル建替え計画",
    "内閣府プロジェクト名２": "ダイヤゲート池袋",
    "特定地域整備計画No": "②",
    "特定地域整備計画名": "西武鉄道池袋ビル建替え計画",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "西武鉄道",
    "事業期間（年度）": "H27-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "303",
    "地域No": "15",
    "地域名": "【特定】池袋駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "東池袋一丁目地区",
    "内閣府No": "10",
    "内閣府プロジェクト名": "東池袋一丁目地区",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "R4-7",
    "状況": "事業中",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "304",
    "地域No": "15",
    "地域名": "【特定】池袋駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "東口駅前広場",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "東口駅前広場",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R11-未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "305",
    "地域No": "15",
    "地域名": "【特定】池袋駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "中池袋公園",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "中池袋公園",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○エ",
    "特定地域整備計画名": "中池袋公園",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H30-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "306",
    "地域No": "15",
    "地域名": "【特定】池袋駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "南北区道",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "南北区道",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○オ",
    "特定地域整備計画名": "南北区道整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H30-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "307",
    "地域No": "15",
    "地域名": "【特定】池袋駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "としまみどりの防災公園",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "としまみどりの防災公園",
    "内閣府プロジェクト名２": "イケ・サンパーク",
    "特定地域整備計画No": "○ウ",
    "特定地域整備計画名": "（仮称）防災公園事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R1-2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "308",
    "地域No": "15",
    "地域名": "【特定】池袋駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "補助176号線",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "補助176号線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○キ",
    "特定地域整備計画名": "補助176号線",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H19-R6",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "309",
    "地域No": "15",
    "地域名": "【特定】池袋駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "補助81号線",
    "内閣府No": "カ",
    "内閣府プロジェクト名": "補助81号線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○イ",
    "特定地域整備計画名": "補助81号線",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H17-R6",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "310",
    "地域No": "15",
    "地域名": "【特定】池袋駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "環状５の１号線",
    "内閣府No": "キ",
    "内閣府プロジェクト名": "環状５の１号線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○ア",
    "特定地域整備計画名": "環状５の１号線",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H10-R9",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "●",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "311",
    "地域No": "15",
    "地域名": "【特定】池袋駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "東西連絡通路（特別区道12-680上空デッキ）",
    "内閣府No": "ク",
    "内閣府プロジェクト名": "東西連絡通路（特別区道12-680上空デッキ）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○カ",
    "特定地域整備計画名": "東西連絡通路（特別区道12-680上空デッキ）",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H29-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "312",
    "地域No": "15",
    "地域名": "【特定】池袋駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "東西連絡通路（南デッキ）",
    "内閣府No": "ケ",
    "内閣府プロジェクト名": "東西連絡通路（南デッキ）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "313",
    "地域No": "15",
    "地域名": "【特定】池袋駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "中央地下通路",
    "内閣府No": "コ",
    "内閣府プロジェクト名": "中央地下通路",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "314",
    "地域No": "15",
    "地域名": "【特定】池袋駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "池袋西口公園",
    "内閣府No": "サ",
    "内閣府プロジェクト名": "池袋西口公園",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H30-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "315",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "羽田空港跡地第１ゾーン整備事業",
    "内閣府No": "1",
    "内閣府プロジェクト名": "羽田空港跡地第１ゾーン整備事業",
    "内閣府プロジェクト名２": "羽田イノベーションシティ（第一期事業）",
    "特定地域整備計画No": "①",
    "特定地域整備計画名": "羽田空港跡地第１ゾーン整備事業（第一期事業）",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "特定目的会社",
    "事業期間（年度）": "H30-R5",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "●",
    "税制支援（都市再生）": "●",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "316",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "羽田空港跡地第２ゾーン計画",
    "内閣府No": "2",
    "内閣府プロジェクト名": "羽田空港跡地第２ゾーン計画",
    "内閣府プロジェクト名２": "羽田エアポートガーデン",
    "特定地域整備計画No": "②",
    "特定地域整備計画名": "羽田空港跡地第２ゾーン計画",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "羽田エアポート都市開発",
    "事業期間（年度）": "H30-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "317",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "特別養護老人ホーム「ゆとりあ」（殿町1丁目地区）",
    "内閣府No": "1",
    "内閣府プロジェクト名": "特別養護老人ホーム「ゆとりあ」（殿町1丁目地区）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "川崎大師福祉会",
    "事業期間（年度）": "H21-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "318",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大師河原一丁目地区",
    "内閣府No": "2",
    "内閣府プロジェクト名": "大師河原一丁目地区",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "",
    "状況": "",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "319",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ミラリオ大師河原（大師河原一丁目地区）",
    "内閣府No": "2-1",
    "内閣府プロジェクト名": "ミラリオ大師河原（大師河原一丁目地区）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "都市再生機構",
    "事業期間（年度）": "H17-18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "320",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "リヴィエ　マーレ（大師河原一丁目地区）",
    "内閣府No": "2-2",
    "内閣府プロジェクト名": "リヴィエ　マーレ（大師河原一丁目地区）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "プロパスト",
    "事業期間（年度）": "H18-19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "321",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "川崎大師祈祷殿（大師河原一丁目地区）",
    "内閣府No": "2-3",
    "内閣府プロジェクト名": "川崎大師祈祷殿（大師河原一丁目地区）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "平間寺",
    "事業期間（年度）": "H16-17",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "322",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "殿町3丁目土地区画整理事業",
    "内閣府No": "3",
    "内閣府プロジェクト名": "殿町3丁目土地区画整理事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○ア",
    "特定地域整備計画名": "殿町三丁目土地区画整理事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR、川崎市",
    "事業期間（年度）": "H21-25",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "323",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "実験動物中央研究所（殿町3丁目土地区画整理事業）",
    "内閣府No": "3-1",
    "内閣府プロジェクト名": "実験動物中央研究所（殿町3丁目土地区画整理事業）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "実験動物中央研究所",
    "事業期間（年度）": "H22-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "324",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "川崎生命科学・環境研究センター（殿町3丁目土地区画整理事業）",
    "内閣府No": "3-2",
    "内閣府プロジェクト名": "川崎生命科学・環境研究センター（殿町3丁目土地区画整理事業）",
    "内閣府プロジェクト名２": "LiSE（ライズ）",
    "特定地域整備計画No": "③",
    "特定地域整備計画名": "川崎生命科学・環境研究センター（ライズ）",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "大成建設",
    "事業期間（年度）": "H23-24",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "325",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）殿町プロジェクト（殿町3丁目土地区画整理事業）",
    "内閣府No": "3-3",
    "内閣府プロジェクト名": "（仮称）殿町プロジェクト（殿町3丁目土地区画整理事業）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "⑫",
    "特定地域整備計画名": "（仮称）殿町プロジェクト",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "大和ハウス工業、東京センチュリーリース、芙蓉総合リース",
    "事業期間（年度）": "H27-R5",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "●",
    "税制支援（都市再生）": "●",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "326",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ナノ医療イノベーションセンター（殿町3丁目土地区画整理事業）",
    "内閣府No": "3-4",
    "内閣府プロジェクト名": "ナノ医療イノベーションセンター（殿町3丁目土地区画整理事業）",
    "内閣府プロジェクト名２": "iCONM（アイコン）",
    "特定地域整備計画No": "⑦",
    "特定地域整備計画名": "ナノ医療イノベーションセンター",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "川崎市産業振興財団",
    "事業期間（年度）": "H25-26",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "327",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "東京サイエンスセンター（殿町3丁目土地区画整理事業）",
    "内閣府No": "3-5",
    "内閣府プロジェクト名": "東京サイエンスセンター（殿町3丁目土地区画整理事業）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "⑥",
    "特定地域整備計画名": "東京サイエンスセンター",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ジョンソン・エンド・ジョンソン",
    "事業期間（年度）": "H25-26",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "328",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "日本アイソトープ協会　川崎技術開発センター（殿町3丁目土地区画整理事業）",
    "内閣府No": "3-6",
    "内閣府プロジェクト名": "日本アイソトープ協会　川崎技術開発センター（殿町3丁目土地区画整理事業）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "⑧",
    "特定地域整備計画名": "日本アイソトープ協会川崎技術開発センター",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "日本アイソトープ協会",
    "事業期間（年度）": "H27-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "329",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ライフイノベーションセンター（殿町3丁目土地区画整理事業）",
    "内閣府No": "3-7",
    "内閣府プロジェクト名": "ライフイノベーションセンター（殿町3丁目土地区画整理事業）",
    "内閣府プロジェクト名２": "ＬＩＣ（エルアイシー）",
    "特定地域整備計画No": "⑩",
    "特定地域整備計画名": "ライフイノベーションセンター（LIC）",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "神奈川県、大和ハウス工業、東京センチュリーリース",
    "事業期間（年度）": "H26-27",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "330",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ＰＤＲファーマ㈱ 川崎ラボ（殿町3丁目土地区画整理事業）",
    "内閣府No": "3-8",
    "内閣府プロジェクト名": "ＰＤＲファーマ㈱ 川崎ラボ（殿町3丁目土地区画整理事業）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "⑪",
    "特定地域整備計画名": "PDR ファーマ㈱ 川崎ラボ",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ＰＤＲファーマ",
    "事業期間（年度）": "H25-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "331",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）サイバニクスＡ棟建設計画（殿町3丁目土地区画整理事業）",
    "内閣府No": "3-9",
    "内閣府プロジェクト名": "（仮称）サイバニクスＡ棟建設計画（殿町3丁目土地区画整理事業）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "⑰",
    "特定地域整備計画名": "サイバニクスイノベーションベースA",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ＣＹＢＥＲＤＹＮＥ",
    "事業期間（年度）": "R2-3",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "332",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ぺプチドリーム本社・研究所（殿町3丁目土地区画整理事業）",
    "内閣府No": "3-10",
    "内閣府プロジェクト名": "ぺプチドリーム本社・研究所（殿町3丁目土地区画整理事業）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "⑭",
    "特定地域整備計画名": "ぺプチドリーム本社・研究所",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ぺプチドリーム",
    "事業期間（年度）": "H28-29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "333",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "国立医薬品食品衛生研究所（殿町3丁目土地区画整理事業）",
    "内閣府No": "3-11",
    "内閣府プロジェクト名": "国立医薬品食品衛生研究所（殿町3丁目土地区画整理事業）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "④",
    "特定地域整備計画名": "国立医薬品食品衛生研究所",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "国立医薬品食品衛生研究所",
    "事業期間（年度）": "H26-29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "334",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "クリエートメディック㈱研究開発センター（殿町3丁目土地区画整理事業）",
    "内閣府No": "3-12",
    "内閣府プロジェクト名": "クリエートメディック㈱研究開発センター（殿町3丁目土地区画整理事業）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "⑨",
    "特定地域整備計画名": "クリエートメディック㈱研究開発センター",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "クリエートメディック",
    "事業期間（年度）": "H27-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "335",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "殿町新研究棟（ＪＳＲ - BiRD）",
    "内閣府No": "3-13",
    "内閣府プロジェクト名": "殿町新研究棟（ＪＳＲ - BiRD）",
    "内閣府プロジェクト名２": "JSR BiRD",
    "特定地域整備計画No": "⑮",
    "特定地域整備計画名": "殿町新研究棟（ＪＳＲ-ＢｉＲＤ）",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ＪＳＲ",
    "事業期間（年度）": "R1-3",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "336",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "殿町本社・研究開発拠点",
    "内閣府No": "3-14",
    "内閣府プロジェクト名": "殿町本社・研究開発拠点",
    "内閣府プロジェクト名２": "MediSky（メディスカイ）",
    "特定地域整備計画No": "⑯",
    "特定地域整備計画名": "殿町本社・研究開発拠点",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "SBカワスミ",
    "事業期間（年度）": "R1-3",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "337",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "㈱ヨドバシカメラ　アッセンブリセンター",
    "内閣府No": "4",
    "内閣府プロジェクト名": "㈱ヨドバシカメラ　アッセンブリセンター",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "⑬",
    "特定地域整備計画名": "ヨドバシカメラアッセンブリーセンター",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ヨドバシカメラ",
    "事業期間（年度）": "H27-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "338",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "全日本空輸㈱　ＡＮＡ殿町ビジネスセンター",
    "内閣府No": "5",
    "内閣府プロジェクト名": "全日本空輸㈱　ＡＮＡ殿町ビジネスセンター",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "⑤",
    "特定地域整備計画名": "臨空関連開発",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "全日本空輸",
    "事業期間（年度）": "H21-未定",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "339",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "塩浜３丁目地区サポートエリア計画",
    "内閣府No": "6",
    "内閣府プロジェクト名": "塩浜３丁目地区サポートエリア計画",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "川崎市、川崎鶴見臨港バス",
    "事業期間（年度）": "H26-未定",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "340",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "港町プロジェクト",
    "内閣府No": "7",
    "内閣府プロジェクト名": "港町プロジェクト",
    "内閣府プロジェクト名２": "リヴァリエ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "京浜急行電鉄、大和ハウス工業",
    "事業期間（年度）": "H22-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "341",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大師橋（旧産業道路）駅前地区",
    "内閣府No": "8",
    "内閣府プロジェクト名": "大師橋（旧産業道路）駅前地区",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "川崎市、京浜急行電鉄、長谷工コーポレーション",
    "事業期間（年度）": "H26-未定",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "342",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "大師河原河川防災ステーション・高規格堤防",
    "内閣府No": "ア-1",
    "内閣府プロジェクト名": "大師河原河川防災ステーション・高規格堤防",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H14-19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "343",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "高規格堤防（大師河原一丁目地区・二丁目地区）",
    "内閣府No": "ア-2",
    "内閣府プロジェクト名": "高規格堤防（大師河原一丁目地区・二丁目地区）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H12-17",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "344",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "開発道路（大師河原一丁目地区）",
    "内閣府No": "ア-3",
    "内閣府プロジェクト名": "開発道路（大師河原一丁目地区）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H17-18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "345",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "高速川崎縦貫線（Ⅰ期）事業（大師ジャンクション）",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "高速川崎縦貫線（Ⅰ期）事業（大師ジャンクション）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H3-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "346",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "高規格堤防（殿町第一地区）",
    "内閣府No": "ウ-1",
    "内閣府プロジェクト名": "高規格堤防（殿町第一地区）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H19-24",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "347",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "殿町3丁目地区内公園(下河原公園、殿町第２公園)",
    "内閣府No": "ウ-2",
    "内閣府プロジェクト名": "殿町3丁目地区内公園(下河原公園、殿町第２公園)",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H22-25",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "348",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "殿町3丁目地区内幹線道路(市道殿町３９号線)",
    "内閣府No": "ウ-3",
    "内閣府プロジェクト名": "殿町3丁目地区内幹線道路(市道殿町３９号線)",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H22-25",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "349",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "高規格堤防（港町地区）",
    "内閣府No": "エ-1",
    "内閣府プロジェクト名": "高規格堤防（港町地区）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H20-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "350",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "開発道路（港町地区）",
    "内閣府No": "エ-2",
    "内閣府プロジェクト名": "開発道路（港町地区）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H22-26",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "351",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "開発道路（大師橋（旧産業道路）駅前地区）",
    "内閣府No": "オ－１",
    "内閣府プロジェクト名": "開発道路（大師橋（旧産業道路）駅前地区）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H26-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "352",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "駅前交通広場（大師橋（旧産業道路）駅前地区）",
    "内閣府No": "オ－２",
    "内閣府プロジェクト名": "駅前交通広場（大師橋（旧産業道路）駅前地区）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "●",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "353",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "大師河原貯留管整備事業",
    "内閣府No": "カ",
    "内閣府プロジェクト名": "大師河原貯留管整備事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H20-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "354",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "臨港道路東扇島水江町線整備事業",
    "内閣府No": "キ",
    "内閣府プロジェクト名": "臨港道路東扇島水江町線整備事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H26-R5",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "355",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "(仮称)臨海部幹線道路",
    "内閣府No": "ク",
    "内閣府プロジェクト名": "(仮称)臨海部幹線道路",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "356",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "京浜急行大師線連続立体交差事業",
    "内閣府No": "ケ",
    "内閣府プロジェクト名": "京浜急行大師線連続立体交差事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H18-未定",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "●",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "357",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "東海道貨物支線貨客併用化",
    "内閣府No": "コ",
    "内閣府プロジェクト名": "東海道貨物支線貨客併用化",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "358",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "連絡道路",
    "内閣府No": "サ",
    "内閣府プロジェクト名": "連絡道路",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○イ",
    "特定地域整備計画名": "東京都市計画道路補助線街路第333 号線、東京都市計画道路環状第８号線及び川崎都市計画道路３・４・29 号殿町羽田空港線",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "川崎市、東京都、国土交通省",
    "事業期間（年度）": "H29-R3",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "359",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "羽田空港跡地地区土地区画整理事業",
    "内閣府No": "シ",
    "内閣府プロジェクト名": "羽田空港跡地地区土地区画整理事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○ウ",
    "特定地域整備計画名": "東京都市計画土地区画整理事業羽田空港跡地地区土地区画整理事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR",
    "事業期間（年度）": "H28-R7",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "●",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "●（L街）",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "360",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "東京都市計画公園事業第３・３・１２４号羽田空港公園",
    "内閣府No": "ス",
    "内閣府プロジェクト名": "東京都市計画公園事業第３・３・１２４号羽田空港公園",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○エ",
    "特定地域整備計画名": "東京都市計画公園事業第３・３・124 号羽田空港公園",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "大田区",
    "事業期間（年度）": "R2-未定",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "361",
    "地域No": "16",
    "地域名": "【特定】羽田空港南・川崎殿町・大師河原地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "殿町交番",
    "内閣府No": "セ",
    "内閣府プロジェクト名": "殿町交番",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "362",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "高島二丁目地区第一種市街地再開発事業",
    "内閣府No": "1",
    "内閣府プロジェクト名": "高島二丁目地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H16-19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "363",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "横浜駅西口開発ビル計画",
    "内閣府No": "2",
    "内閣府プロジェクト名": "横浜駅西口開発ビル計画",
    "内閣府プロジェクト名２": "JR横浜タワー・JR横浜鶴屋町ビル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "JR東日本、東京急行電鉄",
    "事業期間（年度）": "H27-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "364",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）横浜駅東口地区開発",
    "内閣府No": "3",
    "内閣府プロジェクト名": "（仮称）横浜駅東口地区開発",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "365",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "横浜駅きた西口鶴屋地区第一種市街地再開発事業",
    "内閣府No": "4",
    "内閣府プロジェクト名": "横浜駅きた西口鶴屋地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "THE YOKOHAMA FRONT",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "R1-5",
    "状況": "事業中",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "366",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）横浜駅西口地区第一種市街地再開発事業",
    "内閣府No": "5",
    "内閣府プロジェクト名": "（仮称）横浜駅西口地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合（予定）",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "367",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）横浜駅西口五番街地区第一種市街地再開発事業",
    "内閣府No": "6",
    "内閣府プロジェクト名": "（仮称）横浜駅西口五番街地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合（予定）",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "368",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "みなとみらい２１中央地区土地区画整理事業",
    "内閣府No": "7",
    "内閣府プロジェクト名": "みなとみらい２１中央地区土地区画整理事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR",
    "事業期間（年度）": "S58-H22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "369",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "みなとみらい２１中央地区20街区MICE施設整備事業",
    "内閣府No": "7-1",
    "内閣府プロジェクト名": "みなとみらい２１中央地区20街区MICE施設整備事業",
    "内閣府プロジェクト名２": "パシフィコ横浜ノース、ザ・カハラ・ホテル＆リゾート横浜、横浜ベイコート倶楽部＆スパリゾート",
    "特定地域整備計画No": "③",
    "特定地域整備計画名": "みなとみらい２１中央地区20 街区ＭＩＣＥ施設整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "横浜市、グローバルMICE、リゾートトラスト",
    "事業期間（年度）": "H29-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "370",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ヒューリックみなとみらい",
    "内閣府No": "7-2",
    "内閣府プロジェクト名": "ヒューリックみなとみらい",
    "内閣府プロジェクト名２": "ヒューリックみなとみらい",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "テーオーシー",
    "事業期間（年度）": "H19-21",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "371",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ブランズタワーみなとみらい",
    "内閣府No": "7-3",
    "内閣府プロジェクト名": "ブランズタワーみなとみらい",
    "内閣府プロジェクト名２": "ブランズタワーみなとみらい",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東急不動産",
    "事業期間（年度）": "H26-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "372",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "OCEAN GATE MINATO MIRAI",
    "内閣府No": "7-4",
    "内閣府プロジェクト名": "OCEAN GATE MINATO MIRAI",
    "内閣府プロジェクト名２": "OCEAN GATE MINATO MIRAI",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東急不動産",
    "事業期間（年度）": "H27-29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "373",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "みなとみらいビジネススクエア",
    "内閣府No": "7-5",
    "内閣府プロジェクト名": "みなとみらいビジネススクエア",
    "内閣府プロジェクト名２": "みなとみらいビジネススクエア",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東京海上日動火災保険",
    "事業期間（年度）": "H14-16",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "374",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ＭＭパークビル",
    "内閣府No": "7-6",
    "内閣府プロジェクト名": "ＭＭパークビル",
    "内閣府プロジェクト名２": "ＭＭパークビル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ジャパンリアルエステイト",
    "事業期間（年度）": "H18-19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "375",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "みなとみらいセンタービル",
    "内閣府No": "7-7",
    "内閣府プロジェクト名": "みなとみらいセンタービル",
    "内閣府プロジェクト名２": "みなとみらいセンタービル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "SPC",
    "事業期間（年度）": "H19-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "376",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ＭＡＲＫ　ＩＳ　みなとみらい",
    "内閣府No": "7-8",
    "内閣府プロジェクト名": "ＭＡＲＫ　ＩＳ　みなとみらい",
    "内閣府プロジェクト名２": "ＭＡＲＫ　ＩＳ　みなとみらい",
    "特定地域整備計画No": "①",
    "特定地域整備計画名": "（仮称）MM21 地区３４街区商業施設開発計画",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "三菱地所",
    "事業期間（年度）": "H23-25",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "377",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "Ｍ．Ｍ．ＴＯＷＥＲＳ　ＦＯＲＥＳＩＳ",
    "内閣府No": "7-9",
    "内閣府プロジェクト名": "Ｍ．Ｍ．ＴＯＷＥＲＳ　ＦＯＲＥＳＩＳ",
    "内閣府プロジェクト名２": "Ｍ．Ｍ．ＴＯＷＥＲＳ　ＦＯＲＥＳＩＳ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "三菱地所、東京急行電鉄、三菱倉庫",
    "事業期間（年度）": "H16-19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "378",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "Ｍ．Ｍ．MID　SQUARE",
    "内閣府No": "7-10",
    "内閣府プロジェクト名": "Ｍ．Ｍ．MID　SQUARE",
    "内閣府プロジェクト名２": "Ｍ．Ｍ．MID　SQUARE",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ランド、オリックス不動産、東急不動産、三井物産",
    "事業期間（年度）": "H17-19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "379",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "みなとみらいグランドセントラルタワー",
    "内閣府No": "7-11",
    "内閣府プロジェクト名": "みなとみらいグランドセントラルタワー",
    "内閣府プロジェクト名２": "みなとみらいグランドセントラルタワー",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "SPC",
    "事業期間（年度）": "H20-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "380",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ＰＲYＭＥ　ＧＡＬＬＥＲＹみなとみらい",
    "内閣府No": "7-12",
    "内閣府プロジェクト名": "ＰＲYＭＥ　ＧＡＬＬＥＲＹみなとみらい",
    "内閣府プロジェクト名２": "ＰＲYＭＥ　ＧＡＬＬＥＲＹみなとみらい",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "岡田ビル",
    "事業期間（年度）": "H25",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "381",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ウェスティンホテル横浜、The Apartment Bay YOKOHAMA",
    "内閣府No": "7-13",
    "内閣府プロジェクト名": "ウェスティンホテル横浜、The Apartment Bay YOKOHAMA",
    "内閣府プロジェクト名２": "ウェスティンホテル横浜、The Apartment Bay YOKOHAMA",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "積水ハウス",
    "事業期間（年度）": "R1-3",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "382",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "グローバルラーニングセンター",
    "内閣府No": "7-14",
    "内閣府プロジェクト名": "グローバルラーニングセンター",
    "内閣府プロジェクト名２": "グローバルラーニングセンター",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "三菱東京ＵＦＪ銀行、三菱地所",
    "事業期間（年度）": "H25-27",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "383",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "横浜ブルーアベニュー",
    "内閣府No": "7-15",
    "内閣府プロジェクト名": "横浜ブルーアベニュー",
    "内閣府プロジェクト名２": "横浜ブルーアベニュー",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "みずほ信託銀行",
    "事業期間（年度）": "H19-21",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "384",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "横浜野村ビル",
    "内閣府No": "7-16",
    "内閣府プロジェクト名": "横浜野村ビル",
    "内閣府プロジェクト名２": "横浜野村ビル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "野村不動産",
    "事業期間（年度）": "H26-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "385",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "横浜アイマークプレイス",
    "内閣府No": "7-17",
    "内閣府プロジェクト名": "横浜アイマークプレイス",
    "内閣府プロジェクト名２": "横浜アイマークプレイス",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "清水建設",
    "事業期間（年度）": "H24-26",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "386",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "KTビル",
    "内閣府No": "7-18",
    "内閣府プロジェクト名": "KTビル",
    "内閣府プロジェクト名２": "KTビル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "コーエーテクモゲームス",
    "事業期間（年度）": "H29-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "387",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "プロット４８",
    "内閣府No": "7-19",
    "内閣府プロジェクト名": "プロット４８",
    "内閣府プロジェクト名２": "プロット４８",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "？",
    "状況": "？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "388",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "シンクロン本社ビル",
    "内閣府No": "7-20",
    "内閣府プロジェクト名": "シンクロン本社ビル",
    "内閣府プロジェクト名２": "シンクロン本社ビル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "シンクロン",
    "事業期間（年度）": "H19-20",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "389",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "シンクロン本社ビル新館",
    "内閣府No": "7-21",
    "内閣府プロジェクト名": "シンクロン本社ビル新館",
    "内閣府プロジェクト名２": "シンクロン本社ビル新館",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "シンクロン",
    "事業期間（年度）": "H24-26",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "390",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "Brillia Grande みなとみらい",
    "内閣府No": "7-22",
    "内閣府プロジェクト名": "Brillia Grande みなとみらい",
    "内閣府プロジェクト名２": "Brillia Grande みなとみらい",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東京住宅供給センター等",
    "事業期間（年度）": "H16-19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "391",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "パシフィックロイヤルコートみなとみらいオーシャンタワー",
    "内閣府No": "7-23",
    "内閣府プロジェクト名": "パシフィックロイヤルコートみなとみらいオーシャンタワー",
    "内閣府プロジェクト名２": "パシフィックロイヤルコートみなとみらいオーシャンタワー",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ディエイチ開発みなとみらい",
    "事業期間（年度）": "H17-19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "392",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "パシフィックロイヤルコートみなとみらいアーバンタワー",
    "内閣府No": "7-24",
    "内閣府プロジェクト名": "パシフィックロイヤルコートみなとみらいアーバンタワー",
    "内閣府プロジェクト名２": "パシフィックロイヤルコートみなとみらいアーバンタワー",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "SPC",
    "事業期間（年度）": "H17-20",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "393",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "横浜グランゲート",
    "内閣府No": "7-25",
    "内閣府プロジェクト名": "横浜グランゲート",
    "内閣府プロジェクト名２": "横浜グランゲート",
    "特定地域整備計画No": "④",
    "特定地域整備計画名": "（仮称）MM21-54 街区プロジェクト",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "清水建設",
    "事業期間（年度）": "H29-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "394",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "LG YOKOHAMA INNOVATION CENTER",
    "内閣府No": "7-26",
    "内閣府プロジェクト名": "LG YOKOHAMA INNOVATION CENTER",
    "内閣府プロジェクト名２": "LG YOKOHAMA INNOVATION CENTER",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "LG Holdings Japan",
    "事業期間（年度）": "R1-3",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "395",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "みなとみらい学園ビル",
    "内閣府No": "7-27",
    "内閣府プロジェクト名": "みなとみらい学園ビル",
    "内閣府プロジェクト名２": "みなとみらい学園ビル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "みなとみらい学園",
    "事業期間（年度）": "H27-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "396",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "京急グループ本社",
    "内閣府No": "7-28",
    "内閣府プロジェクト名": "京急グループ本社",
    "内閣府プロジェクト名２": "京急グループ本社",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "京浜急行電鉄",
    "事業期間（年度）": "H29-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "397",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "資生堂グローバルイノベーションセンター（Ｓ/ＰＡＲＫ）",
    "内閣府No": "7-29",
    "内閣府プロジェクト名": "資生堂グローバルイノベーションセンター（Ｓ/ＰＡＲＫ）",
    "内閣府プロジェクト名２": "資生堂グローバルイノベーションセンター（Ｓ/ＰＡＲＫ）",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "資生堂",
    "事業期間（年度）": "H28-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "398",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "国土交通省関東地方整備局京浜港湾事務所",
    "内閣府No": "7-30",
    "内閣府プロジェクト名": "国土交通省関東地方整備局京浜港湾事務所",
    "内閣府プロジェクト名２": "国土交通省関東地方整備局京浜港湾事務所",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR、国土交通省",
    "事業期間（年度）": "H17-18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "399",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "オーケーみなとみらいビル",
    "内閣府No": "7-31",
    "内閣府プロジェクト名": "オーケーみなとみらいビル",
    "内閣府プロジェクト名２": "オーケーみなとみらいビル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "オーケー",
    "事業期間（年度）": "H26-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "400",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "プライムコーストみなとみらい",
    "内閣府No": "7-32",
    "内閣府プロジェクト名": "プライムコーストみなとみらい",
    "内閣府プロジェクト名２": "プライムコーストみなとみらい",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "岡田ビル",
    "事業期間（年度）": "H26-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "401",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "横浜アンパンマンこどもミュージアム",
    "内閣府No": "7-33",
    "内閣府プロジェクト名": "横浜アンパンマンこどもミュージアム",
    "内閣府プロジェクト名２": "横浜アンパンマンこどもミュージアム",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "日本テレビ音楽",
    "事業期間（年度）": "H29-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "402",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "富士ゼロックス㈱横浜みなとみらい事業所",
    "内閣府No": "7-34",
    "内閣府プロジェクト名": "富士ゼロックス㈱横浜みなとみらい事業所",
    "内閣府プロジェクト名２": "富士フイルムビジネスイノベーション㈱横浜みなとみらい事業所",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "富士ゼロックス",
    "事業期間（年度）": "H19-21",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "403",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "日産自動車株式会社　グローバル本社",
    "内閣府No": "7-35",
    "内閣府プロジェクト名": "日産自動車株式会社　グローバル本社",
    "内閣府プロジェクト名２": "日産自動車株式会社　グローバル本社",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "日産自動車",
    "事業期間（年度）": "H18-21",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "404",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "横浜三井ビルディング",
    "内閣府No": "7-36",
    "内閣府プロジェクト名": "横浜三井ビルディング",
    "内閣府プロジェクト名２": "横浜三井ビルディング",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "三井不動産",
    "事業期間（年度）": "H21-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "405",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "神奈川大学みなとみらいキャンパス",
    "内閣府No": "7-37",
    "内閣府プロジェクト名": "神奈川大学みなとみらいキャンパス",
    "内閣府プロジェクト名２": "神奈川大学みなとみらいキャンパス",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "神奈川大学",
    "事業期間（年度）": "H30-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "406",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "(仮称）みなとみらい２１中央地区５２街区開発事業計画",
    "内閣府No": "7-38",
    "内閣府プロジェクト名": "(仮称）みなとみらい２１中央地区５２街区開発事業計画",
    "内閣府プロジェクト名２": "(仮称）みなとみらい２１中央地区５２街区開発事業計画",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "SPC、光優",
    "事業期間（年度）": "R4-8",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "●",
    "税制支援（都市再生）": "●",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "●",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "407",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "(仮称）みなとみらい２１中央地区53街区開発計画",
    "内閣府No": "7-39",
    "内閣府プロジェクト名": "(仮称）みなとみらい２１中央地区53街区開発計画",
    "内閣府プロジェクト名２": "(仮称）みなとみらい２１中央地区53街区開発計画",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "大林組、ヤマハ、京浜急行電鉄、日鉄興和不動産、みなとみらい５３ＥＡＳＴ合同会社",
    "事業期間（年度）": "R3-5",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "●",
    "税制支援（都市再生）": "●",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "408",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "みなとみらい本町小学校（暫定）",
    "内閣府No": "7-40",
    "内閣府プロジェクト名": "みなとみらい本町小学校（暫定）",
    "内閣府プロジェクト名２": "みなとみらい本町小学校（暫定）",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "？",
    "状況": "？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "409",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "横濱ゲートタワー",
    "内閣府No": "7-41",
    "内閣府プロジェクト名": "横濱ゲートタワー",
    "内閣府プロジェクト名２": "横濱ゲートタワー",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "鹿島建設、住友生命保険、三井住友海上火災保険",
    "事業期間（年度）": "H31-R3",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "410",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "Kアリーナプロジェクト(ミュージックテラス）",
    "内閣府No": "7-42",
    "内閣府プロジェクト名": "Kアリーナプロジェクト(ミュージックテラス）",
    "内閣府プロジェクト名２": "Kアリーナプロジェクト(ミュージックテラス）",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ケン・コーポレーション",
    "事業期間（年度）": "R2-5",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "●",
    "税制支援（都市再生）": "●",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "411",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）HARBOR EDGE PROJECT",
    "内閣府No": "7-43",
    "内閣府プロジェクト名": "（仮称）HARBOR EDGE PROJECT",
    "内閣府プロジェクト名２": "（仮称）HARBOR EDGE PROJECT",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "BMD62",
    "事業期間（年度）": "R5-8",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "●",
    "税制支援（都市再生）": "●",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "412",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "(仮称）みなとみらい２１中央地区37街区開発計画",
    "内閣府No": "7-44",
    "内閣府プロジェクト名": "(仮称）みなとみらい２１中央地区37街区開発計画",
    "内閣府プロジェクト名２": "(仮称）みなとみらい２１中央地区37街区開発計画",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ＫＲＦ48",
    "事業期間（年度）": "R2-4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "413",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ぴあアリーナMM",
    "内閣府No": "7-45",
    "内閣府プロジェクト名": "ぴあアリーナMM",
    "内閣府プロジェクト名２": "ぴあアリーナMM",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ぴあ",
    "事業期間（年度）": "H29-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "414",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "首都高速道路（株）神奈川局",
    "内閣府No": "7-46",
    "内閣府プロジェクト名": "首都高速道路（株）神奈川局",
    "内閣府プロジェクト名２": "首都高速道路（株）神奈川局",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "首都高速道路",
    "事業期間（年度）": "H31-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "415",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "村田製作所みなとみらいイノベーションセンター",
    "内閣府No": "7-47",
    "内閣府プロジェクト名": "村田製作所みなとみらいイノベーションセンター",
    "内閣府プロジェクト名２": "村田製作所みなとみらいイノベーションセンター",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "村田製作所",
    "事業期間（年度）": "H30-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "416",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "北仲通北土地区画整理事業",
    "内閣府No": "8",
    "内閣府プロジェクト名": "北仲通北土地区画整理事業",
    "内閣府プロジェクト名２": "北仲通北土地区画整理事業",
    "特定地域整備計画No": "○カ",
    "特定地域整備計画名": "北仲通北土地区画整理事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "土地区画整理組合",
    "事業期間（年度）": "H19-26",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "417",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "北仲通北地区　A-1地区、A-2地区",
    "内閣府No": "8-1",
    "内閣府プロジェクト名": "北仲通北地区　A-1地区、A-2地区",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "大和地所、住友不動産",
    "事業期間（年度）": "R5-8",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "●",
    "税制支援（都市再生）": "●",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "418",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "北仲通北地区　A-3地区",
    "内閣府No": "8-2",
    "内閣府プロジェクト名": "北仲通北地区　A-3地区",
    "内閣府プロジェクト名２": "ノートルダム横浜みなとみらい",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "日本セレモニー",
    "事業期間（年度）": "H27-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "419",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "北仲通北地区　A-4地区",
    "内閣府No": "8-3",
    "内閣府プロジェクト名": "北仲通北地区　A-4地区",
    "内閣府プロジェクト名２": "横浜北仲ノット",
    "特定地域整備計画No": "②",
    "特定地域整備計画名": "北仲通北地区Ａ－４地区",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "三井不動産レジデンシャル、丸紅",
    "事業期間（年度）": "H28-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "420",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "北仲通北地区　B-1地区",
    "内閣府No": "8-4",
    "内閣府プロジェクト名": "北仲通北地区　B-1地区",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "日新",
    "事業期間（年度）": "R5-9",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "421",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "北仲通北地区　B-2地区",
    "内閣府No": "8-5",
    "内閣府プロジェクト名": "北仲通北地区　B-2地区",
    "内閣府プロジェクト名２": "アパホテル＆リゾート横浜ベイタワー",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "アパマンション",
    "事業期間（年度）": "H29-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "422",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "北仲通北地区　B-3地区",
    "内閣府No": "8-6",
    "内閣府プロジェクト名": "北仲通北地区　B-3地区",
    "内閣府プロジェクト名２": "シャレール海岸通",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR",
    "事業期間（年度）": "H22-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "423",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "北仲通南地区第二種市街地再開発事業（第1工区）",
    "内閣府No": "8-7",
    "内閣府プロジェクト名": "北仲通南地区第二種市街地再開発事業（第1工区）",
    "内閣府プロジェクト名２": "横浜アイランドタワー",
    "特定地域整備計画No": "○キ",
    "特定地域整備計画名": "横浜国際港都建設計画北仲通南地区第二種市街地再開発事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "URほか",
    "事業期間（年度）": "H12-14",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "424",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "北仲通南地区第二種市街地再開発事業（第2工区）",
    "内閣府No": "8-8",
    "内閣府プロジェクト名": "北仲通南地区第二種市街地再開発事業（第2工区）",
    "内閣府プロジェクト名２": "横浜市庁舎",
    "特定地域整備計画No": "○キ",
    "特定地域整備計画名": "横浜国際港都建設計画北仲通南地区第二種市街地再開発事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "URほか",
    "事業期間（年度）": "H29-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "425",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）山下ふ頭再開発プロジェクト（民間開発事業）",
    "内閣府No": "10-110-2",
    "内閣府プロジェクト名": "（仮称）山下ふ頭再開発プロジェクト（民間開発事業）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "民間事業者",
    "事業期間（年度）": "R1-12",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "426",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）山下ふ頭再開発プロジェクト（賑わい創出事業）",
    "内閣府No": "10-2",
    "内閣府プロジェクト名": "（仮称）山下ふ頭再開発プロジェクト（賑わい創出事業）",
    "内閣府プロジェクト名２": "「動くガンダム」GUNDAM FACTORY YOKOHAMA(ｶﾞﾝﾀﾞﾑﾌｧｸﾄﾘｰ ﾖｺﾊﾏ)　等",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "",
    "状況": "",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "427",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "横浜市旧市庁舎街区活用事業",
    "内閣府No": "11-1",
    "内閣府プロジェクト名": "横浜市旧市庁舎街区活用事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "三井不動産、鹿島建設　ほか",
    "事業期間（年度）": "R3-7",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "●",
    "税制支援（都市再生）": "●",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "428",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "関東学院横浜都心キャンパス",
    "内閣府No": "11-2",
    "内閣府プロジェクト名": "関東学院横浜都心キャンパス",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "関東学院",
    "事業期間（年度）": "R1-4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "429",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）関内駅前港町地区第一種市街地再開発事業",
    "内閣府No": "11-3",
    "内閣府プロジェクト名": "（仮称）関内駅前港町地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "R7-11",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "430",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "横浜市文化体育館再整備事業",
    "内閣府No": "11-4",
    "内閣府プロジェクト名": "横浜市文化体育館再整備事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "YOKOHAMA文体",
    "事業期間（年度）": "R4-5",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "431",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）横浜スタジアム改修事業",
    "内閣府No": "11-5",
    "内閣府プロジェクト名": "（仮称）横浜スタジアム改修事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "横浜スタジアム等",
    "事業期間（年度）": "H29-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "432",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ハイアットリージェンシー横浜",
    "内閣府No": "11-6",
    "内閣府プロジェクト名": "ハイアットリージェンシー横浜",
    "内閣府プロジェクト名２": "ハイアットリージェンシー横浜",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ハイアットホテルズコーポレーション、ケン・コーポレーション",
    "事業期間（年度）": "H30-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "433",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "新港ふ頭客船ターミナル",
    "内閣府No": "12-1",
    "内閣府プロジェクト名": "新港ふ頭客船ターミナル",
    "内閣府プロジェクト名２": "横浜ハンマーヘッド",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "新港ふ頭客船ターミナル",
    "事業期間（年度）": "H30-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "434",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "北部自由通路（きた通路）",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "北部自由通路（きた通路）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H8-21",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "435",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "南部自由通路（みなみ通路）",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "南部自由通路（みなみ通路）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H9-21",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "436",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "南北連絡通路",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "南北連絡通路",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H8-21",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "437",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "横浜駅西口地下街回遊空間形成事業",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "横浜駅西口地下街回遊空間形成事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○ク",
    "特定地域整備計画名": "横浜駅西口地下街回遊空間形成事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "相鉄アーバンクリエイツ",
    "事業期間（年度）": "H25-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "438",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "万里歩道橋",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "万里歩道橋",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H18-21",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "439",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "ポートサイド人道橋",
    "内閣府No": "カ",
    "内閣府プロジェクト名": "ポートサイド人道橋",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H17-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "440",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "みなとみらい21線",
    "内閣府No": "キ",
    "内閣府プロジェクト名": "みなとみらい21線",
    "内閣府プロジェクト名２": "みなとみらい線",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H4-16",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "441",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "きた西口駅前広場・鶴屋橋架け替え",
    "内閣府No": "ク",
    "内閣府プロジェクト名": "きた西口駅前広場・鶴屋橋架け替え",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○ア、○コ",
    "特定地域整備計画名": "鶴屋橋架け替え事業、横浜駅きた西口駅前広場整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "横浜市",
    "事業期間（年度）": "H25-R4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "442",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "栄本町線支線１号線",
    "内閣府No": "ケ",
    "内閣府プロジェクト名": "栄本町線支線１号線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○シ",
    "特定地域整備計画名": "栄本町線支線１号整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "横浜市",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "443",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "横浜駅西口駅前広場",
    "内閣府No": "コ",
    "内閣府プロジェクト名": "横浜駅西口駅前広場",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○ケ",
    "特定地域整備計画名": "横浜駅西口駅前広場改修整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "横浜市",
    "事業期間（年度）": "H31-R4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "444",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "東横線跡地整備事業",
    "内閣府No": "サ",
    "内閣府プロジェクト名": "東横線跡地整備事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○イ",
    "特定地域整備計画名": "東横線跡地整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "横浜市",
    "事業期間（年度）": "H19-R3",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "445",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "みなとみらい大通り",
    "内閣府No": "シ",
    "内閣府プロジェクト名": "みなとみらい大通り",
    "内閣府プロジェクト名２": "みなとみらい大通り",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "S55-H14",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "446",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "国際大通り",
    "内閣府No": "ス",
    "内閣府プロジェクト名": "国際大通り",
    "内閣府プロジェクト名２": "国際大通り",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "S58-H24",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "447",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "動く歩道",
    "内閣府No": "セ",
    "内閣府プロジェクト名": "動く歩道",
    "内閣府プロジェクト名２": "動く歩道",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "S62-H1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "448",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "高島中央公園",
    "内閣府No": "ソ",
    "内閣府プロジェクト名": "高島中央公園",
    "内閣府プロジェクト名２": "高島中央公園",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H17-19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "449",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "グランモール公園",
    "内閣府No": "タ",
    "内閣府プロジェクト名": "グランモール公園",
    "内閣府プロジェクト名２": "グランモール公園",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "？-H11",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "450",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "水際公園",
    "内閣府No": "チ",
    "内閣府プロジェクト名": "水際公園",
    "内閣府プロジェクト名２": "高島水際線公園",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "451",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "グランモール公園内（駐輪場）",
    "内閣府No": "ツ",
    "内閣府プロジェクト名": "グランモール公園内（駐輪場）",
    "内閣府プロジェクト名２": "みなとみらい駅自転車駐車場整備事業",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H19-21",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "452",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "東横線跡地整備事業",
    "内閣府No": "テ",
    "内閣府プロジェクト名": "東横線跡地整備事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○イ",
    "特定地域整備計画名": "東横線跡地整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "横浜市",
    "事業期間（年度）": "H20-29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "453",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "桜木町駅前広場改修整備事業",
    "内閣府No": "ト",
    "内閣府プロジェクト名": "桜木町駅前広場改修整備事業",
    "内閣府プロジェクト名２": "桜木町駅前広場改修整備事業",
    "特定地域整備計画No": "○オ",
    "特定地域整備計画名": "桜木町駅前広場改修整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "横浜市",
    "事業期間（年度）": "H24-25",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "454",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "臨港幹線キング軸デッキ",
    "内閣府No": "ナ",
    "内閣府プロジェクト名": "臨港幹線キング軸デッキ",
    "内閣府プロジェクト名２": "キングモール橋",
    "特定地域整備計画No": "○ス",
    "特定地域整備計画名": "臨港幹線キング軸デッキ",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "横浜市",
    "事業期間（年度）": "H29-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "455",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "（仮称）37-38街区接続デッキ",
    "内閣府No": "ハ",
    "内閣府プロジェクト名": "（仮称）37-38街区接続デッキ",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R3-4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "456",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "（仮称）高島水際線デッキ",
    "内閣府No": "ヒ",
    "内閣府プロジェクト名": "（仮称）高島水際線デッキ",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R3-5",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "●",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "457",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "山下ふ頭1号線",
    "内閣府No": "ヌ-1",
    "内閣府プロジェクト名": "山下ふ頭1号線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "458",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "山下ふ頭緑地・山下ふ頭交通ターミナル・交通広場",
    "内閣府No": "ヌ-2",
    "内閣府プロジェクト名": "緑地・交通ターミナル・交通広場",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R1-未定",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "459",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "山下公園通り接続道路・公園改修",
    "内閣府No": "ヌ-3",
    "内閣府プロジェクト名": "山下公園通り接続道路・公園改修",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "460",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "市道第38号線地下通路",
    "内閣府No": "ヌ-4",
    "内閣府プロジェクト名": "市道第38号線地下通路",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "461",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "支線フランス橋",
    "内閣府No": "ヌ-5",
    "内閣府プロジェクト名": "支線フランス橋",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "462",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "元町・中華街駅前道路改良",
    "内閣府No": "ヌ-6",
    "内閣府プロジェクト名": "元町・中華街駅前道路改良",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "463",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "臨港幹線道路",
    "内閣府No": "ヌ-7",
    "内閣府プロジェクト名": "臨港幹線道路",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "464",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "ＪＲ関内駅北口整備事業（駅舎改良）",
    "内閣府No": "ネ-1",
    "内閣府プロジェクト名": "ＪＲ関内駅北口整備事業（駅舎改良）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H26-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "465",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "ＪＲ関内駅北口周辺整備事業（駅前歩行者広場等整備）",
    "内閣府No": "ネ-2",
    "内閣府プロジェクト名": "ＪＲ関内駅北口周辺整備事業（駅前歩行者広場等整備）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H29-R3",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "466",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "（仮称）旧市庁舎街区横浜公園デッキ",
    "内閣府No": "ネ-3",
    "内閣府プロジェクト名": "（仮称）旧市庁舎街区横浜公園デッキ",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "●",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": "みなと大通り及び横浜文化体育館周辺道路再整備はウォーカブル事業"
  },
  {
    "key": "467",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "帷子川河川改修",
    "内閣府No": "",
    "内閣府プロジェクト名": "",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○ウ",
    "特定地域整備計画名": "帷子川河川改修",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "神奈川県",
    "事業期間（年度）": "H10-R17",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "468",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "パシフィコ横浜大規模改修",
    "内閣府No": "",
    "内閣府プロジェクト名": "",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○エ",
    "特定地域整備計画名": "パシフィコ横浜大規模改修",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "横浜国際平和会議場",
    "事業期間（年度）": "H25-R12",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "469",
    "地域No": "17",
    "地域名": "【特定】横浜都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "横浜駅東口等基盤整備事業",
    "内閣府No": "",
    "内閣府プロジェクト名": "",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○サ",
    "特定地域整備計画名": "横浜駅東口等基盤整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "横浜市",
    "事業期間（年度）": "H26-R5",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "470",
    "地域No": "18",
    "地域名": "横浜上大岡駅西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "上大岡Ｂ地区第一種市街地再開発事業",
    "内閣府No": "1",
    "内閣府プロジェクト名": "上大岡Ｂ地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "カミオ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H13-15",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "471",
    "地域No": "18",
    "地域名": "横浜上大岡駅西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "上大岡Ｃ南地区第一種市街地再開発事業",
    "内閣府No": "2",
    "内閣府プロジェクト名": "上大岡Ｃ南地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "ミオカ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H18-21",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "472",
    "地域No": "18",
    "地域名": "横浜上大岡駅西地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "横浜鎌倉線（鎌倉街道）の拡幅",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "横浜鎌倉線（鎌倉街道）の拡幅",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H21-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "473",
    "地域No": "18",
    "地域名": "横浜上大岡駅西地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "立体横断施設（横浜鎌倉線上空）",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "立体横断施設（横浜鎌倉線上空）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H13-15",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "474",
    "地域No": "18",
    "地域名": "横浜上大岡駅西地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "広場（上大岡Ｂ地区施設建築物内）",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "広場（上大岡Ｂ地区施設建築物内）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H13-15",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "475",
    "地域No": "18",
    "地域名": "横浜上大岡駅西地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "歩行者用通路（上大岡Ｃ南地区施設建築物内）",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "歩行者用通路（上大岡Ｃ南地区施設建築物内）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H18-21",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "476",
    "地域No": "19",
    "地域名": "浜川崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "南渡田北地区",
    "内閣府No": "1",
    "内閣府プロジェクト名": "南渡田北地区",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "477",
    "地域No": "19",
    "地域名": "浜川崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "南渡田南地区",
    "内閣府No": "2",
    "内閣府プロジェクト名": "南渡田南地区",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "478",
    "地域No": "19",
    "地域名": "浜川崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ゼファー川崎小田栄マンション新築工事",
    "内閣府No": "3",
    "内閣府プロジェクト名": "ゼファー川崎小田栄マンション新築工事",
    "内閣府プロジェクト名２": "アイランドブリーズ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ゼファー、ナイス",
    "事業期間（年度）": "H16-18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "479",
    "地域No": "19",
    "地域名": "浜川崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ビオラ川崎　特別養護老人ホーム　新築工事",
    "内閣府No": "4",
    "内閣府プロジェクト名": "ビオラ川崎　特別養護老人ホーム　新築工事",
    "内閣府プロジェクト名２": "ビオラ川崎、葵の園川崎",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "中川徳生会、葵会",
    "事業期間（年度）": "H16-17",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "480",
    "地域No": "19",
    "地域名": "浜川崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "小田栄２丁目マンション新築工事",
    "内閣府No": "5",
    "内閣府プロジェクト名": "小田栄２丁目マンション新築工事",
    "内閣府プロジェクト名２": "アイランドグレース",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ゼファー、ナイス",
    "事業期間（年度）": "H18-20",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "481",
    "地域No": "19",
    "地域名": "浜川崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "アイランドスイート",
    "内閣府No": "6",
    "内閣府プロジェクト名": "アイランドスイート",
    "内閣府プロジェクト名２": "アイランドスイート",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ナイス",
    "事業期間（年度）": "H22-25",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "482",
    "地域No": "19",
    "地域名": "浜川崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ホームセンターコーナン川崎区小田栄店新築工事",
    "内閣府No": "7",
    "内閣府プロジェクト名": "ホームセンターコーナン川崎区小田栄店新築工事",
    "内閣府プロジェクト名２": "ホームセンターコーナン小田栄店",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "コーナン商事",
    "事業期間（年度）": "H25-26",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "483",
    "地域No": "19",
    "地域名": "浜川崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "川崎区小田栄２丁目〔Ｂ地区共同住宅〕計画",
    "内閣府No": "8",
    "内閣府プロジェクト名": "川崎区小田栄２丁目〔Ｂ地区共同住宅〕計画",
    "内閣府プロジェクト名２": "カサーレ川崎ネクシア",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "三信住建、アートプランニング",
    "事業期間（年度）": "H25-27",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "484",
    "地域No": "19",
    "地域名": "浜川崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "グレイプス川崎新町計画",
    "内閣府No": "9",
    "内閣府プロジェクト名": "グレイプス川崎新町計画",
    "内閣府プロジェクト名２": "グレイプス川崎新町",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東京建物",
    "事業期間（年度）": "H25-26",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "485",
    "地域No": "19",
    "地域名": "浜川崎駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "川崎駅扇町線",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "川崎駅扇町線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H17-未定",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "486",
    "地域No": "19",
    "地域名": "浜川崎駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "（仮称）川崎アプローチ線",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "（仮称）川崎アプローチ線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "487",
    "地域No": "19",
    "地域名": "浜川崎駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "(仮称)臨海部幹線道路",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "(仮称)臨海部幹線道路",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "488",
    "地域No": "20",
    "地域名": "川崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "川崎駅北口地区第３西街区第一種市街地再開発事業",
    "内閣府No": "1",
    "内閣府プロジェクト名": "川崎駅北口地区第３西街区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "DICE（ダイス）",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H13-15",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "489",
    "地域No": "20",
    "地域名": "川崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "川崎駅西口地区第一種市街地再開発事業",
    "内閣府No": "2",
    "内閣府プロジェクト名": "川崎駅西口地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "ミューザ川崎",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR",
    "事業期間（年度）": "H13-15",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "490",
    "地域No": "20",
    "地域名": "川崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ＣＵＥ　ＰＲＯＪＥＣＴ",
    "内閣府No": "3",
    "内閣府プロジェクト名": "ＣＵＥ　ＰＲＯＪＥＣＴ",
    "内閣府プロジェクト名２": "LA CITTADELLA(ラ　チッタデッラ)",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "チッタ エンタテイメント",
    "事業期間（年度）": "H12-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "491",
    "地域No": "20",
    "地域名": "川崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）川崎駅西口堀川町地区開発事業",
    "内閣府No": "4",
    "内閣府プロジェクト名": "（仮称）川崎駅西口堀川町地区開発事業",
    "内閣府プロジェクト名２": "ラゾーナ川崎",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "三井不動産、東芝不動産",
    "事業期間（年度）": "H16-18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "492",
    "地域No": "20",
    "地域名": "川崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "川崎駅西口大宮町地区Ｅ－１街区",
    "内閣府No": "5",
    "内閣府プロジェクト名": "川崎駅西口大宮町地区Ｅ－１街区",
    "内閣府プロジェクト名２": "ブリリアタワー川崎",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東京建物、JR東日本都市開発ほか",
    "事業期間（年度）": "H18-20",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "493",
    "地域No": "20",
    "地域名": "川崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "中幸町マンション計画",
    "内閣府No": "6",
    "内閣府プロジェクト名": "中幸町マンション計画",
    "内閣府プロジェクト名２": "クレッセント川崎タワー",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "モリモト",
    "事業期間（年度）": "H18-20",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "494",
    "地域No": "20",
    "地域名": "川崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）中幸町３丁目再開発計画",
    "内閣府No": "7",
    "内閣府プロジェクト名": "（仮称）中幸町３丁目再開発計画",
    "内閣府プロジェクト名２": "サンクタス川崎タワー",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "オリックス不動産",
    "事業期間（年度）": "H21-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "495",
    "地域No": "20",
    "地域名": "川崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "川崎駅西口大宮町地区Ｆ街区",
    "内閣府No": "8",
    "内閣府プロジェクト名": "川崎駅西口大宮町地区Ｆ街区",
    "内閣府プロジェクト名２": "川崎幸病院・川崎ゲートタワー",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "石心会、川崎市住宅供給公社",
    "事業期間（年度）": "H21-24",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "496",
    "地域No": "20",
    "地域名": "川崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "川崎駅北口第２街区１０番地地区",
    "内閣府No": "9",
    "内閣府プロジェクト名": "川崎駅北口第２街区１０番地地区",
    "内閣府プロジェクト名２": "クリエ川崎",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "マンション建替組合",
    "事業期間（年度）": "H21-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "497",
    "地域No": "20",
    "地域名": "川崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "川崎駅北口第２街区１１番地地区",
    "内閣府No": "10",
    "内閣府プロジェクト名": "川崎駅北口第２街区１１番地地区",
    "内閣府プロジェクト名２": "川崎フロンティアビル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "川崎商工会議所、鹿島建設",
    "事業期間（年度）": "H22-24",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "498",
    "地域No": "20",
    "地域名": "川崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）ラゾーナ川崎Ｃ地区開発計画",
    "内閣府No": "11",
    "内閣府プロジェクト名": "（仮称）ラゾーナ川崎Ｃ地区開発計画",
    "内閣府プロジェクト名２": "ラゾーナ川崎東芝ビル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "NREG東芝不動産",
    "事業期間（年度）": "H23-24",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "499",
    "地域No": "20",
    "地域名": "川崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）キヤノン柳町プロジェクト",
    "内閣府No": "12",
    "内閣府プロジェクト名": "（仮称）キヤノン柳町プロジェクト",
    "内閣府プロジェクト名２": "キヤノン川崎事業所",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "キヤノン",
    "事業期間（年度）": "H18-R10",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "500",
    "地域No": "20",
    "地域名": "川崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "京急川崎駅東街区優良建築物等整備事業",
    "内閣府No": "13",
    "内閣府プロジェクト名": "京急川崎駅東街区優良建築物等整備事業",
    "内閣府プロジェクト名２": "京急川崎駅ビル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "京浜急行電鉄",
    "事業期間（年度）": "H26-27",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "501",
    "地域No": "20",
    "地域名": "川崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "川崎駅西口開発計画",
    "内閣府No": "14",
    "内閣府プロジェクト名": "川崎駅西口開発計画",
    "内閣府プロジェクト名２": "川崎デルタ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "JR東日本",
    "事業期間（年度）": "H30-R3",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "502",
    "地域No": "20",
    "地域名": "川崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "川崎駅東口駅前地区A地区",
    "内閣府No": "15",
    "内閣府プロジェクト名": "川崎駅東口駅前地区A地区",
    "内閣府プロジェクト名２": "川崎ゼロゲート",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "アエル",
    "事業期間（年度）": "H30-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "503",
    "地域No": "20",
    "地域名": "川崎駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "川崎駅北口地区第２街区１０番地地区（１０番館ビル）",
    "内閣府No": "16",
    "内閣府プロジェクト名": "川崎駅北口地区第２街区１０番地地区（１０番館ビル）",
    "内閣府プロジェクト名２": "（仮称）MEFULL（ミーフル）川崎",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "野村不動産",
    "事業期間（年度）": "R2-4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "504",
    "地域No": "20",
    "地域名": "川崎駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "川崎都市計画道路3･4･27川崎駅西口線",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "川崎都市計画道路3･4･27川崎駅西口線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H17-19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "505",
    "地域No": "20",
    "地域名": "川崎駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "（仮称）大宮中幸町線",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "（仮称）大宮中幸町線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H14-18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "506",
    "地域No": "20",
    "地域名": "川崎駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "川崎都市計画3・3・9川崎町田線",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "川崎都市計画3・3・9川崎町田線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H20-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "507",
    "地域No": "20",
    "地域名": "川崎駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "川崎都市計画3・3・2川崎駅東扇島線",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "川崎都市計画3・3・2川崎駅東扇島線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H21-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "508",
    "地域No": "20",
    "地域名": "川崎駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "川崎駅東西連絡歩道橋",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "川崎駅東西連絡歩道橋",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H21-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "509",
    "地域No": "20",
    "地域名": "川崎駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "川崎駅北口自由通路",
    "内閣府No": "カ",
    "内閣府プロジェクト名": "川崎駅北口自由通路",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H24-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "510",
    "地域No": "20",
    "地域名": "川崎駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "堀川町Ｃ地区連絡ペデストリアンデッキ",
    "内閣府No": "キ",
    "内閣府プロジェクト名": "堀川町Ｃ地区連絡ペデストリアンデッキ",
    "内閣府プロジェクト名２": "川崎駅西口駅前ﾍﾟﾃﾞｽﾄﾘｱﾝﾃﾞｯｷ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H28-29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "511",
    "地域No": "21",
    "地域名": "相模原橋本駅周辺・相模原駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "橋本６丁目Ｄ地区優良建築物等整備事業",
    "内閣府No": "1",
    "内閣府プロジェクト名": "橋本６丁目Ｄ地区優良建築物等整備事業",
    "内閣府プロジェクト名２": "ザ・ハシモトタワー",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "建築物建設組合",
    "事業期間（年度）": "H17-19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "512",
    "地域No": "21",
    "地域名": "相模原橋本駅周辺・相模原駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "日本金属工業相模原事業所跡地開発事業",
    "内閣府No": "2",
    "内閣府プロジェクト名": "日本金属工業相模原事業所跡地開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "日本金属工業、イトーヨーカ堂、三菱地所、メックプロパティ、藤和不動産",
    "事業期間（年度）": "H19-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "513",
    "地域No": "21",
    "地域名": "相模原橋本駅周辺・相模原駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "日本金属工業相模原事業所跡地開発事業　西－１",
    "内閣府No": "2-1",
    "内閣府プロジェクト名": "日本金属工業相模原事業所跡地開発事業　西－１",
    "内閣府プロジェクト名２": "アリオ橋本",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "イトーヨーカ堂",
    "事業期間（年度）": "H21-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "514",
    "地域No": "21",
    "地域名": "相模原橋本駅周辺・相模原駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "日本金属工業相模原事業所跡地開発事業　西－２",
    "内閣府No": "2-2",
    "内閣府プロジェクト名": "日本金属工業相模原事業所跡地開発事業　西－２",
    "内閣府プロジェクト名２": "ミッドオアシスタワーズ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "三菱地所、藤和不動産",
    "事業期間（年度）": "H20-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "515",
    "地域No": "21",
    "地域名": "相模原橋本駅周辺・相模原駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "橋本６丁目２４番地区優良建築物等整備事業",
    "内閣府No": "3",
    "内閣府プロジェクト名": "橋本６丁目２４番地区優良建築物等整備事業",
    "内閣府プロジェクト名２": "プラウド橋本",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "共同ビル建設組合",
    "事業期間（年度）": "H20-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "516",
    "地域No": "21",
    "地域名": "相模原橋本駅周辺・相模原駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "相模原都市計画公園事業３･３･４号小山公園",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "相模原都市計画公園事業３･３･４号小山公園",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H16-18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "517",
    "地域No": "21",
    "地域名": "相模原橋本駅周辺・相模原駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "都市計画道路大山氷川線",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "都市計画道路大山氷川線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "518",
    "地域No": "21",
    "地域名": "相模原橋本駅周辺・相模原駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "都市計画道路東橋本大山線",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "都市計画道路東橋本大山線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "519",
    "地域No": "21",
    "地域名": "相模原橋本駅周辺・相模原駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "市道　南橋本大山",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "市道　南橋本大山",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "520",
    "地域No": "21",
    "地域名": "相模原橋本駅周辺・相模原駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "市道　大山1号",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "市道　大山1号",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "521",
    "地域No": "21",
    "地域名": "相模原橋本駅周辺・相模原駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "小山公園前跨線橋",
    "内閣府No": "カ",
    "内閣府プロジェクト名": "小山公園前跨線橋",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H19-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "522",
    "地域No": "21",
    "地域名": "相模原橋本駅周辺・相模原駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "橋本小山ふれあい立体",
    "内閣府No": "キ",
    "内閣府プロジェクト名": "橋本小山ふれあい立体",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H19-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "523",
    "地域No": "21",
    "地域名": "相模原橋本駅周辺・相模原駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "大山町ゆうひ公園",
    "内閣府No": "ク",
    "内閣府プロジェクト名": "大山町ゆうひ公園",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "524",
    "地域No": "21",
    "地域名": "相模原橋本駅周辺・相模原駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "大山町あさひ公園",
    "内閣府No": "ケ",
    "内閣府プロジェクト名": "大山町あさひ公園",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "525",
    "地域No": "21",
    "地域名": "相模原橋本駅周辺・相模原駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "リニア中央新幹線",
    "内閣府No": "コ",
    "内閣府プロジェクト名": "リニア中央新幹線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H27-R9",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "526",
    "地域No": "21",
    "地域名": "相模原橋本駅周辺・相模原駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "（仮）相模原駅北口南北線",
    "内閣府No": "サ",
    "内閣府プロジェクト名": "（仮）相模原駅北口南北線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "527",
    "地域No": "21",
    "地域名": "相模原橋本駅周辺・相模原駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "（仮）相模原駅北口東西線",
    "内閣府No": "シ",
    "内閣府プロジェクト名": "（仮）相模原駅北口東西線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "528",
    "地域No": "22",
    "地域名": "本厚木駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "中町第２－２地区周辺",
    "内閣府No": "1",
    "内閣府プロジェクト名": "中町第２－２地区周辺",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "●（太陽光発電等）",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "529",
    "地域No": "22",
    "地域名": "本厚木駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "本厚木駅南口地区",
    "内閣府No": "2",
    "内閣府プロジェクト名": "本厚木駅南口地区",
    "内閣府プロジェクト名２": "本厚木ミハラス",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H29-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "530",
    "地域No": "22",
    "地域名": "本厚木駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）あつぎ元気館",
    "内閣府No": "3",
    "内閣府プロジェクト名": "（仮称）あつぎ元気館",
    "内閣府プロジェクト名２": "アミューあつぎ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "厚木市",
    "事業期間（年度）": "H25",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "531",
    "地域No": "22",
    "地域名": "本厚木駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "厚木バスセンター",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "厚木バスセンター",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R8-未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "532",
    "地域No": "23",
    "地域名": "新潟都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "西堀通5番町地区市街地再開発事業",
    "内閣府No": "1",
    "内閣府プロジェクト名": "西堀通5番町地区市街地再開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "●",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "533",
    "地域No": "23",
    "地域名": "新潟都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "古町通7番町地区第一種市街地再開発事業",
    "内閣府No": "2",
    "内閣府プロジェクト名": "古町通7番町地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H29-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "534",
    "地域No": "23",
    "地域名": "新潟都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "旧新潟運輸総合庁舎跡地活用",
    "内閣府No": "3",
    "内閣府プロジェクト名": "旧新潟運輸総合庁舎跡地活用",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "535",
    "地域No": "23",
    "地域名": "新潟都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "万代2丁目地区開発計画",
    "内閣府No": "4",
    "内閣府プロジェクト名": "万代2丁目地区開発計画",
    "内閣府プロジェクト名２": "ザ・サーパスタワー新潟万代シテイ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "穴吹工務店",
    "事業期間（年度）": "R3-6",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "536",
    "地域No": "23",
    "地域名": "新潟都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "万代5丁目地区優良建築物等整備事業",
    "内閣府No": "5",
    "内閣府プロジェクト名": "万代5丁目地区優良建築物等整備事業",
    "内閣府プロジェクト名２": "アパホテル＆リゾート〈新潟駅前大通〉",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "アパホーム",
    "事業期間（年度）": "R2-4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "537",
    "地域No": "23",
    "地域名": "新潟都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "日本生命新潟ビル",
    "内閣府No": "6",
    "内閣府プロジェクト名": "日本生命新潟ビル",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "日本生命",
    "事業期間（年度）": "R2-4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "538",
    "地域No": "23",
    "地域名": "新潟都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）新潟帝石ビルディング建替えプロジェクト",
    "内閣府No": "7",
    "内閣府プロジェクト名": "（仮称）新潟帝石ビルディング建替えプロジェクト",
    "内閣府プロジェクト名２": "INPEX新潟ビルディング",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ＩＮＰＥＸビジネスサービス",
    "事業期間（年度）": "R4-未定",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "539",
    "地域No": "23",
    "地域名": "新潟都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "日生不動産新潟駅前ビル",
    "内閣府No": "8",
    "内閣府プロジェクト名": "日生不動産新潟駅前ビル",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "日生ホールディングス",
    "事業期間（年度）": "R3-4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "540",
    "地域No": "23",
    "地域名": "新潟都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "八千代1丁目地区開発計画",
    "内閣府No": "9",
    "内閣府プロジェクト名": "八千代1丁目地区開発計画",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "非公表",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "541",
    "地域No": "23",
    "地域名": "新潟都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "JR東日本新潟支社",
    "内閣府No": "10",
    "内閣府プロジェクト名": "JR東日本新潟支社",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "JR東日本",
    "事業期間（年度）": "H30-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "542",
    "地域No": "23",
    "地域名": "新潟都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "新潟駅南口西地区優良建築物等整備事業",
    "内閣府No": "11",
    "内閣府プロジェクト名": "新潟駅南口西地区優良建築物等整備事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "共同企業体",
    "事業期間（年度）": "R4-7",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "543",
    "地域No": "23",
    "地域名": "新潟都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "マルタケビル",
    "内閣府No": "12",
    "内閣府プロジェクト名": "マルタケビル",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "マルタケビル",
    "事業期間（年度）": "H29-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "544",
    "地域No": "23",
    "地域名": "新潟都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "新潟駅付近連続立体交差事業",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "新潟駅付近連続立体交差事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H20-R7",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "●",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "545",
    "地域No": "23",
    "地域名": "新潟都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "新潟駅万代広場整備事業",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "新潟駅万代広場整備事業",
    "内閣府プロジェクト名２": "万代広場",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R1-8",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "546",
    "地域No": "23",
    "地域名": "新潟都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "新潟駅高架下交通広場整備事業",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "新潟駅高架下交通広場整備事業",
    "内閣府プロジェクト名２": "駅直下バスターミナル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H29-R6",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "●（駐輪場）",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "547",
    "地域No": "23",
    "地域名": "新潟都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "一般国道７号　新潟駅交通ターミナル整備事業",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "一般国道７号　新潟駅交通ターミナル整備事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "548",
    "地域No": "23",
    "地域名": "新潟都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "（都）新潟駅西線",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "（都）新潟駅西線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H21-R17",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "●",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "549",
    "地域No": "23",
    "地域名": "新潟都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "鳥屋野・万代・下所島排水区 大規模雨水処理施設整備事業",
    "内閣府No": "カ",
    "内閣府プロジェクト名": "鳥屋野・万代・下所島排水区 大規模雨水処理施設整備事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R2-8",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "550",
    "地域No": "23",
    "地域名": "新潟都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "万代島平面駐車場立体化・商業施設等誘致検討（A）",
    "内閣府No": "キ",
    "内閣府プロジェクト名": "万代島平面駐車場立体化・商業施設等誘致検討（A）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "551",
    "地域No": "23",
    "地域名": "新潟都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "万代島港湾緑地・商業施設等誘致検討",
    "内閣府No": "ク",
    "内閣府プロジェクト名": "万代島港湾緑地・商業施設等誘致検討",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "552",
    "地域No": "23",
    "地域名": "新潟都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "万代島平面駐車場立体化・商業施設等誘致検討（D）",
    "内閣府No": "ケ",
    "内閣府プロジェクト名": "万代島平面駐車場立体化・商業施設等誘致検討（D）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "553",
    "地域No": "24",
    "地域名": "福井駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "福井駅前電車通り北地区A街区第一種市街地再開発事業",
    "内閣府No": "1",
    "内閣府プロジェクト名": "福井駅前電車通り北地区A街区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "R3-6",
    "状況": "事業中",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "554",
    "地域No": "24",
    "地域名": "福井駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "福井駅前電車通り北地区B街区第一種市街地再開発事業",
    "内閣府No": "2",
    "内閣府プロジェクト名": "福井駅前電車通り北地区B街区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "R4-6",
    "状況": "事業中",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "555",
    "地域No": "24",
    "地域名": "福井駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "福井駅前南通り地区第一種市街地再開発事業",
    "内閣府No": "3",
    "内閣府プロジェクト名": "福井駅前南通り地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合（予定）",
    "事業期間（年度）": "R5-7",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "556",
    "地域No": "24",
    "地域名": "福井駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "中央１丁目１０番地地区優良建築物等整備事業",
    "内閣府No": "4",
    "内閣府プロジェクト名": "中央１丁目１０番地地区優良建築物等整備事業",
    "内閣府プロジェクト名２": "デュオヒルズ福井駅前　他",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "元町開発",
    "事業期間（年度）": "H30-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "557",
    "地域No": "24",
    "地域名": "福井駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "中央１丁目18番地区優良建築物等整備事業",
    "内閣府No": "5",
    "内閣府プロジェクト名": "中央１丁目18番地区優良建築物等整備事業",
    "内閣府プロジェクト名２": "ドーミーイン福井",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "加藤ビル",
    "事業期間（年度）": "H29-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "558",
    "地域No": "24",
    "地域名": "福井駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "福井駅付近連続立体交差事業",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "福井駅付近連続立体交差事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H8-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "559",
    "地域No": "24",
    "地域名": "福井駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "福井駅周辺土地区画整理事業",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "福井駅周辺土地区画整理事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H12-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "560",
    "地域No": "24",
    "地域名": "福井駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "北陸新幹線（金沢・敦賀間）",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "北陸新幹線（金沢・敦賀間）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H24-R5",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "561",
    "地域No": "24",
    "地域名": "福井駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "福井市中央公園再整備事業",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "福井市中央公園再整備事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H26-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "562",
    "地域No": "24",
    "地域名": "福井駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "福井城址周辺整備事業",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "福井城址周辺整備事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H29-R6",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "563",
    "地域No": "25",
    "地域名": "岐阜駅北・柳ヶ瀬通周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "吉野町５丁目東地区第1種市街地再開発事業",
    "内閣府No": "1",
    "内閣府プロジェクト名": "吉野町５丁目東地区第1種市街地再開発事業",
    "内閣府プロジェクト名２": "大岐阜ビル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H15-17",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "564",
    "地域No": "25",
    "地域名": "岐阜駅北・柳ヶ瀬通周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "岐阜駅西地区第1種市街地再開発事業",
    "内閣府No": "2",
    "内閣府プロジェクト名": "岐阜駅西地区第1種市街地再開発事業",
    "内閣府プロジェクト名２": "岐阜シティ・タワー43",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H16-19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "565",
    "地域No": "25",
    "地域名": "岐阜駅北・柳ヶ瀬通周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "問屋町西部南街区第1種市街地再開発事業",
    "内閣府No": "3",
    "内閣府プロジェクト名": "問屋町西部南街区第1種市街地再開発事業",
    "内閣府プロジェクト名２": "岐阜スカイウイング37",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H22-24",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "566",
    "地域No": "25",
    "地域名": "岐阜駅北・柳ヶ瀬通周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "問屋町西部北街区第1種市街地再開発事業",
    "内閣府No": "4",
    "内閣府プロジェクト名": "問屋町西部北街区第1種市街地再開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "567",
    "地域No": "25",
    "地域名": "岐阜駅北・柳ヶ瀬通周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "岐阜駅東地区第1種市街地再開発事業",
    "内閣府No": "5",
    "内閣府プロジェクト名": "岐阜駅東地区第1種市街地再開発事業",
    "内閣府プロジェクト名２": "岐阜イーストライジング24",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H27-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "568",
    "地域No": "25",
    "地域名": "岐阜駅北・柳ヶ瀬通周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "問屋町第一地区第1種市街地再開発事業",
    "内閣府No": "6",
    "内閣府プロジェクト名": "問屋町第一地区第1種市街地再開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "569",
    "地域No": "25",
    "地域名": "岐阜駅北・柳ヶ瀬通周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "高島屋南地区第1種市街地再開発事業",
    "内閣府No": "7",
    "内閣府プロジェクト名": "高島屋南地区第1種市街地再開発事業",
    "内閣府プロジェクト名２": "柳ケ瀬グラッスル35",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H30-R4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "570",
    "地域No": "25",
    "地域名": "岐阜駅北・柳ヶ瀬通周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "柳ケ瀬通北地区第1種市街地再開発事業",
    "内閣府No": "8",
    "内閣府プロジェクト名": "柳ケ瀬通北地区第1種市街地再開発事業",
    "内閣府プロジェクト名２": "オアシス柳ケ瀬ビル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H22-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "571",
    "地域No": "25",
    "地域名": "岐阜駅北・柳ヶ瀬通周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "岐阜駅北中央東地区第1種市街地再開発事業",
    "内閣府No": "9",
    "内閣府プロジェクト名": "岐阜駅北中央東地区第1種市街地再開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "572",
    "地域No": "25",
    "地域名": "岐阜駅北・柳ヶ瀬通周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "岐阜駅北中央西地区第1種市街地再開発事業",
    "内閣府No": "10",
    "内閣府プロジェクト名": "岐阜駅北中央西地区第1種市街地再開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "573",
    "地域No": "25",
    "地域名": "岐阜駅北・柳ヶ瀬通周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "岐阜駅北口土地区画整理事業",
    "内閣府No": "11",
    "内閣府プロジェクト名": "岐阜駅北口土地区画整理事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "岐阜市",
    "事業期間（年度）": "H14-27",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "574",
    "地域No": "25",
    "地域名": "岐阜駅北・柳ヶ瀬通周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "日ノ出町２丁目地区都市再生事業",
    "内閣府No": "12",
    "内閣府プロジェクト名": "日ノ出町２丁目地区都市再生事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "平和ビル",
    "事業期間（年度）": "H16-17",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "575",
    "地域No": "25",
    "地域名": "岐阜駅北・柳ヶ瀬通周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "岐阜駅北口駅前広場",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "岐阜駅北口駅前広場",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H16-21",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "576",
    "地域No": "25",
    "地域名": "岐阜駅北・柳ヶ瀬通周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "歩行者用デッキ",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "歩行者用デッキ",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H15-未定",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "●",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "577",
    "地域No": "25",
    "地域名": "岐阜駅北・柳ヶ瀬通周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "3･3･20岐阜駅城田寺線",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "3･3･20岐阜駅城田寺線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H15-20",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "578",
    "地域No": "25",
    "地域名": "岐阜駅北・柳ヶ瀬通周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "3･5･30岐阜駅柳津線",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "3･5･30岐阜駅柳津線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H7-16",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "579",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "牛島南第一種市街地再開発事業",
    "内閣府No": "1",
    "内閣府プロジェクト名": "牛島南第一種市街地再開発事業",
    "内閣府プロジェクト名２": "名古屋ルーセントタワー",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H13-18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "580",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "納屋橋西第一種市街地再開発事業",
    "内閣府No": "2",
    "内閣府プロジェクト名": "納屋橋西第一種市街地再開発事業",
    "内閣府プロジェクト名２": "アクアタウン納屋橋",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR",
    "事業期間（年度）": "H16-18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "581",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "栄四丁目",
    "内閣府No": "3",
    "内閣府プロジェクト名": "栄四丁目",
    "内閣府プロジェクト名２": "名古屋広小路プレイス",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "SPC",
    "事業期間（年度）": "H15-16",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "582",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "東桜一丁目1番地区",
    "内閣府No": "4",
    "内閣府プロジェクト名": "東桜一丁目1番地区",
    "内閣府プロジェクト名２": "アーバンネット名古屋ネクスタビル",
    "特定地域整備計画No": "⑧",
    "特定地域整備計画名": "東桜一丁目1番地区建設事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "エヌ・ティ・ティ都市開発",
    "事業期間（年度）": "H31-R3",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "583",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "名古屋伏見プロジェクト",
    "内閣府No": "5",
    "内閣府プロジェクト名": "名古屋伏見プロジェクト",
    "内閣府プロジェクト名２": "名古屋インターシティ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "SPC",
    "事業期間（年度）": "H18-20",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "584",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "納屋橋東第一種市街地再開発事業",
    "内閣府No": "6",
    "内閣府プロジェクト名": "納屋橋東第一種市街地再開発事業",
    "内閣府プロジェクト名２": "テラッセ納屋橋",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H26-29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "585",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "栄三丁目30番地区優良建築物等整備事業",
    "内閣府No": "7",
    "内閣府プロジェクト名": "栄三丁目30番地区優良建築物等整備事業",
    "内閣府プロジェクト名２": "松坂屋南館増床分",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "松坂屋ほか",
    "事業期間（年度）": "H13-15",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "586",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "栄三丁目6番地区市街地再開発事業",
    "内閣府No": "8",
    "内閣府プロジェクト名": "栄三丁目6番地区市街地再開発事業",
    "内閣府プロジェクト名２": "ラシック",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H14-16",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "587",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "名駅四丁目7番地区優良建築物等整備事業",
    "内閣府No": "9",
    "内閣府プロジェクト名": "名駅四丁目7番地区優良建築物等整備事業",
    "内閣府プロジェクト名２": "ミッドランドスクエア",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東和不動産、トヨタ自動車、毎日新聞社",
    "事業期間（年度）": "H15-18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "588",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "名駅四丁目27番地区優良建築物等整備事業",
    "内閣府No": "10",
    "内閣府プロジェクト名": "名駅四丁目27番地区優良建築物等整備事業",
    "内閣府プロジェクト名２": "モード学園スパイラルタワーズ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "モード学園、三井不動産",
    "事業期間（年度）": "H17-19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "589",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "愛知県産業労働センター整備・運営事業",
    "内閣府No": "11",
    "内閣府プロジェクト名": "愛知県産業労働センター整備・運営事業",
    "内閣府プロジェクト名２": "ウインクあいち",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "愛知県",
    "事業期間（年度）": "H19-21",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "590",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "名古屋ビルディング",
    "内閣府No": "12",
    "内閣府プロジェクト名": "名古屋ビルディング",
    "内閣府プロジェクト名２": "名古屋ビルディング",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "名古屋ビルディング",
    "事業期間（年度）": "H18-20",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "591",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ささしまライブ２４土地区画整理事業",
    "内閣府No": "13",
    "内閣府プロジェクト名": "ささしまライブ２４土地区画整理事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○ア",
    "特定地域整備計画名": "名古屋都市計画事業ささしまライブ24土地区画整理事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "名古屋市",
    "事業期間（年度）": "H11-R7",
    "状況": "事業中",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "●",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "592",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "グローバルゲート建設事業",
    "内閣府No": "13-1",
    "内閣府プロジェクト名": "グローバルゲート建設事業",
    "内閣府プロジェクト名２": "グローバルゲート",
    "特定地域整備計画No": "①",
    "特定地域整備計画名": "グローバルゲート建設事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "SPC",
    "事業期間（年度）": "H26-29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "593",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "愛知大学新名古屋校舎建設事業",
    "内閣府No": "13-2",
    "内閣府プロジェクト名": "愛知大学新名古屋校舎建設事業",
    "内閣府プロジェクト名２": "愛知大学名古屋キャンパス",
    "特定地域整備計画No": "②",
    "特定地域整備計画名": "愛知大学名古屋校舎建設事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "愛知大学",
    "事業期間（年度）": "H24-29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "594",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "中京テレビ放送㈱本社ビル建設事業",
    "内閣府No": "13-3",
    "内閣府プロジェクト名": "中京テレビ放送㈱本社ビル建設事業",
    "内閣府プロジェクト名２": "中京テレビ放送株式会社本社ビル",
    "特定地域整備計画No": "③",
    "特定地域整備計画名": "中京テレビ放送株式会社本社ビル建設事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "中京テレビ放送",
    "事業期間（年度）": "H26-27",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "595",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ロイヤルパークスERささしま",
    "内閣府No": "13-4",
    "内閣府プロジェクト名": "ロイヤルパークスERささしま",
    "内閣府プロジェクト名２": "ロイヤルパークスERささしま",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "大和ハウス工業",
    "事業期間（年度）": "H25-26",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "596",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "名駅四丁目４番南地区優良建築物等整備事業",
    "内閣府No": "14",
    "内閣府プロジェクト名": "名駅四丁目４番南地区優良建築物等整備事業",
    "内閣府プロジェクト名２": "名古屋クロスコートタワー",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "中部経済新聞社、名古屋鉄道、東和不動産",
    "事業期間（年度）": "H22-24",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "597",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "名駅一丁目１番計画北地区（仮称）建設事業",
    "内閣府No": "15",
    "内閣府プロジェクト名": "名駅一丁目１番計画北地区（仮称）建設事業",
    "内閣府プロジェクト名２": "ＪＰタワー名古屋",
    "特定地域整備計画No": "④",
    "特定地域整備計画名": "JPタワー名古屋建設事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "日本郵便、名工建設",
    "事業期間（年度）": "H25-27",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "598",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "名駅一丁目１番計画南地区（仮称）建設事業",
    "内閣府No": "16",
    "内閣府プロジェクト名": "名駅一丁目１番計画南地区（仮称）建設事業",
    "内閣府プロジェクト名２": "ＪＲゲートタワー",
    "特定地域整備計画No": "⑤",
    "特定地域整備計画名": "JRゲートタワー建設事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "JR東海、ジェイアールセントラルビル",
    "事業期間（年度）": "H24-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "599",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "名駅三丁目27番地区建設事業",
    "内閣府No": "17",
    "内閣府プロジェクト名": "名駅三丁目27番地区建設事業",
    "内閣府プロジェクト名２": "大名古屋ビルヂング",
    "特定地域整備計画No": "⑥",
    "特定地域整備計画名": "大名古屋ビルヂング建設事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "三菱地所",
    "事業期間（年度）": "H25-27",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "600",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "名駅四丁目10番地区建設事業",
    "内閣府No": "18",
    "内閣府プロジェクト名": "名駅四丁目10番地区建設事業",
    "内閣府プロジェクト名２": "シンフォニー豊田ビル",
    "特定地域整備計画No": "⑦",
    "特定地域整備計画名": "シンフォニー豊田ビル建設事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東和不動産",
    "事業期間（年度）": "H26-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "601",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "名鉄名駅再開発計画",
    "内閣府No": "19",
    "内閣府プロジェクト名": "名鉄名駅再開発計画",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "602",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "錦三丁目25番地区",
    "内閣府No": "20",
    "内閣府プロジェクト名": "錦三丁目25番地区",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "三菱地所、日本郵政不動産、明治安田生命、中日新聞社、パルコ",
    "事業期間（年度）": "R4-8",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "●",
    "税制支援（都市再生）": "●",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "603",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "丸栄・栄町ビル等",
    "内閣府No": "21",
    "内閣府プロジェクト名": "丸栄・栄町ビル等",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "604",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "錦二丁目20番地区",
    "内閣府No": "22",
    "内閣府プロジェクト名": "錦二丁目20番地区",
    "内閣府プロジェクト名２": "広小路クロスタワー・旧名古屋銀行本店ビル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "SPC、積水ハウス",
    "事業期間（年度）": "H27-29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "605",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ノリタケの森地区",
    "内閣府No": "23",
    "内閣府プロジェクト名": "ノリタケの森地区",
    "内閣府プロジェクト名２": "イオンモール Nagoya Noritake Garden・ザ・パークハウス名古屋",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ノリタケカンパニーリミテド、三菱商事、イオンモール、三菱地所レジデンス",
    "事業期間（年度）": "R1-4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "606",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "シティタワー名古屋　久屋大通公園",
    "内閣府No": "24",
    "内閣府プロジェクト名": "シティタワー名古屋　久屋大通公園",
    "内閣府プロジェクト名２": "シティタワー名古屋　久屋大通公園",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "住友不動産",
    "事業期間（年度）": "H23-24",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "607",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "栄一丁目６番地区優良建築物等整備事業",
    "内閣府No": "25",
    "内閣府プロジェクト名": "栄一丁目６番地区優良建築物等整備事業",
    "内閣府プロジェクト名２": "御園座タワー",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "積水ハウス",
    "事業期間（年度）": "H26-29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "608",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "錦三丁目16番",
    "内閣府No": "26",
    "内閣府プロジェクト名": "錦三丁目16番",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "609",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "名古屋ゼロゲート",
    "内閣府No": "27",
    "内閣府プロジェクト名": "名古屋ゼロゲート",
    "内閣府プロジェクト名２": "名古屋ゼロゲート",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H25-26",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "610",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "錦二丁目７番地区",
    "内閣府No": "28",
    "内閣府プロジェクト名": "錦二丁目７番地区",
    "内閣府プロジェクト名２": "プラウドタワー名古屋錦",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H30-R3",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "611",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "栄四丁目1番地区",
    "内閣府No": "29",
    "内閣府プロジェクト名": "栄四丁目1番地区",
    "内閣府プロジェクト名２": "中日ビル",
    "特定地域整備計画No": "⑨",
    "特定地域整備計画名": "栄四丁目1番地区建設事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "中部日本ビルディング",
    "事業期間（年度）": "R2-6",
    "状況": "事業中",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "●",
    "税制支援（都市再生）": "●",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "612",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "椿町線（都市計画道路）",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "椿町線（都市計画道路）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○ウ",
    "特定地域整備計画名": "名古屋都市計画道路事業３・３・１４号椿町線",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "名古屋市",
    "事業期間（年度）": "H12-29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "613",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "地区幹線道路（牛島南再開発地区計画における2号施設）",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "地区幹線道路（牛島南再開発地区計画における2号施設）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H16-18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "614",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "地下歩行者通路（牛島南再開発地区計画における2号施設）",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "地下歩行者通路（牛島南再開発地区計画における2号施設）",
    "内閣府プロジェクト名２": "ルーセントアべニュー",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H16-18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "615",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "広場（牛島南再開発地区計画における地区施設）",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "広場（牛島南再開発地区計画における地区施設）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H16-18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "616",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "歩道（名駅四丁目地区都市再開発事業計画における公共施設）",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "歩道（名駅四丁目地区都市再開発事業計画における公共施設）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "617",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "地下通路（名駅四丁目27番地区都市再生事業計画における公共施設）",
    "内閣府No": "カ",
    "内閣府プロジェクト名": "地下通路（名駅四丁目27番地区都市再生事業計画における公共施設）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H17-19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "618",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "地下公共空間（名古屋駅周辺地下公共空間整備）",
    "内閣府No": "キ",
    "内閣府プロジェクト名": "地下公共空間（名古屋駅周辺地下公共空間整備）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○イ",
    "特定地域整備計画名": "名古屋駅周辺地下公共空間整備",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "名古屋市",
    "事業期間（年度）": "R6-未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "●",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "619",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "久屋大通の再生",
    "内閣府No": "ク",
    "内閣府プロジェクト名": "久屋大通の再生",
    "内閣府プロジェクト名２": "ヒサヤオオドオリパーク",
    "特定地域整備計画No": "○エ",
    "特定地域整備計画名": "久屋大通の再生",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "名古屋市",
    "事業期間（年度）": "H30-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "620",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "テレビ塔再生事業",
    "内閣府No": "ケ",
    "内閣府プロジェクト名": "テレビ塔再生事業",
    "内閣府プロジェクト名２": "名古屋テレビ塔（中部電力MIRAI TOWER）",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H30-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "621",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "リニア中央新幹線建設事業",
    "内閣府No": "コ",
    "内閣府プロジェクト名": "リニア中央新幹線建設事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H28-R9",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "622",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "リニア中央新幹線関連整備事業",
    "内閣府No": "サ",
    "内閣府プロジェクト名": "リニア中央新幹線関連整備事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "",
    "状況": "",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "623",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "笹島線(東側区間) （都市計画道路）",
    "内閣府No": "ス",
    "内閣府プロジェクト名": "笹島線(東側区間) （都市計画道路）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○カ",
    "特定地域整備計画名": "名古屋都市計画道路事業3・2・208号笹島線（東側区間）",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "名古屋市",
    "事業期間（年度）": "R1-7",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "●",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "624",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "名古屋駅駅前広場の再整備",
    "内閣府No": "セ",
    "内閣府プロジェクト名": "名古屋駅駅前広場の再整備",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○オ",
    "特定地域整備計画名": "名古屋駅駅前広場再整備",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "名古屋市",
    "事業期間（年度）": "R2-未定",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "●",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "●",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "●",
    "その他支援": ""
  },
  {
    "key": "625",
    "地域No": "26",
    "地域名": "【特定】名古屋駅周辺・伏見・栄地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "東西ネットワークの強化（名古屋駅）",
    "内閣府No": "ソ",
    "内閣府プロジェクト名": "東西ネットワークの強化（名古屋駅）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "",
    "状況": "",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "●",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "●",
    "その他支援": ""
  },
  {
    "key": "626",
    "地域No": "27",
    "地域名": "名古屋臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "名古屋港ショッピングモール",
    "内閣府No": "1",
    "内閣府プロジェクト名": "名古屋港ショッピングモール",
    "内閣府プロジェクト名２": "カインズモール名古屋みなと",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "カインズ、アルペン",
    "事業期間（年度）": "H16",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "627",
    "地域No": "27",
    "地域名": "名古屋臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "定期借地権付分譲住宅事業",
    "内閣府No": "2",
    "内閣府プロジェクト名": "定期借地権付分譲住宅事業",
    "内閣府プロジェクト名２": "シティーコーポ野跡",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "名古屋市住宅供給公社",
    "事業期間（年度）": "H16-18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "628",
    "地域No": "27",
    "地域名": "名古屋臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "野跡駅前北街区活用事業",
    "内閣府No": "3",
    "内閣府プロジェクト名": "野跡駅前北街区活用事業",
    "内閣府プロジェクト名２": "名古屋野跡セントグレース大聖堂",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ツカダ・グローバルホールディング",
    "事業期間（年度）": "H20",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "629",
    "地域No": "27",
    "地域名": "名古屋臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "JR東海博物館",
    "内閣府No": "4",
    "内閣府プロジェクト名": "JR東海博物館",
    "内閣府プロジェクト名２": "リニア・鉄道館",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "JR東海",
    "事業期間（年度）": "H21-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "630",
    "地域No": "27",
    "地域名": "名古屋臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "金城ふ頭第1期開発事業",
    "内閣府No": "5",
    "内閣府プロジェクト名": "金城ふ頭第1期開発事業",
    "内閣府プロジェクト名２": "ウェディングアイランド　アンジェローブ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "平安閣",
    "事業期間（年度）": "H17",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "631",
    "地域No": "27",
    "地域名": "名古屋臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "フットサルスタジアム",
    "内閣府No": "6",
    "内閣府プロジェクト名": "フットサルスタジアム",
    "内閣府プロジェクト名２": "武田テバオーシャンアリーナ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "武田テバファーマ",
    "事業期間（年度）": "H18-20",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "632",
    "地域No": "27",
    "地域名": "名古屋臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）港明用地開発事業",
    "内閣府No": "7",
    "内閣府プロジェクト名": "（仮称）港明用地開発事業",
    "内閣府プロジェクト名２": "みなとアクルス",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東邦瓦斯、東邦不動産",
    "事業期間（年度）": "H27-未定",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "633",
    "地域No": "27",
    "地域名": "名古屋臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "名古屋市国際展示場新第1展示館",
    "内閣府No": "8",
    "内閣府プロジェクト名": "名古屋市国際展示場新第1展示館",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "名古屋市",
    "事業期間（年度）": "H31-R4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "634",
    "地域No": "27",
    "地域名": "名古屋臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "LEGOLAND® Japan",
    "内閣府No": "9",
    "内閣府プロジェクト名": "LEGOLAND® Japan",
    "内閣府プロジェクト名２": "レゴランド・ジャパン",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "LEGOLAND®Japan",
    "事業期間（年度）": "H27-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "635",
    "地域No": "27",
    "地域名": "名古屋臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "LEGOLAND® Japan（拡張）",
    "内閣府No": "10",
    "内閣府プロジェクト名": "LEGOLAND® Japan（拡張）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "マーリン・エンタテイメンツ・グループ・リミテッド",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "636",
    "地域No": "27",
    "地域名": "名古屋臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "金城ふ頭駐車場",
    "内閣府No": "11",
    "内閣府プロジェクト名": "金城ふ頭駐車場",
    "内閣府プロジェクト名２": "名古屋市営金城ふ頭駐車場",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "名古屋市",
    "事業期間（年度）": "H27-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "637",
    "地域No": "27",
    "地域名": "名古屋臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "商業施設",
    "内閣府No": "12",
    "内閣府プロジェクト名": "商業施設",
    "内閣府プロジェクト名２": "Maker's Pier",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "GCDS社、矢作地所",
    "事業期間（年度）": "H28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "638",
    "地域No": "27",
    "地域名": "名古屋臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "LEGOLAND® Japan Hotel",
    "内閣府No": "13",
    "内閣府プロジェクト名": "LEGOLAND® Japan Hotel",
    "内閣府プロジェクト名２": "レゴランド・ジャパン・ホテル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "LEGOLAND®Japan",
    "事業期間（年度）": "H28-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "639",
    "地域No": "27",
    "地域名": "名古屋臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ホテル",
    "内閣府No": "14",
    "内閣府プロジェクト名": "ホテル",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "640",
    "地域No": "27",
    "地域名": "名古屋臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "名古屋市国際展示場コンベンション施設",
    "内閣府No": "15",
    "内閣府プロジェクト名": "名古屋市国際展示場コンベンション施設",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "名古屋市",
    "事業期間（年度）": "R2-4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "641",
    "地域No": "27",
    "地域名": "名古屋臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "「稲永・鴨浦地区」野跡駅前広場",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "「稲永・鴨浦地区」野跡駅前広場",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H16",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "642",
    "地域No": "27",
    "地域名": "名古屋臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "「稲永・鴨浦地区」稲永公園連絡遊歩道",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "「稲永・鴨浦地区」稲永公園連絡遊歩道",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H16",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "643",
    "地域No": "27",
    "地域名": "名古屋臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "「金城ふ頭地区」道路付替",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "「金城ふ頭地区」道路付替",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H15-16",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "644",
    "地域No": "27",
    "地域名": "名古屋臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "「金城ふ頭地区」駅前広場",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "「金城ふ頭地区」駅前広場",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H15-16",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "645",
    "地域No": "27",
    "地域名": "名古屋臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "「金城ふ頭地区」横断歩道橋",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "「金城ふ頭地区」横断歩道橋",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H15-16",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "646",
    "地域No": "27",
    "地域名": "名古屋臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "「金城ふ頭地区」緑地",
    "内閣府No": "カ",
    "内閣府プロジェクト名": "「金城ふ頭地区」緑地",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H22-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "647",
    "地域No": "27",
    "地域名": "名古屋臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "「金城ふ頭地区」ペデストリアンデッキ",
    "内閣府No": "キ",
    "内閣府プロジェクト名": "「金城ふ頭地区」ペデストリアンデッキ",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H22-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "648",
    "地域No": "27",
    "地域名": "名古屋臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "「金城ふ頭地区」歩道",
    "内閣府No": "ク",
    "内閣府プロジェクト名": "「金城ふ頭地区」歩道",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H22-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "649",
    "地域No": "27",
    "地域名": "名古屋臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "「金城ふ頭地区」広場",
    "内閣府No": "ケ",
    "内閣府プロジェクト名": "「金城ふ頭地区」広場",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H22-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "650",
    "地域No": "27",
    "地域名": "名古屋臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "「港明地区」道路",
    "内閣府No": "コ",
    "内閣府プロジェクト名": "「港明地区」道路",
    "内閣府プロジェクト名２": "アクルスロード",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H27-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "651",
    "地域No": "27",
    "地域名": "名古屋臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "「港明地区」公園",
    "内閣府No": "サ",
    "内閣府プロジェクト名": "「港明地区」公園",
    "内閣府プロジェクト名２": "港明公園、津金公園",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H27-29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "652",
    "地域No": "28",
    "地域名": "中部国際空港東・常滑りんくう地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "愛知県国際展示場",
    "内閣府No": "1",
    "内閣府プロジェクト名": "愛知県国際展示場",
    "内閣府プロジェクト名２": "Aichi Sky Expo",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "愛知県",
    "事業期間（年度）": "H29-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "653",
    "地域No": "28",
    "地域名": "中部国際空港東・常滑りんくう地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "第２ターミナルビル",
    "内閣府No": "2",
    "内閣府プロジェクト名": "第２ターミナルビル",
    "内閣府プロジェクト名２": "Ｔ２",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "中部国際空港",
    "事業期間（年度）": "H30-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "654",
    "地域No": "28",
    "地域名": "中部国際空港東・常滑りんくう地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ＦＬＩＧＨＴ　ＯＦ　ＤＲＥＡＭＳ",
    "内閣府No": "3",
    "内閣府プロジェクト名": "ＦＬＩＧＨＴ　ＯＦ　ＤＲＥＡＭＳ",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "中部国際空港",
    "事業期間（年度）": "H29-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "655",
    "地域No": "28",
    "地域名": "中部国際空港東・常滑りんくう地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ホテル整備事業",
    "内閣府No": "4",
    "内閣府プロジェクト名": "ホテル整備事業",
    "内閣府プロジェクト名２": "セントレアホテル新棟",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "名古屋鉄道",
    "事業期間（年度）": "H29-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "656",
    "地域No": "28",
    "地域名": "中部国際空港東・常滑りんくう地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ホテル整備事業",
    "内閣府No": "5",
    "内閣府プロジェクト名": "ホテル整備事業",
    "内閣府プロジェクト名２": "東横INN中部国際空港Ⅱ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東横イン",
    "事業期間（年度）": "H28-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "657",
    "地域No": "28",
    "地域名": "中部国際空港東・常滑りんくう地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ホテル整備事業",
    "内閣府No": "6",
    "内閣府プロジェクト名": "ホテル整備事業",
    "内閣府プロジェクト名２": "フォーポイントバイシェラトン名古屋　中部国際空港",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "積水ハウス",
    "事業期間（年度）": "H29-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "658",
    "地域No": "28",
    "地域名": "中部国際空港東・常滑りんくう地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "中部臨空都市空港島港湾交流ゾーン開発",
    "内閣府No": "7",
    "内閣府プロジェクト名": "中部臨空都市空港島港湾交流ゾーン開発",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "659",
    "地域No": "28",
    "地域名": "中部国際空港東・常滑りんくう地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "中部臨空都市空港島総合物流ゾーン開発",
    "内閣府No": "8",
    "内閣府プロジェクト名": "中部臨空都市空港島総合物流ゾーン開発",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "660",
    "地域No": "28",
    "地域名": "中部国際空港東・常滑りんくう地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "中部臨空都市空港対岸部港湾ゾーン開発",
    "内閣府No": "9",
    "内閣府プロジェクト名": "中部臨空都市空港対岸部港湾ゾーン開発",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "661",
    "地域No": "28",
    "地域名": "中部国際空港東・常滑りんくう地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "中部臨空都市空港対岸部中央ゾーン開発",
    "内閣府No": "10",
    "内閣府プロジェクト名": "中部臨空都市空港対岸部中央ゾーン開発",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "662",
    "地域No": "28",
    "地域名": "中部国際空港東・常滑りんくう地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "中部臨空都市空港対岸部生活文化ゾーン開発",
    "内閣府No": "11",
    "内閣府プロジェクト名": "中部臨空都市空港対岸部生活文化ゾーン開発",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "663",
    "地域No": "28",
    "地域名": "中部国際空港東・常滑りんくう地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "中部臨空都市空港対岸部研究生産ゾーン開発",
    "内閣府No": "12",
    "内閣府プロジェクト名": "中部臨空都市空港対岸部研究生産ゾーン開発",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "664",
    "地域No": "28",
    "地域名": "中部国際空港東・常滑りんくう地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "シネマコンプレックス整備事業",
    "内閣府No": "13",
    "内閣府プロジェクト名": "シネマコンプレックス整備事業",
    "内閣府プロジェクト名２": "イオンシネマ常滑",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "イオンモール",
    "事業期間（年度）": "H28-29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "665",
    "地域No": "28",
    "地域名": "中部国際空港東・常滑りんくう地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "旧市民病院跡地再開発",
    "内閣府No": "14",
    "内閣府プロジェクト名": "旧市民病院跡地再開発",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "666",
    "地域No": "28",
    "地域名": "中部国際空港東・常滑りんくう地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "自動車部品製造工場整備事業",
    "内閣府No": "15",
    "内閣府プロジェクト名": "自動車部品製造工場整備事業",
    "内閣府プロジェクト名２": "ＧＫＮドライブラインジャパン㈱名古屋事業所　常滑工場",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ＧＫＮドライブラインジャパン",
    "事業期間（年度）": "H29-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "667",
    "地域No": "28",
    "地域名": "中部国際空港東・常滑りんくう地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "水素ステーション整備事業",
    "内閣府No": "16",
    "内閣府プロジェクト名": "水素ステーション整備事業",
    "内閣府プロジェクト名２": "セントレア水素ステーション",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東邦ガス",
    "事業期間（年度）": "H29-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "668",
    "地域No": "28",
    "地域名": "中部国際空港東・常滑りんくう地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "レンタカー事業所・駐車場整備事業",
    "内閣府No": "17",
    "内閣府プロジェクト名": "レンタカー事業所・駐車場整備事業",
    "内閣府プロジェクト名２": "タイムズセントレア空港東",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "タイムズモビリティネットワークス",
    "事業期間（年度）": "H29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "669",
    "地域No": "28",
    "地域名": "中部国際空港東・常滑りんくう地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "物流拠点整備事業",
    "内閣府No": "18",
    "内閣府プロジェクト名": "物流拠点整備事業",
    "内閣府プロジェクト名２": "SyncAgeりんくう常滑",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東山",
    "事業期間（年度）": "H30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "670",
    "地域No": "28",
    "地域名": "中部国際空港東・常滑りんくう地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "連絡通路整備",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "連絡通路整備",
    "内閣府プロジェクト名２": "空中回廊",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H29-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "671",
    "地域No": "28",
    "地域名": "中部国際空港東・常滑りんくう地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "歩道等上屋整備",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "歩道等上屋整備",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H30-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "672",
    "地域No": "28",
    "地域名": "中部国際空港東・常滑りんくう地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "りんくうIC出口追加事業",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "りんくうIC出口追加事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H29-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "673",
    "地域No": "29",
    "地域名": "京都駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "イオンモールＫＹＯＴＯ",
    "内閣府No": "1",
    "内閣府プロジェクト名": "イオンモールＫＹＯＴＯ",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "清水建設",
    "事業期間（年度）": "H19-21",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "674",
    "地域No": "29",
    "地域名": "京都駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "新・都ホテル増築",
    "内閣府No": "2",
    "内閣府プロジェクト名": "新・都ホテル増築",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "近鉄ホテルシステムズ",
    "事業期間（年度）": "H16-17",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "675",
    "地域No": "29",
    "地域名": "京都駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ホテルビスタ京都",
    "内閣府No": "3",
    "内閣府プロジェクト名": "ホテルビスタ京都",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ＭＫビスタ、MKビスタ・ホールディングス",
    "事業期間（年度）": "H20-21",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "676",
    "地域No": "29",
    "地域名": "京都駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ＷＡＫＡＴＯビル",
    "内閣府No": "4",
    "内閣府プロジェクト名": "ＷＡＫＡＴＯビル",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "若藤",
    "事業期間（年度）": "H20-21",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "677",
    "地域No": "29",
    "地域名": "京都駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "元安寧小学校跡地活用",
    "内閣府No": "5",
    "内閣府プロジェクト名": "元安寧小学校跡地活用",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "678",
    "地域No": "29",
    "地域名": "京都駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "運転免許更新センター及び地域防犯ステーション整備等事業（旧七条警察署跡地活用）",
    "内閣府No": "6",
    "内閣府プロジェクト名": "運転免許更新センター及び地域防犯ステーション整備等事業（旧七条警察署跡地活用）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ダイワロイヤルグループ",
    "事業期間（年度）": "H26-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "679",
    "地域No": "29",
    "地域名": "京都駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ハトヤ瑞鳳閣",
    "内閣府No": "7",
    "内閣府プロジェクト名": "ハトヤ瑞鳳閣",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ハトヤ観光",
    "事業期間（年度）": "H25-26",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "680",
    "地域No": "29",
    "地域名": "京都駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ワコール新京都ビル",
    "内閣府No": "8",
    "内閣府プロジェクト名": "ワコール新京都ビル",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ワコールホールディングス",
    "事業期間（年度）": "H26-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "681",
    "地域No": "29",
    "地域名": "京都駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "京都鉄道博物館",
    "内閣府No": "9",
    "内閣府プロジェクト名": "京都鉄道博物館",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "JR西日本",
    "事業期間（年度）": "H25-27",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "682",
    "地域No": "29",
    "地域名": "京都駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "パデシオン京都七条ミッドパーク（日本たばこ産業㈱京都支店跡地活用）",
    "内閣府No": "10",
    "内閣府プロジェクト名": "パデシオン京都七条ミッドパーク（日本たばこ産業㈱京都支店跡地活用）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "睦備建設",
    "事業期間（年度）": "H27-29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "683",
    "地域No": "29",
    "地域名": "京都駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "第一市場　賑わいゾーン①",
    "内閣府No": "11-1",
    "内閣府プロジェクト名": "第一市場　賑わいゾーン①",
    "内閣府プロジェクト名２": "ホテルエミオン京都",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "スターツコーポレーション",
    "事業期間（年度）": "H30-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "684",
    "地域No": "29",
    "地域名": "京都駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "第一市場　賑わいゾーン②",
    "内閣府No": "11-2",
    "内閣府プロジェクト名": "第一市場　賑わいゾーン②",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "中央倉庫",
    "事業期間（年度）": "R1-R7",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "685",
    "地域No": "29",
    "地域名": "京都駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "第一市場　有効活用地（青果棟跡地）",
    "内閣府No": "12",
    "内閣府プロジェクト名": "第一市場　有効活用地（青果棟跡地）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "686",
    "地域No": "29",
    "地域名": "京都駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "第一市場　有効活用地（厚生会館跡地）",
    "内閣府No": "13",
    "内閣府プロジェクト名": "第一市場　有効活用地（厚生会館跡地）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "687",
    "地域No": "29",
    "地域名": "京都駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "第一市場　有効活用地（駐車場跡地）",
    "内閣府No": "14",
    "内閣府プロジェクト名": "第一市場　有効活用地（駐車場跡地）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "688",
    "地域No": "29",
    "地域名": "京都駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "KRP10号館",
    "内閣府No": "15",
    "内閣府プロジェクト名": "KRP10号館",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "大阪ガス都市開発",
    "事業期間（年度）": "H28-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "689",
    "地域No": "29",
    "地域名": "京都駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "京都プロジェクト（仮称）",
    "内閣府No": "16",
    "内閣府プロジェクト名": "京都プロジェクト（仮称）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "日本郵政、京都駅ビル開発",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "690",
    "地域No": "29",
    "地域名": "京都駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "京都駅八条口駅前広場",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "京都駅八条口駅前広場",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H26-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "691",
    "地域No": "29",
    "地域名": "京都駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "京都駅北口駅前広場交通施設",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "京都駅北口駅前広場交通施設",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H25",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "692",
    "地域No": "29",
    "地域名": "京都駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "崇仁北部第一地区土地区画整理事業",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "崇仁北部第一地区土地区画整理事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H23-R7",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "693",
    "地域No": "29",
    "地域名": "京都駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "崇仁北部第二地区土地区画整理事業",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "崇仁北部第二地区土地区画整理事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H26-R7",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "694",
    "地域No": "29",
    "地域名": "京都駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "梅小路新駅",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "梅小路新駅",
    "内閣府プロジェクト名２": "ＪＲ梅小路京都西駅",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H26-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "695",
    "地域No": "30",
    "地域名": "京都南部油小路通沿道地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "技術の橋渡し拠点整備（京都市成長産業創造センター）",
    "内閣府No": "1",
    "内閣府プロジェクト名": "技術の橋渡し拠点整備（京都市成長産業創造センター）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "京都高度技術研究所",
    "事業期間（年度）": "H24-25",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "696",
    "地域No": "30",
    "地域名": "京都南部油小路通沿道地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "㈱増田医科器械本社ビル",
    "内閣府No": "2",
    "内閣府プロジェクト名": "㈱増田医科器械本社ビル",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "増田医科器械",
    "事業期間（年度）": "H15-16",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "697",
    "地域No": "30",
    "地域名": "京都南部油小路通沿道地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "アルフレッサ㈱京都医薬品センター",
    "内閣府No": "3",
    "内閣府プロジェクト名": "アルフレッサ㈱京都医薬品センター",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "アルフレッサ",
    "事業期間（年度）": "H26-27",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "698",
    "地域No": "30",
    "地域名": "京都南部油小路通沿道地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "京都市上下水道局南部拠点整備事業",
    "内閣府No": "4",
    "内閣府プロジェクト名": "京都市上下水道局南部拠点整備事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "京都市",
    "事業期間（年度）": "R3-4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "699",
    "地域No": "30",
    "地域名": "京都南部油小路通沿道地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "京都市創業支援工場跡地開発計画",
    "内閣府No": "5",
    "内閣府プロジェクト名": "京都市創業支援工場跡地開発計画",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "任天堂",
    "事業期間（年度）": "？-R9",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "700",
    "地域No": "30",
    "地域名": "京都南部油小路通沿道地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "毛利町タワープロジェクト",
    "内閣府No": "6",
    "内閣府プロジェクト名": "毛利町タワープロジェクト",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "長栄",
    "事業期間（年度）": "R4-6",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "701",
    "地域No": "30",
    "地域名": "京都南部油小路通沿道地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "㈱グラフィック第５工場",
    "内閣府No": "7",
    "内閣府プロジェクト名": "㈱グラフィック第５工場",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "グラフィック",
    "事業期間（年度）": "R4-5",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "702",
    "地域No": "30",
    "地域名": "京都南部油小路通沿道地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "京都高速道路油小路線（直線区間）",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "京都高速道路油小路線（直線区間）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H11-19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "703",
    "地域No": "30",
    "地域名": "京都南部油小路通沿道地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "油小路通再整備",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "油小路通再整備",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H18-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "704",
    "地域No": "31",
    "地域名": "大阪城公園周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ＫＤＤＩ大阪第２ビル新築工事",
    "内閣府No": "1",
    "内閣府プロジェクト名": "ＫＤＤＩ大阪第２ビル新築工事",
    "内閣府プロジェクト名２": "ＫＤＤＩ大阪第２ビル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ＫＤＤＩ",
    "事業期間（年度）": "H25-27",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "705",
    "地域No": "31",
    "地域名": "大阪城公園周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "新ＭＩＤ大阪京橋ビル新築工事",
    "内閣府No": "2",
    "内閣府プロジェクト名": "新ＭＩＤ大阪京橋ビル新築工事",
    "内閣府プロジェクト名２": "オプテージビル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "関電不動産開発",
    "事業期間（年度）": "H27-29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "706",
    "地域No": "31",
    "地域名": "大阪城公園周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "読売テレビ新社屋建設計画",
    "内閣府No": "3",
    "内閣府プロジェクト名": "読売テレビ新社屋建設計画",
    "内閣府プロジェクト名２": "読売テレビ新社屋",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "讀賣テレビ放送",
    "事業期間（年度）": "H28-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "707",
    "地域No": "31",
    "地域名": "大阪城公園周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）京阪京橋駅周辺開発計画",
    "内閣府No": "4",
    "内閣府プロジェクト名": "（仮称）京阪京橋駅周辺開発計画",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "京阪ホールディングス",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "708",
    "地域No": "31",
    "地域名": "大阪城公園周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）イオン京橋開発計画",
    "内閣府No": "5",
    "内閣府プロジェクト名": "（仮称）イオン京橋開発計画",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "709",
    "地域No": "31",
    "地域名": "大阪城公園周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "京阪神OBPビル新築工事",
    "内閣府No": "6",
    "内閣府プロジェクト名": "京阪神OBPビル新築工事",
    "内閣府プロジェクト名２": "京阪神OBPビル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "京阪神ビルディング",
    "事業期間（年度）": "H31-R3",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "710",
    "地域No": "31",
    "地域名": "大阪城公園周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）大阪公立大学　森之宮キャンパス整備計画",
    "内閣府No": "7",
    "内閣府プロジェクト名": "（仮称）大阪公立大学　森之宮キャンパス整備計画",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "公立大学法人大阪",
    "事業期間（年度）": "R4-7",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "711",
    "地域No": "31",
    "地域名": "大阪城公園周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）イノベーション・コアゾーン開発計画①",
    "内閣府No": "8",
    "内閣府プロジェクト名": "（仮称）イノベーション・コアゾーン開発計画①",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "712",
    "地域No": "31",
    "地域名": "大阪城公園周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）イノベーション・コアゾーン開発計画②",
    "内閣府No": "9",
    "内閣府プロジェクト名": "（仮称）イノベーション・コアゾーン開発計画②",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "713",
    "地域No": "31",
    "地域名": "大阪城公園周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大阪・大手前一丁目プロジェクト",
    "内閣府No": "10",
    "内閣府プロジェクト名": "大阪・大手前一丁目プロジェクト",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "日本経済新聞社、大和ハウス工業",
    "事業期間（年度）": "R3-5",
    "状況": "事業中",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "714",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "うめきた地区",
    "内閣府No": "1",
    "内閣府プロジェクト名": "うめきた地区",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "01-④",
    "特定地域整備計画名": "（仮称）うめきた2 期開発事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "三菱地所、オリックス不動産ほか",
    "事業期間（年度）": "H21-R8",
    "状況": "事業中",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "●",
    "税制支援（都市再生）": "●",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "●",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "715",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "茶屋町地区市街地再開発事業",
    "内閣府No": "2",
    "内閣府プロジェクト名": "茶屋町地区市街地再開発事業",
    "内閣府プロジェクト名２": "NU茶屋町",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H15-25",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "716",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大阪駅地区",
    "内閣府No": "3",
    "内閣府プロジェクト名": "大阪駅地区",
    "内閣府プロジェクト名２": "大阪ステーションシティ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "JR西日本、大阪ターミナルビル",
    "事業期間（年度）": "H18-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "717",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "角田町地区",
    "内閣府No": "4",
    "内閣府プロジェクト名": "角田町地区",
    "内閣府プロジェクト名２": "大阪梅田ツインタワーズ・ノース",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "阪急電鉄",
    "事業期間（年度）": "H18-24",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "718",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "梅田二丁目地区",
    "内閣府No": "5",
    "内閣府プロジェクト名": "梅田二丁目地区",
    "内閣府プロジェクト名２": "ブリーゼタワー",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "サンケイビル",
    "事業期間（年度）": "H17-20",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "719",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大阪大学病院跡地開発",
    "内閣府No": "6",
    "内閣府プロジェクト名": "大阪大学病院跡地開発",
    "内閣府プロジェクト名２": "ほたるまち",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "朝日放送、オリックス不動産ほか",
    "事業期間（年度）": "H17-20",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "720",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "中之島三丁目共同開発",
    "内閣府No": "7",
    "内閣府プロジェクト名": "中之島三丁目共同開発",
    "内閣府プロジェクト名２": "関電ビルディング、中之島ダイビル、ダイビル本館",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "関西電力、ダイビル、関電不動産",
    "事業期間（年度）": "H12-24",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "721",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "淀屋橋地区",
    "内閣府No": "8",
    "内閣府プロジェクト名": "淀屋橋地区",
    "内閣府プロジェクト名２": "淀屋橋odona",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR",
    "事業期間（年度）": "H17-19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "722",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "心斎橋筋一丁目地区",
    "内閣府No": "9",
    "内閣府プロジェクト名": "心斎橋筋一丁目地区",
    "内閣府プロジェクト名２": "大丸心斎橋店",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "大丸松坂屋百貨店",
    "事業期間（年度）": "H15-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "723",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "本町三丁目南地区",
    "内閣府No": "10",
    "内閣府プロジェクト名": "本町三丁目南地区",
    "内閣府プロジェクト名２": "本町ガーデンシティ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "積水ハウス",
    "事業期間（年度）": "H19-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "724",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "西本町一丁目地区",
    "内閣府No": "11",
    "内閣府プロジェクト名": "西本町一丁目地区",
    "内閣府プロジェクト名２": "オリックス本社ビル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "オリックス不動産",
    "事業期間（年度）": "H20-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "725",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "小松原町地区",
    "内閣府No": "12",
    "内閣府プロジェクト名": "小松原町地区",
    "内閣府プロジェクト名２": "大阪富国生命ビル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "富国生命",
    "事業期間（年度）": "H20-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "726",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "中之島四つ橋筋地区（１期：東側）",
    "内閣府No": "13",
    "内閣府プロジェクト名": "中之島四つ橋筋地区（１期：東側）",
    "内閣府プロジェクト名２": "中之島フェスティバルタワー",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "朝日新聞社",
    "事業期間（年度）": "H21-29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "727",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "中之島四つ橋筋地区（２期：西側）",
    "内閣府No": "13",
    "内閣府プロジェクト名": "中之島四つ橋筋地区（２期：西側）",
    "内閣府プロジェクト名２": "中之島フェスティバルタワー・ウェスト",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "朝日新聞社",
    "事業期間（年度）": "H21-29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "728",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大阪駅西地区(旧大阪中央郵便局等建替え)",
    "内閣府No": "14",
    "内閣府プロジェクト名": "大阪駅西地区(旧大阪中央郵便局等建替え)",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "01-②",
    "特定地域整備計画名": "大阪駅西地区（大阪中央郵便局、大弘ビル及び西梅田中央駐車場建替え）",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "日本郵便、JR西日本、大阪ターミナルビル、JTB",
    "事業期間（年度）": "R2-5",
    "状況": "事業中",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "729",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "今橋三丁目地区（日本生命相互会社大阪本店東館）",
    "内閣府No": "15",
    "内閣府プロジェクト名": "今橋三丁目地区（日本生命相互会社大阪本店東館）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "日本生命",
    "事業期間（年度）": "H24-26",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "730",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大深町地区",
    "内閣府No": "16",
    "内閣府プロジェクト名": "大深町地区",
    "内閣府プロジェクト名２": "ヨドバシ梅田タワー",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ヨドバシカメラ",
    "事業期間（年度）": "H29-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "731",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "梅田１丁目地区",
    "内閣府No": "17",
    "内閣府プロジェクト名": "梅田１丁目地区",
    "内閣府プロジェクト名２": "大阪梅田ツインタワーズ・サウス",
    "特定地域整備計画No": "01-①",
    "特定地域整備計画名": "梅田一丁目一番地計画（大阪神ビルディング・新阪急ビル建替え計画）",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "阪神電気鉄道、阪急電鉄",
    "事業期間（年度）": "H27-R3",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "732",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大阪中之島美術館",
    "内閣府No": "18",
    "内閣府プロジェクト名": "大阪中之島美術館",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "大阪市",
    "事業期間（年度）": "H30-R3",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "733",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "未来医療国際拠点",
    "内閣府No": "19",
    "内閣府プロジェクト名": "未来医療国際拠点",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "日本生命、京阪ホールディングス、関電不動産",
    "事業期間（年度）": "？-R5",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "●",
    "税制支援（都市再生）": "●",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "734",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ザ・パークハウス　中之島タワー",
    "内閣府No": "20",
    "内閣府プロジェクト名": "ザ・パークハウス　中之島タワー",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "三菱地所レジデンス、住友商事、京阪電鉄不動産、アサヒプロパティズ",
    "事業期間（年度）": "H26-29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "735",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "伏見町三丁目地区(三菱東京UFJ銀行大阪本店建替え)",
    "内閣府No": "21",
    "内閣府プロジェクト名": "伏見町三丁目地区(三菱東京UFJ銀行大阪本店建替え)",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "三菱東京UFJ 銀行",
    "事業期間（年度）": "H27-29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "736",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "淀屋橋駅西地区",
    "内閣府No": "22",
    "内閣府プロジェクト名": "淀屋橋駅西地区",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "R3-7",
    "状況": "事業中",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "737",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "淀屋橋駅東地区",
    "内閣府No": "23",
    "内閣府プロジェクト名": "淀屋橋駅東地区",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "中央日本土地建物、京阪ホールディングス、みずほ銀行",
    "事業期間（年度）": "R4-7",
    "状況": "事業中",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "●",
    "税制支援（都市再生）": "●",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "738",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "堂島浜一丁目地区",
    "内閣府No": "24",
    "内閣府プロジェクト名": "堂島浜一丁目地区",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "SPC",
    "事業期間（年度）": "R3-6",
    "状況": "事業中",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "739",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）大阪駅西北ビル開発事業",
    "内閣府No": "25",
    "内閣府プロジェクト名": "（仮称）大阪駅西北ビル開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "JR西日本、大阪ターミナルビル",
    "事業期間（年度）": "R2-6",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "●",
    "税制支援（都市再生）": "●",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "740",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "新・新ダイビル（仮称）開発計画",
    "内閣府No": "26",
    "内閣府プロジェクト名": "新・新ダイビル（仮称）開発計画",
    "内閣府プロジェクト名２": "新ダイビル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ダイビル",
    "事業期間（年度）": "H24-26",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "741",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大阪駅北大深西地区土地区画整理事業",
    "内閣府No": "",
    "内閣府プロジェクト名": "",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "01-③",
    "特定地域整備計画名": "大阪駅北大深西地区土地区画整理事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR",
    "事業期間（年度）": "H27-R8",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "●",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "742",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "大阪都市計画道路3･1･35号大阪駅北１号線",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "大阪都市計画道路3･1･35号大阪駅北１号線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR",
    "事業期間（年度）": "H17-25",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "743",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "大阪都市計画道路3･1･36号大阪駅北2号線",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "大阪都市計画道路3･1･36号大阪駅北2号線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR",
    "事業期間（年度）": "H17-25",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "744",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "大阪都市計画交通広場第1号大阪駅北口広場",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "大阪都市計画交通広場第1号大阪駅北口広場",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR",
    "事業期間（年度）": "H17-25",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "745",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "区画道路１～６号線",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "区画道路１～６号線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR",
    "事業期間（年度）": "H17-26",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "746",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "大阪駅北広場",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "大阪駅北広場",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H18-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "747",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "大阪駅南広場",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "大阪駅南広場",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H18-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "748",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "大阪駅南北通路",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "大阪駅南北通路",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H18-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "749",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "大阪駅南口東通路",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "大阪駅南口東通路",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "01-○イ",
    "特定地域整備計画名": "大阪駅南口東通路",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H18-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "750",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "大阪駅南口西通路",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "大阪駅南口西通路",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "01-○ウ",
    "特定地域整備計画名": "大阪駅南口西通路",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H27-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "751",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "梅田北野線",
    "内閣府No": "カ",
    "内閣府プロジェクト名": "梅田北野線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H17-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "752",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "北野方面東西4号線",
    "内閣府No": "カ",
    "内閣府プロジェクト名": "北野方面東西4号線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H17-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "753",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "北野方面東西２号線",
    "内閣府No": "カ",
    "内閣府プロジェクト名": "北野方面東西２号線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H17-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "754",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "北野万歳橋筋線",
    "内閣府No": "カ",
    "内閣府プロジェクト名": "北野万歳橋筋線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H17-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "755",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "綱敷天神東筋線",
    "内閣府No": "カ",
    "内閣府プロジェクト名": "綱敷天神東筋線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H17-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "756",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "本庄天満方面南北22号線",
    "内閣府No": "カ",
    "内閣府プロジェクト名": "本庄天満方面南北22号線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H17-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "757",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "本庄天満方面東西24号線",
    "内閣府No": "カ",
    "内閣府プロジェクト名": "本庄天満方面東西24号線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H17-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "758",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "広路4号御堂筋　道路空間の再編",
    "内閣府No": "キ",
    "内閣府プロジェクト名": "広路4号御堂筋　道路空間の再編",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H27-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "759",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "大阪都市計画道路3･1･35号大阪駅北1号線",
    "内閣府No": "ク",
    "内閣府プロジェクト名": "大阪都市計画道路3･1･35号大阪駅北1号線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR",
    "事業期間（年度）": "H27-R8",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "760",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "大阪都市計画道路3･1･36号大阪駅北2号線",
    "内閣府No": "ク",
    "内閣府プロジェクト名": "大阪都市計画道路3･1･36号大阪駅北2号線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR",
    "事業期間（年度）": "H27-R8",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "761",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "大阪都市計画道路3･3･37号大阪駅北3号線",
    "内閣府No": "ク",
    "内閣府プロジェクト名": "大阪都市計画道路3･3･37号大阪駅北3号線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR",
    "事業期間（年度）": "H27-R8",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "762",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "大阪都市計画道路Ⅰ・３・20号海老江梅田線",
    "内閣府No": "ク",
    "内閣府プロジェクト名": "大阪都市計画道路Ⅰ・３・20号海老江梅田線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR",
    "事業期間（年度）": "H27-R8",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "763",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "大阪都市計画道路7･6･49中津南北線",
    "内閣府No": "ク",
    "内閣府プロジェクト名": "大阪都市計画道路7･6･49中津南北線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR",
    "事業期間（年度）": "H27-R8",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "764",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "区画道路7〜13号線",
    "内閣府No": "ク",
    "内閣府プロジェクト名": "区画道路7〜13号線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR",
    "事業期間（年度）": "H27-R8",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "765",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "1〜2号公園",
    "内閣府No": "ク",
    "内閣府プロジェクト名": "1〜2号公園",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR",
    "事業期間（年度）": "H27-R8",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "766",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "大阪都市計画交通広場５号大阪西口広場",
    "内閣府No": "ク",
    "内閣府プロジェクト名": "大阪都市計画交通広場５号大阪西口広場",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR",
    "事業期間（年度）": "H27-R8",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "767",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "JR東海道線支線地下化・新駅設置事業",
    "内閣府No": "ケ",
    "内閣府プロジェクト名": "JR東海道線支線地下化・新駅設置事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "01-○ア",
    "特定地域整備計画名": "JR東海道線支線地下化事業及び新駅設置事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "大阪市（地下化）、JR 西日本（新駅）",
    "事業期間（年度）": "H26-R5",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "●",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "768",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "大深町（うめきた２期）地区防災公園街区整備事業",
    "内閣府No": "コ",
    "内閣府プロジェクト名": "大深町（うめきた２期）地区防災公園街区整備事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "01-○エ",
    "特定地域整備計画名": "大深町（うめきた２期）地区防災公園街区整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR",
    "事業期間（年度）": "H30-R8",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "769",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "３・１・64号大阪駅前線",
    "内閣府No": "サ",
    "内閣府プロジェクト名": "３・１・64号大阪駅前線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "阪神電気鉄道、阪急電鉄",
    "事業期間（年度）": "R3-7",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "770",
    "地域No": "32",
    "地域名": "【特定】大阪駅周辺・中之島・御堂筋周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "３・１・64号大阪駅前線（支線第１号線）",
    "内閣府No": "サ",
    "内閣府プロジェクト名": "３・１・64号大阪駅前線（支線第１号線）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "阪神電気鉄道、阪急電鉄",
    "事業期間（年度）": "R3-7",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "771",
    "地域No": "33",
    "地域名": "難波・湊町地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "難波地区",
    "内閣府No": "1",
    "内閣府プロジェクト名": "難波地区",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "南海電気鉄道ほか",
    "事業期間（年度）": "",
    "状況": "",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "772",
    "地域No": "33",
    "地域名": "難波・湊町地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "なんばパークス",
    "内閣府No": "1-1",
    "内閣府プロジェクト名": "なんばパークス",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "南海電気鉄道、高島屋",
    "事業期間（年度）": "H11-19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "773",
    "地域No": "33",
    "地域名": "難波・湊町地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "Ｃ街区プロジェクト",
    "内閣府No": "1-2",
    "内閣府プロジェクト名": "Ｃ街区プロジェクト",
    "内閣府プロジェクト名２": "Ｚｅｐｐ　Ｎａｍｂａ／南海なんば第1ビル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "南海電気鉄道、大阪府立大学、Zepp Namba",
    "事業期間（年度）": "H23-24",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "774",
    "地域No": "33",
    "地域名": "難波・湊町地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "難波五丁目地区（なんばスカイオ）",
    "内閣府No": "1-3",
    "内閣府プロジェクト名": "難波五丁目地区（なんばスカイオ）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "南海電気鉄道",
    "事業期間（年度）": "H27-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "775",
    "地域No": "33",
    "地域名": "難波・湊町地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "湊町地区",
    "内閣府No": "2",
    "内閣府プロジェクト名": "湊町地区",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "大阪市、UR、JR西日本ほか",
    "事業期間（年度）": "",
    "状況": "",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "776",
    "地域No": "33",
    "地域名": "難波・湊町地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "区画道路第1号",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "区画道路第1号",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H13-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "777",
    "地域No": "33",
    "地域名": "難波・湊町地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "区画道路第2号",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "区画道路第2号",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H13-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "778",
    "地域No": "33",
    "地域名": "難波・湊町地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "区画道路第3号",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "区画道路第3号",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H13-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "779",
    "地域No": "33",
    "地域名": "難波・湊町地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "区画道路第７号",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "区画道路第７号",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H13-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "780",
    "地域No": "33",
    "地域名": "難波・湊町地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "地区幹線道路",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "地区幹線道路",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H13-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "781",
    "地域No": "33",
    "地域名": "難波・湊町地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "第2号公園",
    "内閣府No": "カ",
    "内閣府プロジェクト名": "第2号公園",
    "内閣府プロジェクト名２": "高岸公園",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H13-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "782",
    "地域No": "33",
    "地域名": "難波・湊町地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "湊町南北線",
    "内閣府No": "キ",
    "内閣府プロジェクト名": "湊町南北線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H7-16",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "783",
    "地域No": "33",
    "地域名": "難波・湊町地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "湊町東西線",
    "内閣府No": "ク",
    "内閣府プロジェクト名": "湊町東西線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H7-16",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "784",
    "地域No": "33",
    "地域名": "難波・湊町地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "元町南北線",
    "内閣府No": "ケ",
    "内閣府プロジェクト名": "元町南北線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H7-16",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "785",
    "地域No": "33",
    "地域名": "難波・湊町地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "交通広場",
    "内閣府No": "コ",
    "内閣府プロジェクト名": "交通広場",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H7-16",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "786",
    "地域No": "33",
    "地域名": "難波・湊町地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "中央広場",
    "内閣府No": "サ",
    "内閣府プロジェクト名": "中央広場",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H7-16",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "787",
    "地域No": "34",
    "地域名": "新大阪駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "阪急　新大阪連絡線　駅ビル計画（仮称）",
    "内閣府No": "1",
    "内閣府プロジェクト名": "阪急　新大阪連絡線　駅ビル計画（仮称）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "阪急電鉄",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "788",
    "地域No": "34",
    "地域名": "新大阪駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "宮原4丁目2番街区計画（仮称）",
    "内閣府No": "2",
    "内閣府プロジェクト名": "宮原4丁目2番街区計画（仮称）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "日本郵政不動産",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "789",
    "地域No": "34",
    "地域名": "新大阪駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "新大阪駅東口まちづくり用地開発（仮称）",
    "内閣府No": "3",
    "内閣府プロジェクト名": "新大阪駅東口まちづくり用地開発（仮称）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "790",
    "地域No": "34",
    "地域名": "新大阪駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "西中島5丁目14番街区計画（仮称）",
    "内閣府No": "4",
    "内閣府プロジェクト名": "西中島5丁目14番街区計画（仮称）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "スリーワイ・エム・ディ",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "791",
    "地域No": "34",
    "地域名": "新大阪駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "新大阪駅南側広場（仮称）",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "新大阪駅南側広場（仮称）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "792",
    "地域No": "34",
    "地域名": "新大阪駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "阪急　新大阪連絡線新駅",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "阪急　新大阪連絡線新駅",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "793",
    "地域No": "35",
    "地域名": "阿倍野地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大阪都市計画事業阿倍野A1地区第二種市街地再開発事業（第6工区）",
    "内閣府No": "1",
    "内閣府プロジェクト名": "大阪都市計画事業阿倍野A1地区第二種市街地再開発事業（第6工区）",
    "内閣府プロジェクト名２": "あべのｎｉｎｉ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "特定建築者共同企業体",
    "事業期間（年度）": "H20-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "794",
    "地域No": "35",
    "地域名": "阿倍野地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大阪都市計画事業阿倍野A1地区第二種市街地再開発事業（第5工区）",
    "内閣府No": "2",
    "内閣府プロジェクト名": "大阪都市計画事業阿倍野A1地区第二種市街地再開発事業（第5工区）",
    "内閣府プロジェクト名２": "あべのキューズタウン",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東急不動産",
    "事業期間（年度）": "H20-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "795",
    "地域No": "35",
    "地域名": "阿倍野地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大阪府官舎跡地開発計画",
    "内閣府No": "3",
    "内閣府プロジェクト名": "大阪府官舎跡地開発計画",
    "内閣府プロジェクト名２": "ａｎｄ（アンド）",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "近鉄百貨店",
    "事業期間（年度）": "H18-20",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "796",
    "地域No": "35",
    "地域名": "阿倍野地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "阿倍野筋一丁目地区",
    "内閣府No": "4",
    "内閣府プロジェクト名": "阿倍野筋一丁目地区",
    "内閣府プロジェクト名２": "あべのハルカス",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "近畿日本鉄道",
    "事業期間（年度）": "H21-25",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "797",
    "地域No": "35",
    "地域名": "阿倍野地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）あべの東口計画",
    "内閣府No": "5",
    "内閣府プロジェクト名": "（仮称）あべの東口計画",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "近鉄不動産",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "798",
    "地域No": "35",
    "地域名": "阿倍野地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "大阪都市計画道路　Ⅰ･1･6号 長柄堺線",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "大阪都市計画道路　Ⅰ･1･6号 長柄堺線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H23-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "799",
    "地域No": "35",
    "地域名": "阿倍野地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "大阪都市計画道路　Ⅰ･1･2号　尼崎平野線",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "大阪都市計画道路　Ⅰ･1･2号　尼崎平野線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H23-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "800",
    "地域No": "35",
    "地域名": "阿倍野地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "大阪都市計画道路　3・2・7号　金塚南北線",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "大阪都市計画道路　3・2・7号　金塚南北線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H17-19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "801",
    "地域No": "35",
    "地域名": "阿倍野地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "大阪都市計画道路　7・4・19号　金塚東西線",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "大阪都市計画道路　7・4・19号　金塚東西線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H16-24",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "802",
    "地域No": "35",
    "地域名": "阿倍野地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "大阪都市計画道路　7・6・27号　金塚東4号線",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "大阪都市計画道路　7・6・27号　金塚東4号線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "803",
    "地域No": "35",
    "地域名": "阿倍野地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "大阪都市計画道路　7・5・28号　金塚東5号線",
    "内閣府No": "カ",
    "内閣府プロジェクト名": "大阪都市計画道路　7・5・28号　金塚東5号線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H15",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "804",
    "地域No": "35",
    "地域名": "阿倍野地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "道路施設　阿倍野歩道橋",
    "内閣府No": "キ",
    "内閣府プロジェクト名": "道路施設　阿倍野歩道橋",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H21-25",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "805",
    "地域No": "35",
    "地域名": "阿倍野地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "大阪都市計画道路　8・6・25号　阿倍野南北線",
    "内閣府No": "ク",
    "内閣府プロジェクト名": "大阪都市計画道路　8・6・25号　阿倍野南北線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H20-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "806",
    "地域No": "35",
    "地域名": "阿倍野地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "阿倍野再開発２号公園",
    "内閣府No": "ケ",
    "内閣府プロジェクト名": "阿倍野再開発２号公園",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H24-25",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "807",
    "地域No": "35",
    "地域名": "阿倍野地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "大阪都市計画駐車場　４１　天王寺・あべの橋駅自転車駐車場",
    "内閣府No": "コ",
    "内閣府プロジェクト名": "大阪都市計画駐車場　４１　天王寺・あべの橋駅自転車駐車場",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H20-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "808",
    "地域No": "36",
    "地域名": "【特定】大阪コスモスクエア駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "咲洲コスモスクエア地区",
    "内閣府No": "1",
    "内閣府プロジェクト名": "咲洲コスモスクエア地区",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "民間",
    "事業期間（年度）": "",
    "状況": "",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "809",
    "地域No": "36",
    "地域名": "【特定】大阪コスモスクエア駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "森ノ宮医療大学 新学科用校舎新築 開発事業",
    "内閣府No": "2",
    "内閣府プロジェクト名": "森ノ宮医療大学 新学科用校舎新築 開発事業",
    "内閣府プロジェクト名２": "森ノ宮医療大学　新校舎、森ノ宮医療学園ウェルランゲージスクール",
    "特定地域整備計画No": "①",
    "特定地域整備計画名": "森ノ宮医療大学 2期建設事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "森ノ宮医療学園",
    "事業期間（年度）": "H18-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "810",
    "地域No": "36",
    "地域名": "【特定】大阪コスモスクエア駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大阪エンタテイメントデザイン専門学校建築　開発事業",
    "内閣府No": "3",
    "内閣府プロジェクト名": "大阪エンタテイメントデザイン専門学校建築　開発事業",
    "内閣府プロジェクト名２": "大阪エンタテイメントデザイン専門学校",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "上田学園",
    "事業期間（年度）": "H25",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "811",
    "地域No": "36",
    "地域名": "【特定】大阪コスモスクエア駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "独立行政法人製品評価技術基盤機構　蓄電池評価センター（NLAB）整備事業（予定）",
    "内閣府No": "4",
    "内閣府プロジェクト名": "独立行政法人製品評価技術基盤機構　蓄電池評価センター（NLAB）整備事業（予定）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "812",
    "地域No": "36",
    "地域名": "【特定】大阪コスモスクエア駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "富山産業株式会社　開発事業",
    "内閣府No": "5",
    "内閣府プロジェクト名": "富山産業株式会社　開発事業",
    "内閣府プロジェクト名２": "富山産業株式会社",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "富山産業",
    "事業期間（年度）": "H29-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "813",
    "地域No": "36",
    "地域名": "【特定】大阪コスモスクエア駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "株式会社鴻池組　開発事業",
    "内閣府No": "6",
    "内閣府プロジェクト名": "株式会社鴻池組　開発事業",
    "内閣府プロジェクト名２": "株式会社鴻池組　大阪テクノセンター",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "鴻池組",
    "事業期間（年度）": "R2-3",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "814",
    "地域No": "36",
    "地域名": "【特定】大阪コスモスクエア駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "浜理薬品工業株式会社　開発事業",
    "内閣府No": "7",
    "内閣府プロジェクト名": "浜理薬品工業株式会社　開発事業",
    "内閣府プロジェクト名２": "浜理薬品工業株式会社",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "浜理薬品工業",
    "事業期間（年度）": "H30-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "815",
    "地域No": "36",
    "地域名": "【特定】大阪コスモスクエア駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "独立行政法人製品評価技術基盤機構　蓄電池評価センター（NLAB）整備事業",
    "内閣府No": "8",
    "内閣府プロジェクト名": "独立行政法人製品評価技術基盤機構　蓄電池評価センター（NLAB）整備事業",
    "内閣府プロジェクト名２": "独立行政法人製品評価技術基盤機構　国際評価技術本部　蓄電池評価センター（NLAB）",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "製品評価技術基盤機構",
    "事業期間（年度）": "H26-27",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "816",
    "地域No": "36",
    "地域名": "【特定】大阪コスモスクエア駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "西尾レントオール株式会社　咲洲プロジェクト",
    "内閣府No": "9",
    "内閣府プロジェクト名": "西尾レントオール株式会社　咲洲プロジェクト",
    "内閣府プロジェクト名２": "西尾レントオール株式会社　（仮称）R&D国際交流センター",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "西尾レントール",
    "事業期間（年度）": "R3-4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "817",
    "地域No": "36",
    "地域名": "【特定】大阪コスモスクエア駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ミズノ株式会社　開発事業",
    "内閣府No": "10",
    "内閣府プロジェクト名": "ミズノ株式会社　開発事業",
    "内閣府プロジェクト名２": "ミズノ株式会社　イノベーションセンター「MIZUNOENGINE」",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ミズノ",
    "事業期間（年度）": "R3-4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "818",
    "地域No": "36",
    "地域名": "【特定】大阪コスモスクエア駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "ペデストリアンデッキ（民間整備含む)",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "ペデストリアンデッキ（民間整備含む)",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H17-",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "819",
    "地域No": "36",
    "地域名": "【特定】大阪コスモスクエア駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "情報管路",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "情報管路",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H17-21",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "820",
    "地域No": "36",
    "地域名": "【特定】大阪コスモスクエア駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "エレベーター",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "エレベーター",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H17-21",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "821",
    "地域No": "36",
    "地域名": "【特定】大阪コスモスクエア駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "中ふ頭駅前（舗装・緑化）",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "中ふ頭駅前（舗装・緑化）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H18-19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "822",
    "地域No": "36",
    "地域名": "【特定】大阪コスモスクエア駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "中ふ頭駅前(情報板）",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "中ふ頭駅前(情報板）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H18-19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "823",
    "地域No": "36",
    "地域名": "【特定】大阪コスモスクエア駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "コスモスクエア駅前（情報板）",
    "内閣府No": "カ",
    "内閣府プロジェクト名": "コスモスクエア駅前（情報板）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "824",
    "地域No": "36",
    "地域名": "【特定】大阪コスモスクエア駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "コスモスクエア駅前複合一体開発（事前公募中）",
    "内閣府No": "",
    "内閣府プロジェクト名": "",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "②",
    "特定地域整備計画名": "コスモスクエア駅前複合一体開発（事前公募中）",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H27-未定",
    "状況": "事業中？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "825",
    "地域No": "37",
    "地域名": "堺東駅西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "南海車庫跡地開発",
    "内閣府No": "1",
    "内閣府プロジェクト名": "南海車庫跡地開発",
    "内閣府プロジェクト名２": "堺東ヴューモ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "藤和不動産等",
    "事業期間（年度）": "H20-21",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "826",
    "地域No": "37",
    "地域名": "堺東駅西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "堺東行政ゾーン整備推進事業",
    "内閣府No": "2",
    "内閣府プロジェクト名": "堺東行政ゾーン整備推進事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "国・堺市等",
    "事業期間（年度）": "H25-R4？",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "827",
    "地域No": "37",
    "地域名": "堺東駅西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "堺東駅南地区市街地再開発事業",
    "内閣府No": "3",
    "内閣府プロジェクト名": "堺東駅南地区市街地再開発事業",
    "内閣府プロジェクト名２": "ジョルノ・プラウドタワー堺東",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発株式会社",
    "事業期間（年度）": "H28-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "828",
    "地域No": "38",
    "地域名": "千里中央駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "千里中央地区再整備事業",
    "内閣府No": "1",
    "内閣府プロジェクト名": "千里中央地区再整備事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "民間",
    "事業期間（年度）": "H17-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "829",
    "地域No": "38",
    "地域名": "千里中央駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "よみうり文化センター（千里中央）再整備事業",
    "内閣府No": "2",
    "内閣府プロジェクト名": "よみうり文化センター（千里中央）再整備事業",
    "内閣府プロジェクト名２": "ＳＥＮＲＩＴＯ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "民間",
    "事業期間（年度）": "H26-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "830",
    "地域No": "38",
    "地域名": "千里中央駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "豊中市千里文化センター",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "豊中市千里文化センター",
    "内閣府プロジェクト名２": "コラボ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H18-19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "831",
    "地域No": "38",
    "地域名": "千里中央駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "ザ・千里タワーＢ１Ｆ　駐輪場",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "ザ・千里タワーＢ１Ｆ　駐輪場",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H18-21",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "832",
    "地域No": "38",
    "地域名": "千里中央駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "千里中央西交差点",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "千里中央西交差点",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "833",
    "地域No": "38",
    "地域名": "千里中央駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "ＳＥＮＲＩＴＯ　道路（歩行者専用通路）・緑地",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "ＳＥＮＲＩＴＯ　道路（歩行者専用通路）・緑地",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H26-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "834",
    "地域No": "39",
    "地域名": "高槻駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大阪医科大学教育研究・医療・環境機能高度化事",
    "内閣府No": "1",
    "内閣府プロジェクト名": "大阪医科大学教育研究・医療・環境機能高度化事",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "大阪医科薬科大学",
    "事業期間（年度）": "H15-R7",
    "状況": "事業中",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "835",
    "地域No": "39",
    "地域名": "高槻駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ＪＲ高槻駅北東地区都市開発事業",
    "内閣府No": "2",
    "内閣府プロジェクト名": "ＪＲ高槻駅北東地区都市開発事業",
    "内閣府プロジェクト名２": "ミューズたかつき（関西大学高槻ミューズキャンパス、西武高槻店、西武パーキング館、愛仁会リハビリテーション病院等）",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "民間事業者等",
    "事業期間（年度）": "H20-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "836",
    "地域No": "39",
    "地域名": "高槻駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "阪急北側線",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "阪急北側線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H21",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "837",
    "地域No": "39",
    "地域名": "高槻駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "緑歩道等",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "緑歩道等",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "838",
    "地域No": "39",
    "地域名": "高槻駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "広場",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "広場",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H25",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "839",
    "地域No": "39",
    "地域名": "高槻駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "古曽部天神線（北側延伸部）",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "古曽部天神線（北側延伸部）",
    "内閣府プロジェクト名２": "古曽部212号線",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H20-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "840",
    "地域No": "39",
    "地域名": "高槻駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "古曽部天神線（土地区画整理事業地区内）",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "古曽部天神線（土地区画整理事業地区内）",
    "内閣府プロジェクト名２": "安満新町天神線",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H20-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "841",
    "地域No": "39",
    "地域名": "高槻駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "古曽部白梅線",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "古曽部白梅線",
    "内閣府プロジェクト名２": "白梅町2号線",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H21-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "842",
    "地域No": "39",
    "地域名": "高槻駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "区画道路1号線",
    "内閣府No": "カ",
    "内閣府プロジェクト名": "区画道路1号線",
    "内閣府プロジェクト名２": "安満新町天神線",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H21-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "843",
    "地域No": "39",
    "地域名": "高槻駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "区画道路2号線",
    "内閣府No": "キ",
    "内閣府プロジェクト名": "区画道路2号線",
    "内閣府プロジェクト名２": "白梅町1号線",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "844",
    "地域No": "39",
    "地域名": "高槻駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "弁天こ線橋",
    "内閣府No": "ク",
    "内閣府プロジェクト名": "弁天こ線橋",
    "内閣府プロジェクト名２": "白梅町歩道橋2号線",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H20-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "845",
    "地域No": "39",
    "地域名": "高槻駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "公園・緑地",
    "内閣府No": "ケ",
    "内閣府プロジェクト名": "公園・緑地",
    "内閣府プロジェクト名２": "弁天公園ほか",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H22-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "846",
    "地域No": "40",
    "地域名": "枚方市駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "枚方市駅周辺地区第1種市街地再開発事業",
    "内閣府No": "1",
    "内閣府プロジェクト名": "枚方市駅周辺地区第1種市街地再開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "R2-7",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "●",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "847",
    "地域No": "40",
    "地域名": "枚方市駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "枚方市総合文化芸術センター整備",
    "内閣府No": "2",
    "内閣府プロジェクト名": "枚方市総合文化芸術センター整備",
    "内閣府プロジェクト名２": "枚方市総合文化芸術センター",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "枚方市",
    "事業期間（年度）": "H30-R3",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "848",
    "地域No": "40",
    "地域名": "枚方市駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "枚方市駅北口駅前広場再整備",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "枚方市駅北口駅前広場再整備",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R2-7",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "●（L街）",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "849",
    "地域No": "40",
    "地域名": "枚方市駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "外周道路整備",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "外周道路整備",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R2-7",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "850",
    "地域No": "40",
    "地域名": "枚方市駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "（都）枚方藤阪線整備事業",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "（都）枚方藤阪線整備事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R4-6",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "851",
    "地域No": "40",
    "地域名": "枚方市駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "高架下道路改良事業",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "高架下道路改良事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R4-5",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "852",
    "地域No": "40",
    "地域名": "枚方市駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "無電柱化事業",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "無電柱化事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R3-6",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "853",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ポートアイランド西地域コンテナバース跡地再開発事業",
    "内閣府No": "1",
    "内閣府プロジェクト名": "ポートアイランド西地域コンテナバース跡地再開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ニトリ、上組、ﾕｰ･ｴｽ･ｴｽ、神戸学院、兵庫医科大学、阪神興業、伊藤忠商事、伊藤忠都市開発、近畿菱重興産、金子真珠、渋沢倉庫",
    "事業期間（年度）": "H15-20",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "854",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "関西ＤＣセンター",
    "内閣府No": "1-1",
    "内閣府プロジェクト名": "関西ＤＣセンター",
    "内閣府プロジェクト名２": "関西ＤＣセンター",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ニトリ",
    "事業期間（年度）": "H15-16",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "855",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "上組ロジスティックセンター",
    "内閣府No": "1-2",
    "内閣府プロジェクト名": "上組ロジスティックセンター",
    "内閣府プロジェクト名２": "上組ロジスティックセンター",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "上組",
    "事業期間（年度）": "H16-17",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "856",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ＵＳＳ神戸会場",
    "内閣府No": "1-3",
    "内閣府プロジェクト名": "ＵＳＳ神戸会場",
    "内閣府プロジェクト名２": "ＵＳＳ神戸会場",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ﾕｰ･ｴｽ･ｴｽ",
    "事業期間（年度）": "H16-17",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "857",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "神戸学院",
    "内閣府No": "1-4",
    "内閣府プロジェクト名": "神戸学院",
    "内閣府プロジェクト名２": "神戸学院",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "神戸学院",
    "事業期間（年度）": "？-H18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "858",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "兵庫医科大学",
    "内閣府No": "1-5",
    "内閣府プロジェクト名": "兵庫医科大学",
    "内閣府プロジェクト名２": "兵庫医科大学",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "兵庫医科大学",
    "事業期間（年度）": "？-H18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "859",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "神戸学院",
    "内閣府No": "1-6",
    "内閣府プロジェクト名": "神戸学院",
    "内閣府プロジェクト名２": "神戸学院",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "神戸学院",
    "事業期間（年度）": "？-H18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "860",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ポートアイランドドライビングスクール",
    "内閣府No": "1-7",
    "内閣府プロジェクト名": "ポートアイランドドライビングスクール",
    "内閣府プロジェクト名２": "ポートアイランドドライビングスクール",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "阪神興業",
    "事業期間（年度）": "？-H17",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "861",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "アルティス神戸ポートアイランド",
    "内閣府No": "1-8",
    "内閣府プロジェクト名": "アルティス神戸ポートアイランド",
    "内閣府プロジェクト名２": "アルティス神戸ポートアイランド",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "伊藤忠商事",
    "事業期間（年度）": "？-H18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "862",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "イトーピア神戸ポートアイランド",
    "内閣府No": "1-9",
    "内閣府プロジェクト名": "イトーピア神戸ポートアイランド",
    "内閣府プロジェクト名２": "イトーピア神戸ポートアイランド",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "伊藤忠都市開発",
    "事業期間（年度）": "？-H19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "863",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ポルトアーレミオKOBE",
    "内閣府No": "1-10",
    "内閣府プロジェクト名": "ポルトアーレミオKOBE",
    "内閣府プロジェクト名２": "ポルトアーレミオKOBE",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "近畿菱重興産",
    "事業期間（年度）": "？-H18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "864",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "金子真珠㈱",
    "内閣府No": "1-11",
    "内閣府プロジェクト名": "金子真珠㈱",
    "内閣府プロジェクト名２": "金子真珠㈱",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "金子真珠",
    "事業期間（年度）": "？-H18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "865",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "渋沢倉庫㈱",
    "内閣府No": "1-12",
    "内閣府プロジェクト名": "渋沢倉庫㈱",
    "内閣府プロジェクト名２": "渋沢倉庫㈱",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "渋沢倉庫",
    "事業期間（年度）": "H20-21",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "866",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大阪湾岸道路西神部整備に伴う地域活性化拠点整備事業",
    "内閣府No": "1-13",
    "内閣府プロジェクト名": "大阪湾岸道路西神部整備に伴う地域活性化拠点整備事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "",
    "状況": "",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "867",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "神戸医療産業都市",
    "内閣府No": "2",
    "内閣府プロジェクト名": "神戸医療産業都市",
    "内閣府プロジェクト名２": "神戸医療産業都市構想",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "",
    "状況": "",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "868",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "先端医療センター",
    "内閣府No": "2-1",
    "内閣府プロジェクト名": "先端医療センター",
    "内閣府プロジェクト名２": "先端医療センター",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "神戸市民病院機構",
    "事業期間（年度）": "？-H15",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "869",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "理化学研究所",
    "内閣府No": "2-2",
    "内閣府プロジェクト名": "理化学研究所",
    "内閣府プロジェクト名２": "理化学研究所",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "理化学研究所",
    "事業期間（年度）": "？-H22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "870",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "神戸臨床研究情報センター",
    "内閣府No": "2-3",
    "内閣府プロジェクト名": "神戸臨床研究情報センター",
    "内閣府プロジェクト名２": "神戸臨床研究情報センター",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "民間",
    "事業期間（年度）": "？-H14",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "871",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "神戸バイオメディカル創造センター",
    "内閣府No": "2-4",
    "内閣府プロジェクト名": "神戸バイオメディカル創造センター",
    "内閣府プロジェクト名２": "神戸バイオメディカル創造センター",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "民間",
    "事業期間（年度）": "？-H15",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "872",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "神戸バイオテクノロジー研究・人材育成センター/神戸大学インキュベーションセンター",
    "内閣府No": "2-5",
    "内閣府プロジェクト名": "神戸バイオテクノロジー研究・人材育成センター/神戸大学インキュベーションセンター",
    "内閣府プロジェクト名２": "神戸バイオテクノロジー研究・人材育成センター/神戸大学インキュベーションセンター",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "神戸大学",
    "事業期間（年度）": "？-H15",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "873",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "神戸医療機器開発センター",
    "内閣府No": "2-6",
    "内閣府プロジェクト名": "神戸医療機器開発センター",
    "内閣府プロジェクト名２": "神戸医療機器開発センター",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "中小企業基盤整備機構",
    "事業期間（年度）": "？-H17",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "874",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "神戸健康産業開発センター",
    "内閣府No": "2-7",
    "内閣府プロジェクト名": "神戸健康産業開発センター",
    "内閣府プロジェクト名２": "神戸健康産業開発センター",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "中小企業基盤整備機構",
    "事業期間（年度）": "？-H18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "875",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "理化学研究所",
    "内閣府No": "2-8",
    "内閣府プロジェクト名": "理化学研究所",
    "内閣府プロジェクト名２": "理化学研究所",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "理化学研究所",
    "事業期間（年度）": "？-H18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "876",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "神戸キメックセンタービル",
    "内閣府No": "2-9",
    "内閣府プロジェクト名": "神戸キメックセンタービル",
    "内閣府プロジェクト名２": "神戸キメックセンタービル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "民間",
    "事業期間（年度）": "？-H18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "877",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "神戸国際ビジネスセンター",
    "内閣府No": "2-10",
    "内閣府プロジェクト名": "神戸国際ビジネスセンター",
    "内閣府プロジェクト名２": "神戸国際ビジネスセンター",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "民間",
    "事業期間（年度）": "？-H14",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "878",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "神戸ハイブリッドビジネスセンター",
    "内閣府No": "2-11",
    "内閣府プロジェクト名": "神戸ハイブリッドビジネスセンター",
    "内閣府プロジェクト名２": "神戸ハイブリッドビジネスセンター",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "民間",
    "事業期間（年度）": "？-H22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "879",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "国際医療開発センター",
    "内閣府No": "2-12",
    "内閣府プロジェクト名": "国際医療開発センター",
    "内閣府プロジェクト名２": "国際医療開発センター",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "民間",
    "事業期間（年度）": "？-H22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "880",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "高度計算科学研究支援センター",
    "内閣府No": "2-13",
    "内閣府プロジェクト名": "高度計算科学研究支援センター",
    "内閣府プロジェクト名２": "高度計算科学研究支援センター",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "民間",
    "事業期間（年度）": "？-H22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "881",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "神戸低侵襲がん医療センター",
    "内閣府No": "2-14",
    "内閣府プロジェクト名": "神戸低侵襲がん医療センター",
    "内閣府プロジェクト名２": "神戸低侵襲がん医療センター",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "民間",
    "事業期間（年度）": "？-H24",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "882",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "チャイルド・ケモ・ハウス",
    "内閣府No": "2-15",
    "内閣府プロジェクト名": "チャイルド・ケモ・ハウス",
    "内閣府プロジェクト名２": "チャイルド・ケモ・ハウス",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "民間",
    "事業期間（年度）": "？-H25",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "883",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "西記念ポートアイランドリハビリテーション病院",
    "内閣府No": "2-16",
    "内閣府プロジェクト名": "西記念ポートアイランドリハビリテーション病院",
    "内閣府プロジェクト名２": "西記念ポートアイランドリハビリテーション病院",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "民間",
    "事業期間（年度）": "？-H24",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "884",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "インターナショナルメディカルプラザ",
    "内閣府No": "2-17",
    "内閣府プロジェクト名": "インターナショナルメディカルプラザ",
    "内閣府プロジェクト名２": "インターナショナルメディカルプラザ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "民間",
    "事業期間（年度）": "？-H26",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "885",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "神戸大学先端融合研究環統合研究拠点アネックス",
    "内閣府No": "2-18",
    "内閣府プロジェクト名": "神戸大学先端融合研究環統合研究拠点アネックス",
    "内閣府プロジェクト名２": "神戸大学先端融合研究環統合研究拠点アネックス",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "民間",
    "事業期間（年度）": "？-H26",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "886",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "理化学研究所",
    "内閣府No": "2-19",
    "内閣府プロジェクト名": "理化学研究所",
    "内閣府プロジェクト名２": "理化学研究所",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "理化学研究所",
    "事業期間（年度）": "？-H26",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "887",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "兵庫県立こども病院",
    "内閣府No": "2-20",
    "内閣府プロジェクト名": "兵庫県立こども病院",
    "内閣府プロジェクト名２": "兵庫県立こども病院",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "兵庫県",
    "事業期間（年度）": "？-H28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "888",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "神戸医療イノベーションセンター",
    "内閣府No": "2-21",
    "内閣府プロジェクト名": "神戸医療イノベーションセンター",
    "内閣府プロジェクト名２": "神戸医療イノベーションセンター",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "民間",
    "事業期間（年度）": "？-H29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "889",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "神戸大学医学部附属病院国際がん医療・研究センター",
    "内閣府No": "2-22",
    "内閣府プロジェクト名": "神戸大学医学部附属病院国際がん医療・研究センター",
    "内閣府プロジェクト名２": "神戸大学医学部附属病院国際がん医療・研究センター",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "神戸大学",
    "事業期間（年度）": "？-H29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "890",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "神戸アイセンター",
    "内閣府No": "2-23",
    "内閣府プロジェクト名": "神戸アイセンター",
    "内閣府プロジェクト名２": "神戸アイセンター",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "神戸市民病院機構",
    "事業期間（年度）": "？-H29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "891",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "兵庫県立粒子線医療センター附属 神戸陽子線センター",
    "内閣府No": "2-24",
    "内閣府プロジェクト名": "兵庫県立粒子線医療センター附属 神戸陽子線センター",
    "内閣府プロジェクト名２": "兵庫県立粒子線医療センター附属 神戸陽子線センター",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "兵庫県",
    "事業期間（年度）": "？-H29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "892",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "Creative Lab for Innovation in Kobe（CLIK）",
    "内閣府No": "2-25",
    "内閣府プロジェクト名": "Creative Lab for Innovation in Kobe（CLIK）",
    "内閣府プロジェクト名２": "Creative Lab for Innovation in Kobe（CLIK）",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "民間",
    "事業期間（年度）": "？-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "893",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "幹線道路",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "幹線道路",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H17-？",
    "状況": "",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "894",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "幹線道路",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "幹線道路",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H17-？",
    "状況": "",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "895",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "幹線道路",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "幹線道路",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "",
    "状況": "",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "896",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "歩行者デッキ",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "歩行者デッキ",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "",
    "状況": "",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "897",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "交流拠点用地",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "交流拠点用地",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H17-？",
    "状況": "",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "898",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "緑地",
    "内閣府No": "カ",
    "内閣府プロジェクト名": "緑地",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H17-？",
    "状況": "",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "899",
    "地域No": "41",
    "地域名": "神戸ポートアイランド西地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "幹線道路",
    "内閣府No": "キ",
    "内閣府プロジェクト名": "幹線道路",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H17-未定",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "900",
    "地域No": "42",
    "地域名": "【特定】神戸都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "神戸新聞社跡地ビル計画",
    "内閣府No": "1",
    "内閣府プロジェクト名": "神戸新聞社跡地ビル計画",
    "内閣府プロジェクト名２": "神戸新聞会館　ミント神戸",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "神戸新聞会館",
    "事業期間（年度）": "H16-18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "901",
    "地域No": "42",
    "地域名": "【特定】神戸都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "旭通４丁目地区第一種市街地再開発事業",
    "内閣府No": "2",
    "内閣府プロジェクト名": "旭通４丁目地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "シティタワー神戸三宮",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H21-24",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "902",
    "地域No": "42",
    "地域名": "【特定】神戸都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "新港第１突堤再開発",
    "内閣府No": "3",
    "内閣府プロジェクト名": "新港第１突堤再開発",
    "内閣府プロジェクト名２": "ラ・スイート神戸オーシャンズガーデン",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ラスイート",
    "事業期間（年度）": "H25-27",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "903",
    "地域No": "42",
    "地域名": "【特定】神戸都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "総合福利厚生施設整備",
    "内閣府No": "4",
    "内閣府プロジェクト名": "総合福利厚生施設整備",
    "内閣府プロジェクト名２": "神戸ポートオアシス",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "神戸市",
    "事業期間（年度）": "H27-29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "904",
    "地域No": "42",
    "地域名": "【特定】神戸都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "新港突堤西地区（第1突堤基部）再開発",
    "内閣府No": "5",
    "内閣府プロジェクト名": "新港突堤西地区（第1突堤基部）再開発",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "住友不動産、関電不動産開発、SMBC信託銀行、AQUART神戸、AQUART PARK神戸、デカンショライオン、フェリシモ",
    "事業期間（年度）": "R1-7",
    "状況": "事業中",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "●",
    "税制支援（都市再生）": "●",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "905",
    "地域No": "42",
    "地域名": "【特定】神戸都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "神戸阪急ビル東館建替及び西館リニューアル計画",
    "内閣府No": "6",
    "内閣府プロジェクト名": "神戸阪急ビル東館建替及び西館リニューアル計画",
    "内閣府プロジェクト名２": "神戸三宮阪急ビル",
    "特定地域整備計画No": "①",
    "特定地域整備計画名": "神戸阪急ビル東館建替及び西館リニューアル計画",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "阪急電鉄",
    "事業期間（年度）": "H29-R3",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "906",
    "地域No": "42",
    "地域名": "【特定】神戸都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "神戸三宮雲井通５丁目地区第一種市街地再開発",
    "内閣府No": "7",
    "内閣府プロジェクト名": "神戸三宮雲井通５丁目地区第一種市街地再開発",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "②",
    "特定地域整備計画名": "神戸三宮雲井通５丁目地区市街地再開発事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発株式会社",
    "事業期間（年度）": "R4-9",
    "状況": "事業中",
    "都市再生特別地区": "●",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "●",
    "区画整理再開発": "●",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "907",
    "地域No": "42",
    "地域名": "【特定】神戸都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）神戸市役所本庁舎２号館再整備事業",
    "内閣府No": "8",
    "内閣府プロジェクト名": "（仮称）神戸市役所本庁舎２号館再整備事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "③",
    "特定地域整備計画名": "神戸市役所本庁舎２号館再整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R4-9",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "908",
    "地域No": "42",
    "地域名": "【特定】神戸都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "新港突堤西地区（第2突堤）再開発",
    "内閣府No": "9",
    "内閣府プロジェクト名": "新港突堤西地区（第2突堤）再開発",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "NTT都市開発、スマートバリュー、NTTドコモ",
    "事業期間（年度）": "R4-6",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "●",
    "税制支援（都市再生）": "●",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "909",
    "地域No": "42",
    "地域名": "【特定】神戸都心・臨海地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "JR三ノ宮新駅ビル開発計画",
    "内閣府No": "10",
    "内閣府プロジェクト名": "JR三ノ宮新駅ビル開発計画",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "④",
    "特定地域整備計画名": "JR三ノ宮新駅ビル開発計画",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "JR西日本、UR",
    "事業期間（年度）": "R5-11",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "910",
    "地域No": "42",
    "地域名": "【特定】神戸都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "三宮駅南交通広場",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "三宮駅南交通広場",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H16-18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "911",
    "地域No": "42",
    "地域名": "【特定】神戸都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "三宮駅前東線",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "三宮駅前東線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H17-24",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "912",
    "地域No": "42",
    "地域名": "【特定】神戸都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "三宮駅前東地下線",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "三宮駅前東地下線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H17-24",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "913",
    "地域No": "42",
    "地域名": "【特定】神戸都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "葺合南54号線（都心部における道路のリデザイン事業）",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "葺合南54号線（都心部における道路のリデザイン事業）",
    "内閣府プロジェクト名２": "葺合南54号線のリデザイン",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H27-R3",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "914",
    "地域No": "42",
    "地域名": "【特定】神戸都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "三宮プラッツリニューアル",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "三宮プラッツリニューアル",
    "内閣府プロジェクト名２": "三宮プラッツ",
    "特定地域整備計画No": "○ア",
    "特定地域整備計画名": "三宮プラッツリニューアル",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "神戸市",
    "事業期間（年度）": "R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "915",
    "地域No": "42",
    "地域名": "【特定】神戸都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "一般国道２号　神戸三宮駅交通ターミナル整備事業（新バスターミナル（Ⅰ期））",
    "内閣府No": "カ",
    "内閣府プロジェクト名": "一般国道２号　神戸三宮駅交通ターミナル整備事業（新バスターミナル（Ⅰ期））",
    "内閣府プロジェクト名２": "新バスターミナル（Ⅰ期）",
    "特定地域整備計画No": "○イ",
    "特定地域整備計画名": "（仮称）新三宮バスターミナル（Ⅰ期）",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "国土交通省",
    "事業期間（年度）": "R3-9",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "916",
    "地域No": "42",
    "地域名": "【特定】神戸都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "（仮称）新三宮図書館整備事業",
    "内閣府No": "キ",
    "内閣府プロジェクト名": "（仮称）新三宮図書館整備事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○ウ",
    "特定地域整備計画名": "（仮称）三宮図書館整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "神戸市",
    "事業期間（年度）": "R3-9",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "917",
    "地域No": "42",
    "地域名": "【特定】神戸都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "（仮称）新・神戸文化ホール整備事業",
    "内閣府No": "ク",
    "内閣府プロジェクト名": "（仮称）新・神戸文化ホール整備事業",
    "内閣府プロジェクト名２": "大ホール（多目的ホール）",
    "特定地域整備計画No": "○エ",
    "特定地域整備計画名": "（仮称）新・神戸文化ホール大ホール（多目的ホール）",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "神戸市",
    "事業期間（年度）": "R3-9",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "918",
    "地域No": "42",
    "地域名": "【特定】神戸都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "新交通三宮駅改良事業",
    "内閣府No": "ケ",
    "内閣府プロジェクト名": "新交通三宮駅改良事業",
    "内閣府プロジェクト名２": "ポートライナー三宮駅",
    "特定地域整備計画No": "○オ",
    "特定地域整備計画名": "新交通三宮駅改良事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "神戸市、神戸新交通",
    "事業期間（年度）": "R1-4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "919",
    "地域No": "42",
    "地域名": "【特定】神戸都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "三宮駅周辺デッキ整備",
    "内閣府No": "コ",
    "内閣府プロジェクト名": "三宮駅周辺デッキ整備",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○カ",
    "特定地域整備計画名": "三宮駅周辺デッキ整備",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "神戸市",
    "事業期間（年度）": "R2-13",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "●",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "●",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "920",
    "地域No": "42",
    "地域名": "【特定】神戸都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "新港突堤西地区（第1突堤基部）再開発※5のなかで実施",
    "内閣府No": "サ",
    "内閣府プロジェクト名": "新港突堤西地区（第1突堤基部）再開発※5のなかで実施",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R1-7",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "921",
    "地域No": "42",
    "地域名": "【特定】神戸都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "新港突堤西地区（第２突堤）再開発※9のなかで実施",
    "内閣府No": "シ",
    "内閣府プロジェクト名": "新港突堤西地区（第２突堤）再開発※9のなかで実施",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R4-6",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "922",
    "地域No": "42",
    "地域名": "【特定】神戸都心・臨海地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "磯上公園再整備",
    "内閣府No": "ス",
    "内閣府プロジェクト名": "磯上公園再整備",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R4-5",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "●",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": "周辺道路もウォーカブル"
  },
  {
    "key": "923",
    "地域No": "43",
    "地域名": "岡山駅周辺・表町地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "大型ショッピングセンター",
    "内閣府No": "1",
    "内閣府プロジェクト名": "大型ショッピングセンター",
    "内閣府プロジェクト名２": "イオンモール岡山",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "イオンモール",
    "事業期間（年度）": "H25-26",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "924",
    "地域No": "43",
    "地域名": "岡山駅周辺・表町地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "出石小学校跡地整備事業",
    "内閣府No": "2",
    "内閣府プロジェクト名": "出石小学校跡地整備事業",
    "内閣府プロジェクト名２": "おかやまインターパークス",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "両備バスほか４社",
    "事業期間（年度）": "H17-19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "925",
    "地域No": "43",
    "地域名": "岡山駅周辺・表町地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "岡山市本町8番地区第一種市街地再開発事業",
    "内閣府No": "3",
    "内閣府プロジェクト名": "岡山市本町8番地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "本町プラザ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H18-19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "926",
    "地域No": "43",
    "地域名": "岡山駅周辺・表町地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "柳町二丁目1番地区開発事業",
    "内閣府No": "4",
    "内閣府プロジェクト名": "柳町二丁目1番地区開発事業",
    "内閣府プロジェクト名２": "山陽新聞社本社ビル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "山陽新聞社",
    "事業期間（年度）": "H16-18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "927",
    "地域No": "43",
    "地域名": "岡山駅周辺・表町地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "岡山市本町4番地区優良建築物等整備事業",
    "内閣府No": "5",
    "内閣府プロジェクト名": "岡山市本町4番地区優良建築物等整備事業",
    "内閣府プロジェクト名２": "コア本町",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "本町都市開発",
    "事業期間（年度）": "H12-14",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "928",
    "地域No": "43",
    "地域名": "岡山駅周辺・表町地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "岡山中央南小学校跡地活用事業",
    "内閣府No": "6",
    "内閣府プロジェクト名": "岡山中央南小学校跡地活用事業",
    "内閣府プロジェクト名２": "川崎病院",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "川崎学園",
    "事業期間（年度）": "H25-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "929",
    "地域No": "43",
    "地域名": "岡山駅周辺・表町地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "岡山市平和町1番地区第一種市街地再開発事業",
    "内閣府No": "7",
    "内閣府プロジェクト名": "岡山市平和町1番地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "ルミノ平和町",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H18-20",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "930",
    "地域No": "43",
    "地域名": "岡山駅周辺・表町地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "岡山市中山下一丁目1番地区第一種市街地再開発事業",
    "内閣府No": "8",
    "内閣府プロジェクト名": "岡山市中山下一丁目1番地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "ハレクロスタワー",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H27-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "931",
    "地域No": "43",
    "地域名": "岡山駅周辺・表町地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "岡山市駅元町地区第二種市街地再開発事業",
    "内閣府No": "9",
    "内閣府プロジェクト名": "岡山市駅元町地区第二種市街地再開発事業",
    "内閣府プロジェクト名２": "フォーラムシティビル、リットシティビル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "岡山市",
    "事業期間（年度）": "H10-17",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "932",
    "地域No": "43",
    "地域名": "岡山駅周辺・表町地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "岡山市野田屋町一丁目２番３番地区第一種市街地再開発事業",
    "内閣府No": "10",
    "内閣府プロジェクト名": "岡山市野田屋町一丁目２番３番地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "R6-8",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "933",
    "地域No": "43",
    "地域名": "岡山駅周辺・表町地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "岡山市蕃山町1番地区第一種市街地再開発事業",
    "内閣府No": "11",
    "内閣府プロジェクト名": "岡山市蕃山町1番地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "R4-7",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "934",
    "地域No": "43",
    "地域名": "岡山駅周辺・表町地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "岡山市駅前町一丁目2番3番4番地区第一種市街地再開発事業",
    "内閣府No": "12",
    "内閣府プロジェクト名": "岡山市駅前町一丁目2番3番4番地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "R4-8",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "935",
    "地域No": "43",
    "地域名": "岡山駅周辺・表町地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "旧後楽館中・高（天神校舎）跡地活用事業",
    "内閣府No": "13",
    "内閣府プロジェクト名": "旧後楽館中・高（天神校舎）跡地活用事業",
    "内閣府プロジェクト名２": "RSKイノベイティブ・メディアセンター",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "RSKホールディングス",
    "事業期間（年度）": "H30-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "936",
    "地域No": "43",
    "地域名": "岡山駅周辺・表町地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "岡山市表町一丁目1番地区第一種市街地再開発事業",
    "内閣府No": "14",
    "内閣府プロジェクト名": "岡山市表町一丁目1番地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "R5-8",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "937",
    "地域No": "43",
    "地域名": "岡山駅周辺・表町地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "岡山市天神町10番地区第一種市街地再開発事業",
    "内閣府No": "15",
    "内閣府プロジェクト名": "岡山市天神町10番地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "R6-8",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "938",
    "地域No": "43",
    "地域名": "岡山駅周辺・表町地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "都市計画道路下石井岩井線",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "都市計画道路下石井岩井線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H6-17",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "939",
    "地域No": "43",
    "地域名": "岡山駅周辺・表町地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "岡山駅西口交通広場",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "岡山駅西口交通広場",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H15-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "940",
    "地域No": "43",
    "地域名": "岡山駅周辺・表町地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "岡山駅東西連絡通路",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "岡山駅東西連絡通路",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H15-19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "941",
    "地域No": "43",
    "地域名": "岡山駅周辺・表町地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "下石井公園",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "下石井公園",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R4-5",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "●",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "942",
    "地域No": "43",
    "地域名": "岡山駅周辺・表町地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "コミュニティ施設",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "コミュニティ施設",
    "内閣府プロジェクト名２": "岡山市出石コミュニティハウス",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "？-H20",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "943",
    "地域No": "43",
    "地域名": "岡山駅周辺・表町地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "市道錦町古京町線（県庁通り）歩いて楽しい道路空間創出事業",
    "内閣府No": "カ",
    "内閣府プロジェクト名": "市道錦町古京町線（県庁通り）歩いて楽しい道路空間創出事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R1-3",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "944",
    "地域No": "43",
    "地域名": "岡山駅周辺・表町地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "岡山駅前広場への路面電車乗り入れ整備事業",
    "内閣府No": "キ",
    "内閣府プロジェクト名": "岡山駅前広場への路面電車乗り入れ整備事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R3-7",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "●",
    "その他支援": ""
  },
  {
    "key": "945",
    "地域No": "44",
    "地域名": "【特定】広島都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ひろぎんホールディングス本社ビル",
    "内閣府No": "1",
    "内閣府プロジェクト名": "ひろぎんホールディングス本社ビル",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "広島銀行",
    "事業期間（年度）": "H30-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "946",
    "地域No": "44",
    "地域名": "【特定】広島都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "基町相生通地区第一種市街地再開発事業",
    "内閣府No": "2",
    "内閣府プロジェクト名": "基町相生通地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR、朝日新聞社、朝日ビルディング、中国電力ネットワーク",
    "事業期間（年度）": "R5-11",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "947",
    "地域No": "44",
    "地域名": "【特定】広島都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "広島市中区富士見町地区フルサービスホテル建設プロジェクト",
    "内閣府No": "3",
    "内閣府プロジェクト名": "広島市中区富士見町地区フルサービスホテル建設プロジェクト",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "開発合同会社",
    "事業期間（年度）": "R1-4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "948",
    "地域No": "44",
    "地域名": "【特定】広島都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "広島駅南口計画（仮称）（広島東郵便局敷地）",
    "内閣府No": "4",
    "内閣府プロジェクト名": "広島駅南口計画（仮称）（広島東郵便局敷地）",
    "内閣府プロジェクト名２": "広島JPビルディング",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "日本郵便",
    "事業期間（年度）": "R2-4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "949",
    "地域No": "44",
    "地域名": "【特定】広島都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "広島駅ビルの建替え計画",
    "内閣府No": "5",
    "内閣府プロジェクト名": "広島駅ビルの建替え計画",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "JR西日本、ＪＲ西日本不動産開発、中国ＳＣ開発、JR西日本ホテル開発",
    "事業期間（年度）": "R2-7",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "●",
    "税制支援（都市再生）": "●",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "950",
    "地域No": "44",
    "地域名": "【特定】広島都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "東横INN広島駅スタジアム前",
    "内閣府No": "6",
    "内閣府プロジェクト名": "東横INN広島駅スタジアム前",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東横イン",
    "事業期間（年度）": "R1-3",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "951",
    "地域No": "44",
    "地域名": "【特定】広島都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "中央公園ｻｯｶｰｽﾀｼﾞｱﾑ（仮称）",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "中央公園ｻｯｶｰｽﾀｼﾞｱﾑ（仮称）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R3-6",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "●",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "952",
    "地域No": "44",
    "地域名": "【特定】広島都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "旧広島市民球場跡地の活用",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "旧広島市民球場跡地の活用",
    "内閣府プロジェクト名２": "旧広島市民球場跡地イベント広場",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "953",
    "地域No": "44",
    "地域名": "【特定】広島都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "都市計画道路　東部線",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "都市計画道路　東部線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H12-R6",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "954",
    "地域No": "44",
    "地域名": "【特定】広島都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "広島駅南口広場の再整備等",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "広島駅南口広場の再整備等",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R2-8",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "●",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "●",
    "都市・地域交通戦略推進事業": "●",
    "その他支援": ""
  },
  {
    "key": "955",
    "地域No": "44",
    "地域名": "【特定】広島都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "広島駅・市民球場間歩行者用道路",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "広島駅・市民球場間歩行者用道路",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H28-R7",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "●",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "956",
    "地域No": "45",
    "地域名": "福山駅南地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "東桜町地区第一種市街地再開発事業",
    "内閣府No": "1",
    "内閣府プロジェクト名": "東桜町地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "ines FUKUYAMA（アイネスフクヤマ）",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "福山駅前開発",
    "事業期間（年度）": "H20-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "957",
    "地域No": "45",
    "地域名": "福山駅南地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "福山駅前市街地再開発事業（予定）",
    "内閣府No": "2",
    "内閣府プロジェクト名": "福山駅前市街地再開発事業（予定）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "958",
    "地域No": "45",
    "地域名": "福山駅南地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "三之丸町地区優良建築物等整備事業",
    "内閣府No": "3",
    "内閣府プロジェクト名": "三之丸町地区優良建築物等整備事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "穴吹興産、キョーエイネクスト、トモテツ不動産",
    "事業期間（年度）": "R1-5",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "959",
    "地域No": "45",
    "地域名": "福山駅南地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "福山駅前広場",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "福山駅前広場",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H18-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "960",
    "地域No": "45",
    "地域名": "福山駅南地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "福山駅西町線",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "福山駅西町線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H16-18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "961",
    "地域No": "45",
    "地域名": "福山駅南地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "福山駅南自転車駐車場",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "福山駅南自転車駐車場",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H16-18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "962",
    "地域No": "45",
    "地域名": "福山駅南地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "福山東警察署駅前交番",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "福山東警察署駅前交番",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R4-5",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "963",
    "地域No": "46",
    "地域名": "高松駅周辺･丸亀町地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "高松地方合同庁舎整備事業",
    "内閣府No": "1",
    "内閣府プロジェクト名": "高松地方合同庁舎整備事業",
    "内閣府プロジェクト名２": "高松サンポート合同庁舎",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "国土交通省",
    "事業期間（年度）": "H16-29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "964",
    "地域No": "46",
    "地域名": "高松駅周辺･丸亀町地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "高松丸亀町商店街Ａ街区第一種市街地再開発事業",
    "内閣府No": "2",
    "内閣府プロジェクト名": "高松丸亀町商店街Ａ街区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "高松丸亀町壱番街",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H16-18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "965",
    "地域No": "46",
    "地域名": "高松駅周辺･丸亀町地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "高松丸亀町商店街Ｇ街区第一種市街地再開発事業",
    "内閣府No": "3",
    "内閣府プロジェクト名": "高松丸亀町商店街Ｇ街区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "丸亀町グリーン",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H22-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "966",
    "地域No": "46",
    "地域名": "高松駅周辺･丸亀町地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "小規模連鎖型再開発事業（高松丸亀町商店街Ｂ・Ｃ街区）",
    "内閣府No": "4",
    "内閣府プロジェクト名": "小規模連鎖型再開発事業（高松丸亀町商店街Ｂ・Ｃ街区）",
    "内閣府プロジェクト名２": "高松丸亀町弐番街・参番街",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "高松丸亀町まちづくり",
    "事業期間（年度）": "H20-21",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "967",
    "地域No": "46",
    "地域名": "高松駅周辺･丸亀町地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "高松市大工町・磨屋町地区第一種市街地再開発事業",
    "内閣府No": "5",
    "内閣府プロジェクト名": "高松市大工町・磨屋町地区第一種市街地再開発事業",
    "内閣府プロジェクト名２": "（仮称）高松大工町・磨屋町街区",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "R2-5",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "968",
    "地域No": "46",
    "地域名": "高松駅周辺･丸亀町地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "新県立体育館整備事業",
    "内閣府No": "6",
    "内閣府プロジェクト名": "新県立体育館整備事業",
    "内閣府プロジェクト名２": "新香川県立体育館",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "香川県",
    "事業期間（年度）": "R4-6",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "969",
    "地域No": "46",
    "地域名": "高松駅周辺･丸亀町地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "隔地駐車場",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "隔地駐車場",
    "内閣府プロジェクト名２": "高松丸亀町壱番街駐車場",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H16-18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "970",
    "地域No": "46",
    "地域名": "高松駅周辺･丸亀町地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "市道内町１号線",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "市道内町１号線",
    "内閣府プロジェクト名２": "市道内町１号線",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H17-18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "971",
    "地域No": "46",
    "地域名": "高松駅周辺･丸亀町地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "丸亀町栗林線",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "丸亀町栗林線",
    "内閣府プロジェクト名２": "丸亀町栗林線",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H18-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "972",
    "地域No": "48",
    "地域名": "小倉駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "小倉駅南口東地区市街地再開発事業",
    "内閣府No": "1",
    "内閣府プロジェクト名": "小倉駅南口東地区市街地再開発事業",
    "内閣府プロジェクト名２": "ガーデンシティ小倉",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H28-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "973",
    "地域No": "48",
    "地域名": "小倉駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "室町一丁目地区（第二期）市街地再開発事業",
    "内閣府No": "2",
    "内閣府プロジェクト名": "室町一丁目地区（第二期）市街地再開発事業",
    "内閣府プロジェクト名２": "リバーウォーク北九州",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H16-17",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "974",
    "地域No": "48",
    "地域名": "小倉駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "西小倉駅前第一地区市街地再開発事業",
    "内閣府No": "3",
    "内閣府プロジェクト名": "西小倉駅前第一地区市街地再開発事業",
    "内閣府プロジェクト名２": "小倉D.C.タワー",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "H20-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "975",
    "地域No": "48",
    "地域名": "小倉駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "馬借一丁目1番地区優良建築物等整備事業",
    "内閣府No": "4",
    "内閣府プロジェクト名": "馬借一丁目1番地区優良建築物等整備事業",
    "内閣府プロジェクト名２": "小倉タワー",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "SPC",
    "事業期間（年度）": "H17-19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "976",
    "地域No": "48",
    "地域名": "小倉駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "スタジアム整備事業",
    "内閣府No": "5",
    "内閣府プロジェクト名": "スタジアム整備事業",
    "内閣府プロジェクト名２": "ミクニワールドスタジアム北九州（北九州スタジアム）",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ウインドシップ北九州",
    "事業期間（年度）": "H27-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "977",
    "地域No": "48",
    "地域名": "小倉駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "浅野三丁目総合計画",
    "内閣府No": "6",
    "内閣府プロジェクト名": "浅野三丁目総合計画",
    "内閣府プロジェクト名２": "ソレイユ浅野、あべりあ浅野",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "正勇会",
    "事業期間（年度）": "H26-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "978",
    "地域No": "48",
    "地域名": "小倉駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "旦過地区土地区画整理事業",
    "内閣府No": "7",
    "内閣府プロジェクト名": "旦過地区土地区画整理事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "北九州市",
    "事業期間（年度）": "R2-9",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "●",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "979",
    "地域No": "48",
    "地域名": "小倉駅周辺地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "魚町三丁目５番地区優良建築物等整備事業",
    "内閣府No": "8",
    "内閣府プロジェクト名": "魚町三丁目５番地区優良建築物等整備事業",
    "内閣府プロジェクト名２": "（仮称）ミクニ魚町ビル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ミクニ",
    "事業期間（年度）": "R4-5",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "980",
    "地域No": "48",
    "地域名": "小倉駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "神獄川都市基盤河川改修事業",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "神獄川都市基盤河川改修事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "S45-R15",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "981",
    "地域No": "48",
    "地域名": "小倉駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "都市計画道路博労町線",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "都市計画道路博労町線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H11-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "982",
    "地域No": "48",
    "地域名": "小倉駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "都市計画道路小倉中央線",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "都市計画道路小倉中央線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "983",
    "地域No": "48",
    "地域名": "小倉駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "国道199号砂津バイパス",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "国道199号砂津バイパス",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H20-R1",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "984",
    "地域No": "48",
    "地域名": "小倉駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "浅野1号線道路改築事業",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "浅野1号線道路改築事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H26-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "985",
    "地域No": "48",
    "地域名": "小倉駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "浅野1号線横断歩道橋",
    "内閣府No": "カ",
    "内閣府プロジェクト名": "浅野1号線横断歩道橋",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H27-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "986",
    "地域No": "48",
    "地域名": "小倉駅周辺地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "浅野33号線道路改築事業",
    "内閣府No": "キ",
    "内閣府プロジェクト名": "浅野33号線道路改築事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H26",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "987",
    "地域No": "49",
    "地域名": "福岡箱崎地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "福岡広域都市計画事業貝塚駅周辺土地区画整理事業",
    "内閣府No": "1",
    "内閣府プロジェクト名": "福岡広域都市計画事業貝塚駅周辺土地区画整理事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "福岡市",
    "事業期間（年度）": "R4-10",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "●",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "988",
    "地域No": "49",
    "地域名": "福岡箱崎地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "住宅市街地総合整備事業　箱崎地区（福岡市東区箱崎三丁目ほか）",
    "内閣府No": "2",
    "内閣府プロジェクト名": "住宅市街地総合整備事業　箱崎地区（福岡市東区箱崎三丁目ほか）",
    "内閣府プロジェクト名２": "九大箱崎南地区開発行為",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR",
    "事業期間（年度）": "R2-4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "989",
    "地域No": "49",
    "地域名": "福岡箱崎地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "都市計画道路堅粕箱崎線整備事業",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "都市計画道路堅粕箱崎線整備事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R2-6",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "990",
    "地域No": "49",
    "地域名": "福岡箱崎地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "都市計画道路原田箱崎線整備事業",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "都市計画道路原田箱崎線整備事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R2-6",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "991",
    "地域No": "50",
    "地域名": "福岡香椎・臨海東地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "香椎団地の建替",
    "内閣府No": "1",
    "内閣府プロジェクト名": "香椎団地の建替",
    "内閣府プロジェクト名２": "アーベインルネス香椎",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR",
    "事業期間（年度）": "H11-20",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "992",
    "地域No": "50",
    "地域名": "福岡香椎・臨海東地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "香椎副都心土地区画整理事業",
    "内閣府No": "2",
    "内閣府プロジェクト名": "香椎副都心土地区画整理事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR",
    "事業期間（年度）": "H5-24",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "993",
    "地域No": "50",
    "地域名": "福岡香椎・臨海東地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ＮＴＴドコモ香椎ビル",
    "内閣府No": "2-1",
    "内閣府プロジェクト名": "ＮＴＴドコモ香椎ビル",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ＮＴＴドコモ九州",
    "事業期間（年度）": "H13-15",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "994",
    "地域No": "50",
    "地域名": "福岡香椎・臨海東地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "アルカーサル　アヴィオ（結婚式場）",
    "内閣府No": "2-2",
    "内閣府プロジェクト名": "アルカーサル　アヴィオ（結婚式場）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "JR九州",
    "事業期間（年度）": "H20",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "995",
    "地域No": "50",
    "地域名": "福岡香椎・臨海東地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "MJRザ千早",
    "内閣府No": "2-3",
    "内閣府プロジェクト名": "MJRザ千早",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "JR九州",
    "事業期間（年度）": "H20-21",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "996",
    "地域No": "50",
    "地域名": "福岡香椎・臨海東地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "D’グラフォート千早ステーションレジデンス",
    "内閣府No": "2-4",
    "内閣府プロジェクト名": "D’グラフォート千早ステーションレジデンス",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "大和ハウス工業",
    "事業期間（年度）": "H17-18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "997",
    "地域No": "50",
    "地域名": "福岡香椎・臨海東地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "プレミスト千早タワー　ツインマークス",
    "内閣府No": "2-5",
    "内閣府プロジェクト名": "プレミスト千早タワー　ツインマークス",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "大和ハウス工業",
    "事業期間（年度）": "H19-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "998",
    "地域No": "50",
    "地域名": "福岡香椎・臨海東地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "香椎駅周辺土地区画整理事業",
    "内閣府No": "3",
    "内閣府プロジェクト名": "香椎駅周辺土地区画整理事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "福岡市",
    "事業期間（年度）": "H11-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "999",
    "地域No": "50",
    "地域名": "福岡香椎・臨海東地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "照葉のまちづくり事業",
    "内閣府No": "4",
    "内閣府プロジェクト名": "照葉のまちづくり事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "アイランドシティ住宅開発企業連合体、博多港開発",
    "事業期間（年度）": "H16-R6",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1000",
    "地域No": "50",
    "地域名": "福岡香椎・臨海東地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "香椎照葉３丁目地区事業",
    "内閣府No": "5",
    "内閣府プロジェクト名": "香椎照葉３丁目地区事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "新栄住宅、Ｃ・Ｎ・Ａグループ、伯洋海運、アイランドフォレストタワー分譲事業・共同事業体、エストラスト、第一交通産業",
    "事業期間（年度）": "H18-31",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1001",
    "地域No": "50",
    "地域名": "福岡香椎・臨海東地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "CO2ゼロ街区事業",
    "内閣府No": "6",
    "内閣府プロジェクト名": "CO2ゼロ街区事業",
    "内閣府プロジェクト名２": "照葉スマートタウン",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "積水ハウス、九州住宅建設産業協会、スウェーデンハウス、住友林業",
    "事業期間（年度）": "H23-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1002",
    "地域No": "50",
    "地域名": "福岡香椎・臨海東地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "環境配慮街区事業",
    "内閣府No": "7",
    "内閣府プロジェクト名": "環境配慮街区事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "積水ハウス、西日本鉄道、福岡商事、西部ガス興商",
    "事業期間（年度）": "H29-R5",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1003",
    "地域No": "50",
    "地域名": "福岡香椎・臨海東地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "香椎照葉６，７丁目地区事業",
    "内閣府No": "8",
    "内閣府プロジェクト名": "香椎照葉６，７丁目地区事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "積水ハウス、西日本鉄道、福岡商事、西部ガス興商",
    "事業期間（年度）": "H30-R7",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1004",
    "地域No": "50",
    "地域名": "福岡香椎・臨海東地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "香椎浜開発計画",
    "内閣府No": "9",
    "内閣府プロジェクト名": "香椎浜開発計画",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "福岡地所",
    "事業期間（年度）": "H14-15",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1005",
    "地域No": "50",
    "地域名": "福岡香椎・臨海東地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "香椎アイランド線",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "香椎アイランド線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H11-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1006",
    "地域No": "50",
    "地域名": "福岡香椎・臨海東地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "アイランド東1号線外6路線",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "アイランド東1号線外6路線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H15-R5",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1007",
    "地域No": "50",
    "地域名": "福岡香椎・臨海東地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "福岡都市計画公園5.5.10号ｱｲﾗﾝﾄﾞｼﾃｨ中央公園",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "福岡都市計画公園5.5.10号ｱｲﾗﾝﾄﾞｼﾃｨ中央公園",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H14-19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1008",
    "地域No": "50",
    "地域名": "福岡香椎・臨海東地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "香椎副都心公共施設",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "香椎副都心公共施設",
    "内閣府プロジェクト名２": "なみきスクエア",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H26-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1009",
    "地域No": "50",
    "地域名": "福岡香椎・臨海東地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "福岡市総合体育館整備運営事業",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "福岡市総合体育館整備運営事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H28-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1010",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "新天神地下街建設事業",
    "内閣府No": "1",
    "内閣府プロジェクト名": "新天神地下街建設事業",
    "内閣府プロジェクト名２": "新天神地下街",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "福岡地下街開発",
    "事業期間（年度）": "H11-16",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1011",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "渡辺通駅北土地区画整理事業",
    "内閣府No": "2",
    "内閣府プロジェクト名": "渡辺通駅北土地区画整理事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "UR",
    "事業期間（年度）": "H18-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1012",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "友愛病院計画",
    "内閣府No": "2-1",
    "内閣府プロジェクト名": "友愛病院計画",
    "内閣府プロジェクト名２": "桜十字福岡病院",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "桜十字メディカルグループ",
    "事業期間（年度）": "H23-25",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1013",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "天神１２２地区",
    "内閣府No": "3",
    "内閣府プロジェクト名": "天神１２２地区",
    "内閣府プロジェクト名２": "天神１２２ビル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "共同企業体",
    "事業期間（年度）": "H19-20",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1014",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ＮＨＫ放送会館跡地開発",
    "内閣府No": "4",
    "内閣府プロジェクト名": "ＮＨＫ放送会館跡地開発",
    "内閣府プロジェクト名２": "岩田屋新館",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "福岡新都心開発",
    "事業期間（年度）": "H13-15",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1015",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "渡辺通２丁目地区（電気ビル北館）",
    "内閣府No": "5-1",
    "内閣府プロジェクト名": "渡辺通２丁目地区（電気ビル北館）",
    "内閣府プロジェクト名２": "電気ビル北館",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "電気ビル",
    "事業期間（年度）": "H18-19",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1016",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "渡辺通２丁目地区（電気ビル南館）",
    "内閣府No": "5-2",
    "内閣府プロジェクト名": "渡辺通２丁目地区（電気ビル南館）",
    "内閣府プロジェクト名２": "電気ビル共創館",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "電気ビル",
    "事業期間（年度）": "H21-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1017",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ＺＡＲＡ跡地",
    "内閣府No": "6",
    "内閣府プロジェクト名": "ＺＡＲＡ跡地",
    "内閣府プロジェクト名２": "天神ＶＩＯＲＯ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "東京建物",
    "事業期間（年度）": "H17-18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1018",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）福岡天神プロジェクト",
    "内閣府No": "7",
    "内閣府プロジェクト名": "（仮称）福岡天神プロジェクト",
    "内閣府プロジェクト名２": "アーバンネット天神ビル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "NTT都市開発",
    "事業期間（年度）": "H21-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1019",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "新舞鶴小",
    "内閣府No": "8",
    "内閣府プロジェクト名": "新舞鶴小",
    "内閣府プロジェクト名２": "福岡市立舞鶴小学校",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "福岡市",
    "事業期間（年度）": "H23-25",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1020",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ウォータフロント再整備事業",
    "内閣府No": "9",
    "内閣府プロジェクト名": "ウォータフロント再整備事業",
    "内閣府プロジェクト名２": "マリンメッセ福岡B館",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "福岡市、民間事業者",
    "事業期間（年度）": "？-未定",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1021",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ＪＲ博多駅ビル整備事業",
    "内閣府No": "10",
    "内閣府プロジェクト名": "ＪＲ博多駅ビル整備事業",
    "内閣府プロジェクト名２": "ＪＲ博多シティ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "JR九州",
    "事業期間（年度）": "H17-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1022",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "博多駅南西街区（KITTE博多）",
    "内閣府No": "11-1",
    "内閣府プロジェクト名": "博多駅南西街区（KITTE博多）",
    "内閣府プロジェクト名２": "KITTE博多",
    "特定地域整備計画No": "③",
    "特定地域整備計画名": "ＫＩＴＴＥ博多",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "日本郵便",
    "事業期間（年度）": "H25-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1023",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "博多駅南西街区（JRJP博多ビル）",
    "内閣府No": "11-2",
    "内閣府プロジェクト名": "博多駅南西街区（JRJP博多ビル）",
    "内閣府プロジェクト名２": "JRJP博多ビル",
    "特定地域整備計画No": "②",
    "特定地域整備計画名": "JRJP 博多ビル建設事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "日本郵便、JR九州",
    "事業期間（年度）": "H26-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1024",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "祇園町開発",
    "内閣府No": "12",
    "内閣府プロジェクト名": "祇園町開発",
    "内閣府プロジェクト名２": "キャナルシティ博多イーストビル",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "福岡地所ほか",
    "事業期間（年度）": "H22-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1025",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ロイヤルパークホテル　ザ　福岡",
    "内閣府No": "13",
    "内閣府プロジェクト名": "ロイヤルパークホテル　ザ　福岡",
    "内閣府プロジェクト名２": "ロイヤルパークホテル　ザ　福岡",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "深見製鋼所",
    "事業期間（年度）": "H21-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1026",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "今泉１丁目地区（中央児童会館等建替え施設）",
    "内閣府No": "14",
    "内閣府プロジェクト名": "今泉１丁目地区（中央児童会館等建替え施設）",
    "内閣府プロジェクト名２": "西鉄天神ＣＬＡＳＳ",
    "特定地域整備計画No": "①",
    "特定地域整備計画名": "今泉１丁目地区(中央児童会館等建替え施設)",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "SPC",
    "事業期間（年度）": "H26-27",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1027",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "天神ビジネスセンター",
    "内閣府No": "15",
    "内閣府プロジェクト名": "天神ビジネスセンター",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "④",
    "特定地域整備計画名": "（仮称）天神ビジネスセンター",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "福岡地所",
    "事業期間（年度）": "H29-R3",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1028",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ソラリアプラザ改造工事",
    "内閣府No": "16",
    "内閣府プロジェクト名": "ソラリアプラザ改造工事",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "⑤",
    "特定地域整備計画名": "ソラリアプラザ改造工事",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "西日本鉄道",
    "事業期間（年度）": "H25-27",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1029",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "福岡パルコ新館",
    "内閣府No": "17",
    "内閣府プロジェクト名": "福岡パルコ新館",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "パルコ",
    "事業期間（年度）": "H25-26",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1030",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "福ビル街区建替プロジェクト",
    "内閣府No": "18",
    "内閣府プロジェクト名": "福ビル街区建替プロジェクト",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "西日本鉄道",
    "事業期間（年度）": "R3-6",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "●",
    "税制支援（都市再生）": "●",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1031",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "旧大名小学校跡地活用事業",
    "内閣府No": "19",
    "内閣府プロジェクト名": "旧大名小学校跡地活用事業",
    "内閣府プロジェクト名２": "福岡大名ガーデンシティ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "SPC",
    "事業期間（年度）": "R1-4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1032",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "博多区新庁舎整備等事業",
    "内閣府No": "20",
    "内閣府プロジェクト名": "博多区新庁舎整備等事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "福岡市",
    "事業期間（年度）": "R1-4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1033",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "博多イーストテラス",
    "内閣府No": "21",
    "内閣府プロジェクト名": "博多イーストテラス",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ＮＴＴ都市開発、大成建設",
    "事業期間（年度）": "R2-4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1034",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "福岡東総合庁舎跡地有効活用事業",
    "内閣府No": "22",
    "内閣府プロジェクト名": "福岡東総合庁舎跡地有効活用事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "JR九州、福岡地所、麻生",
    "事業期間（年度）": "R3-5",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1035",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "ヒューリック福岡ビル",
    "内閣府No": "23",
    "内閣府プロジェクト名": "ヒューリック福岡ビル",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ヒューリック",
    "事業期間（年度）": "R4-6",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1036",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "天神1丁目北１４番街区ビル",
    "内閣府No": "24",
    "内閣府プロジェクト名": "天神1丁目北１４番街区ビル",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "日本生命、積水ハウス",
    "事業期間（年度）": "R4-6",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1037",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "都市計画道路天神地下道9・10・11・12号線（新天神地下街）",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "都市計画道路天神地下道9・10・11・12号線（新天神地下街）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H11-18",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1038",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "都市計画道路渡辺通春吉線（渡辺通駅北土地区画整理事業）",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "都市計画道路渡辺通春吉線（渡辺通駅北土地区画整理事業）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H18-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1039",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "その他区画道路（渡辺通駅北土地区画整理事業）",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "その他区画道路（渡辺通駅北土地区画整理事業）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H18-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1040",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "都市高速鉄道3号線（市営地下鉄七隈線）",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "都市高速鉄道3号線（市営地下鉄七隈線）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○ア",
    "特定地域整備計画名": "地下鉄七隈線延伸事業（天神南～博多）",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "福岡市",
    "事業期間（年度）": "H8-16",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1041",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "警固公園再整備事業",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "警固公園再整備事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○ウ",
    "特定地域整備計画名": "警固公園再整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "福岡市",
    "事業期間（年度）": "H23-24",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1042",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "春吉二丁目地区住宅市街地総合整備事業",
    "内閣府No": "カ",
    "内閣府プロジェクト名": "春吉二丁目地区住宅市街地総合整備事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H21-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1043",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "天神周辺浸水対策事業",
    "内閣府No": "キ",
    "内閣府プロジェクト名": "天神周辺浸水対策事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○オ",
    "特定地域整備計画名": "天神周辺浸水対策事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "福岡市",
    "事業期間（年度）": "H21-R8",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1044",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "中央ふ頭の機能強化",
    "内閣府No": "ク",
    "内閣府プロジェクト名": "中央ふ頭の機能強化",
    "内閣府プロジェクト名２": "中央ふ頭クルーズセンター",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H21-28",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1045",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "福岡都市計画道路3・3・41号（博多駅博多口駅前広場）",
    "内閣府No": "ケ",
    "内閣府プロジェクト名": "福岡都市計画道路3・3・41号（博多駅博多口駅前広場）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H21-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1046",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "博多口地下車路",
    "内閣府No": "コ",
    "内閣府プロジェクト名": "博多口地下車路",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H21-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1047",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "博多口地下通路",
    "内閣府No": "サ",
    "内閣府プロジェクト名": "博多口地下通路",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H21-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1048",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "博多口上空デッキ",
    "内閣府No": "シ",
    "内閣府プロジェクト名": "博多口上空デッキ",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H22-24",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1049",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "新博多駅地下街",
    "内閣府No": "ス",
    "内閣府プロジェクト名": "新博多駅地下街",
    "内閣府プロジェクト名２": "ＪＲ博多シティ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H18-22",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1050",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "福岡都市計画道路３・４・４２博多駅五十川線（筑紫口駅前広場）",
    "内閣府No": "セ",
    "内閣府プロジェクト名": "福岡都市計画道路３・４・４２博多駅五十川線（筑紫口駅前広場）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R2-4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1051",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "明治公園・環境共生型駐輪場整備事業",
    "内閣府No": "ソ",
    "内閣府プロジェクト名": "明治公園・環境共生型駐輪場整備事業",
    "内閣府プロジェクト名２": "明治公園自転車駐車場",
    "特定地域整備計画No": "○カ",
    "特定地域整備計画名": "明治公園自転車駐車場",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "福岡市",
    "事業期間（年度）": "H25-26",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1052",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "地下鉄七隈線延伸事業（天神南～博多）",
    "内閣府No": "タ",
    "内閣府プロジェクト名": "地下鉄七隈線延伸事業（天神南～博多）",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H25-R4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1053",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "博多駅周辺浸水対策事業",
    "内閣府No": "チ",
    "内閣府プロジェクト名": "博多駅周辺浸水対策事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○エ",
    "特定地域整備計画名": "博多駅周辺浸水対策事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "福岡市",
    "事業期間（年度）": "H16-24",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1054",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "拠点間回遊案内強化事業",
    "内閣府No": "ツ",
    "内閣府プロジェクト名": "拠点間回遊案内強化事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○イ",
    "特定地域整備計画名": "拠点間回遊案内強化事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "福岡市",
    "事業期間（年度）": "H24-27",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1055",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "天神明治通り地区地下通路",
    "内閣府No": "テ",
    "内閣府プロジェクト名": "天神明治通り地区地下通路",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○キ",
    "特定地域整備計画名": "天神明治通り地区地下通路",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "民間事業者",
    "事業期間（年度）": "H28-R4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1056",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "天神３号線外地下通路・駐輪場整備事業",
    "内閣府No": "ト",
    "内閣府プロジェクト名": "天神３号線外地下通路・駐輪場整備事業",
    "内閣府プロジェクト名２": "ふれあい通り地下通路・駐輪場",
    "特定地域整備計画No": "○ク",
    "特定地域整備計画名": "天神３号線外地下通路・駐輪場整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "福岡市",
    "事業期間（年度）": "H28-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1057",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "都市計画道路築港石城町線",
    "内閣府No": "ナ",
    "内閣府プロジェクト名": "都市計画道路築港石城町線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H28-R3",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1058",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "はかた駅前通り",
    "内閣府No": "ニ",
    "内閣府プロジェクト名": "はかた駅前通り",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "○ケ",
    "特定地域整備計画名": "はかた駅前通り再整備事業",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "福岡市",
    "事業期間（年度）": "H28-R4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1059",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "（仮称）博多駅周辺地区歩行者連絡橋",
    "内閣府No": "ヌ",
    "内閣府プロジェクト名": "（仮称）博多駅周辺地区歩行者連絡橋",
    "内閣府プロジェクト名２": "博多駅歩行者デッキ",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H31-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1060",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "出来町公園",
    "内閣府No": "ネ",
    "内閣府プロジェクト名": "出来町公園",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H27-29",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1061",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "藤田公園",
    "内閣府No": "ノ",
    "内閣府プロジェクト名": "藤田公園",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R1-6",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "●",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1062",
    "地域No": "51",
    "地域名": "【特定】福岡都心地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "都市計画道路　天神通線",
    "内閣府No": "ハ",
    "内閣府プロジェクト名": "都市計画道路　天神通線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R2-未定",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "●",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1063",
    "地域No": "52",
    "地域名": "長崎中央地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "長崎スタジアムシティプロジェクト",
    "内閣府No": "1",
    "内閣府プロジェクト名": "長崎スタジアムシティプロジェクト",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "ジャパネットホールディングス",
    "事業期間（年度）": "R4-6",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "●",
    "税制支援（都市再生）": "●",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1064",
    "地域No": "52",
    "地域名": "長崎中央地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "浜町地区市街地再開発事業",
    "内閣府No": "2",
    "内閣府プロジェクト名": "浜町地区市街地再開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合（予定）",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1065",
    "地域No": "52",
    "地域名": "長崎中央地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "新大工町地区市街地再開発事業",
    "内閣府No": "3",
    "内閣府プロジェクト名": "新大工町地区市街地再開発事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "再開発組合",
    "事業期間（年度）": "R1-4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1066",
    "地域No": "52",
    "地域名": "長崎中央地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）新長崎駅ビル開発プロジェクト",
    "内閣府No": "4",
    "内閣府プロジェクト名": "（仮称）新長崎駅ビル開発プロジェクト",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "JR九州",
    "事業期間（年度）": "R3-5",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "●",
    "税制支援（都市再生）": "●",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1067",
    "地域No": "52",
    "地域名": "長崎中央地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "（仮称）長崎市交流拠点施設整備・運営事業",
    "内閣府No": "5",
    "内閣府プロジェクト名": "（仮称）長崎市交流拠点施設整備・運営事業",
    "内閣府プロジェクト名２": "出島メッセ長崎",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "長崎市",
    "事業期間（年度）": "R1-3",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1068",
    "地域No": "52",
    "地域名": "長崎中央地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "長崎市役所跡地活用",
    "内閣府No": "6",
    "内閣府プロジェクト名": "長崎市役所跡地活用",
    "内閣府プロジェクト名２": "新たな文化施設",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "長崎市",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "●",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1069",
    "地域No": "52",
    "地域名": "長崎中央地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "中部下水処理場跡地活用",
    "内閣府No": "7",
    "内閣府プロジェクト名": "中部下水処理場跡地活用",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "未定",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1070",
    "地域No": "52",
    "地域名": "長崎中央地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "新庁舎建設事業",
    "内閣府No": "8",
    "内閣府プロジェクト名": "新庁舎建設事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "長崎市",
    "事業期間（年度）": "R1-4",
    "状況": "完了？",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1071",
    "地域No": "52",
    "地域名": "長崎中央地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "長崎県庁舎跡地・県警本部跡地活用",
    "内閣府No": "9",
    "内閣府プロジェクト名": "長崎県庁舎跡地・県警本部跡地活用",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "長崎県",
    "事業期間（年度）": "未定",
    "状況": "未着手",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1072",
    "地域No": "52",
    "地域名": "長崎中央地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "松が枝国際観光船埠頭の延伸（２バース化）",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "松が枝国際観光船埠頭の延伸（２バース化）",
    "内閣府プロジェクト名２": "松が枝地区整備構想",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R2-7",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1073",
    "地域No": "52",
    "地域名": "長崎中央地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "長崎駅周辺土地区画整理事業",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "長崎駅周辺土地区画整理事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H24-6",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "●（L街）",
    "都市・地域交通戦略推進事業": "",
    "その他支援": "区画内のベンチやモニュメントを都市構造で支援"
  },
  {
    "key": "1074",
    "地域No": "52",
    "地域名": "長崎中央地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "桜町近隣公園整備事業",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "桜町近隣公園整備事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R2-7",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "●",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1075",
    "地域No": "52",
    "地域名": "長崎中央地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "魚の町公園整備事業",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "魚の町公園整備事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "R2-3",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1076",
    "地域No": "52",
    "地域名": "長崎中央地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "ＪＲ長崎本線連続立体交差事業",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "ＪＲ長崎本線連続立体交差事業",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H27-R5",
    "状況": "事業中",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "●",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1077",
    "地域No": "53",
    "地域名": "那覇旭橋駅東地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "モノレール旭橋駅周辺地区第一種市街地再開発事業　南工区",
    "内閣府No": "1",
    "内閣府プロジェクト名": "モノレール旭橋駅周辺地区第一種市街地再開発事業　南工区",
    "内閣府プロジェクト名２": "カフーナ旭橋",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "旭橋都市再開発",
    "事業期間（年度）": "H19-23",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1078",
    "地域No": "53",
    "地域名": "那覇旭橋駅東地域",
    "種類": "都市開発事業",
    "整理No": "",
    "プロジェクト名": "モノレール旭橋駅周辺地区第一種市街地再開発事業　北工区",
    "内閣府No": "2",
    "内閣府プロジェクト名": "モノレール旭橋駅周辺地区第一種市街地再開発事業　北工区",
    "内閣府プロジェクト名２": "カフーナ旭橋A街区",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "旭橋都市再開発",
    "事業期間（年度）": "H27-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1079",
    "地域No": "53",
    "地域名": "那覇旭橋駅東地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "バスターミナル",
    "内閣府No": "ア",
    "内閣府プロジェクト名": "バスターミナル",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H27-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1080",
    "地域No": "53",
    "地域名": "那覇旭橋駅東地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "駅前広場",
    "内閣府No": "イ",
    "内閣府プロジェクト名": "駅前広場",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H27-30",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1081",
    "地域No": "53",
    "地域名": "那覇旭橋駅東地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "ペデストリアンデッキ",
    "内閣府No": "ウ",
    "内閣府プロジェクト名": "ペデストリアンデッキ",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H19-R2",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1082",
    "地域No": "53",
    "地域名": "那覇旭橋駅東地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "歩行者専用通路",
    "内閣府No": "エ",
    "内閣府プロジェクト名": "歩行者専用通路",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H23-24",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  },
  {
    "key": "1083",
    "地域No": "53",
    "地域名": "那覇旭橋駅東地域",
    "種類": "公共施設整備",
    "整理No": "",
    "プロジェクト名": "市道旭町６号線",
    "内閣府No": "オ",
    "内閣府プロジェクト名": "市道旭町６号線",
    "内閣府プロジェクト名２": "",
    "特定地域整備計画No": "",
    "特定地域整備計画名": "",
    "補助金・交付金等": "",
    "その他": "",
    "実施主体": "",
    "事業期間（年度）": "H19-21",
    "状況": "完了",
    "都市再生特別地区": "",
    "民間都市再生事業計画認定": "",
    "税制支援（都市再生）": "",
    "税制支援（ウォーカブル）": "",
    "民都金融支援": "",
    "国際競争拠点都市整備事業": "",
    "区画整理再開発": "",
    "都市構造都市再生整備計画事業": "",
    "まちなかウォーカブル推進事業": "",
    "街路連立": "",
    "都市・地域交通戦略推進事業": "",
    "その他支援": ""
  }
];